import React, { Component, useState } from 'react'

import Ports from './PortData'
import ItemTypes from '../Assembly/ItemTypes'
import ImageSizes from '../Assembly/ImageSizes'
import PortTypes from '../Assembly/PortTypes'

import AllowedPortTypes from './AllowedPortTypes'

import DraggingInfo from '../Assembly/DraggingInfo'
import { PORTDATA } from '../Humanoid/defaultData'
import { checkIsPwmOutput } from '../../utils/utils'
import Sizes from '../../helpers/Sizes'
import './Connections.css'
import {
    HardwareWireConfigs,
    getAllowedTargets,
    getHardwareWireConfig,
    computeAutoDropPinConnections,
    getWholeSocketParent,
} from '../Assembly/PinMaps'
import { isPortGroupOccupied, getGroupBlob, getPortGroup } from './PortGroups'

// var Device=JSON.stringify(sessionStorage.getItem("connectedDevice"));
var Device = sessionStorage.getItem('connectedDevice') || 'Ace'
if (
    ![
        'Ace',
        'Humanoid',
        'Hexapod',
        'Roboki',
        'Klaw',
        'Atr',
        'Toki',
        'Poki',
        'Moki',
    ].includes(Device)
) {
    Device = 'Ace'
}

let internalAccessoriesData = JSON.parse(
    sessionStorage.getItem('concept')
).internalaccessories

const computeModularWirePath = ({
    startX,
    startY,
    cx1,
    cy1,
    endX,
    endY,
    offsetWire = [0, 0],
    flatLength,
    verticalLength = 0,
}) => {
    const mStartX = startX + offsetWire[0]
    const mStartY = startY + offsetWire[1]
    const mCx1 = cx1 + offsetWire[0]
    const mCy1 = cy1 + offsetWire[1]

    const sCx2 = endX - flatLength
    const sCy2 = endY + verticalLength

    return {
        d: `M ${mStartX},${mStartY} C ${mCx1},${mCy1} ${sCx2},${sCy2} ${endX},${endY}`,
        targetY: endY,
    }
}

class Curve extends Component {
    // shouldComponentUpdate(nextProps, nextState, prev) {
    //     return JSON.stringify(nextProps.bibox) !== JSON.stringify(this.props.bibox) || JSON.stringify(nextProps.component) !== JSON.stringify(this.props.component) || JSON.stringify(nextProps.components) !== JSON.stringify(this.props.components) || JSON.stringify(nextProps.PortConnections) !== JSON.stringify(this.props.PortConnections) || JSON.stringify(nextProps.extraComponent) !== JSON.stringify(this.props.extraComponent) || nextProps.isDragging !== this.props.isDragging;
    // }
    defaultCurve = ({ bibox, left, top, connectedTo }) => {
        let LeftF = bibox.left
        let TopF = bibox.top
        let cx1 = left + ImageSizes[ItemTypes.COMPONENT][0] / 2
        let cy1 = top + 2 * ImageSizes[ItemTypes.COMPONENT][1]
        let cx2 = LeftF + Ports(connectedTo)[0]
        let cy2 = TopF + Ports(connectedTo)[1]
        cy2 += 75

        const startX = left - 10 + ImageSizes[ItemTypes.COMPONENT][0] / 2
        const startY = top + 85
        const endX = LeftF + Ports(connectedTo)[0]
        const endY = TopF + Ports(connectedTo)[1]

        const activeConfig = getHardwareWireConfig(
            this.props.componentName,
            sessionStorage.getItem('connectedDevice')
        )

        // Only render the multi-pin wire bundle for well-formed configs on Toki.
        // The _FULL multi-pin port data + 3-wire feature are Toki-only; on Poki/Moki
        // these config types keep the single-wire path below (matches Assembly).
        if (
            sessionStorage.getItem('connectedDevice') === 'Toki' &&
            activeConfig &&
            activeConfig.pins
        ) {
            return (
                <g>
                    {Object.entries(activeConfig.pins).map(
                        ([pinKey, pinMeta]) => {
                            // 1. Use the actual live port the component is connected to!
                            // Check for the '_FULL' object first (where detailed pin data usually lives),
                            // then fallback to the standard port name.
                            const activePort = connectedTo
                            const targetPortData =
                                Ports(activePort + '_FULL') || Ports(activePort)

                            const targetPins = targetPortData?.pins || {}

                            // 2. Resolve the correct pin key dynamically. If allowedTargets maps it, use that.
                            let lookupKey = pinMeta.targetPinKey || pinKey
                            if (pinMeta.allowedTargets) {
                                const match = pinMeta.allowedTargets.find(
                                    (t) =>
                                        t.portId === activePort + '_FULL' ||
                                        t.portId === activePort
                                )
                                if (match) lookupKey = match.pinKey
                            }

                            const coords = targetPins[lookupKey]
                            const finalX = coords ? LeftF + coords[0] : endX
                            const finalY = coords ? TopF + coords[1] : endY

                            // 3. Extract flatLength dynamically from PortData.js
                            const portFlatLength =
                                targetPortData?.flatLength || 0
                            const portVerticalLength =
                                targetPortData?.verticalLength || 0

                            const pathString = computeModularWirePath({
                                startX,
                                startY,
                                cx1,
                                cy1,
                                endX: finalX,
                                endY: finalY,
                                offsetWire: pinMeta.offsetWire,
                                flatLength: portFlatLength, // <--- Using the dynamic value here
                                verticalLength: portVerticalLength,
                            }).d

                            return (
                                <path
                                    key={`drop-wire-${pinKey}`}
                                    stroke={pinMeta.stroke}
                                    strokeWidth="3px"
                                    fill="none"
                                    d={pathString}
                                />
                            )
                        }
                    )}
                </g>
            )
        }

        return (
            <path
                d={`M ${startX},${startY} C ${cx1},${cy1} ${cx2},${cy2} ${endX},${endY}`}
            />
        )
    }

    render() {
        Device = sessionStorage.getItem('connectedDevice')
        let deviceVersion = sessionStorage.getItem('deviceVersion') || '0.0.0'
        const { bibox, component, components, PortConnections } = this.props
        const { connectedTo, left, top } = component

        // console.log('Rendering Curve for', component.componentName, 'connected to', connectedTo)

        // On Toki, multi-pin components (RGB, servo_motor_360, …) are rendered solely
        // by the magnifier engine from each instance's per-pin `pinConnections`, which
        // is the single source of truth. Skip the legacy per-device Curve drawing so
        // wires aren't drawn twice.
        if (
            ['Toki', 'Poki'].includes(Device) &&
            getHardwareWireConfig(this.props.componentName, Device)
        ) {
            return null
        }
        const sessionStoragePortConnections = JSON.parse(
            sessionStorage.getItem('assemblyTwo')
        ).PortConnections
        var Left, Top
        var LeftF, TopF
        var LeftO, TopO
        var LeftB, TopB
        var LeftC, TopC
        var LeftCL, TopCL
        var LeftBL, TopBL
        var LeftG, TopG
        var cx2, cy2, cx1, cy1
        var LeftS, TopS
        var LeftSS, TopSS

        const isDeviceVersion12 =
            (['1', '2', '3'].includes(deviceVersion[0]) &&
                ['Ace', 'Humanoid', 'Hexapod'].includes(Device)) ||
            ['Roboki', 'Klaw', 'Atr', 'Toki', 'Poki', 'Moki'].includes(Device)

        if (
            [
                'Ace',
                'Humanoid',
                'Hexapod',
                'Klaw',
                'Roboki',
                'Atr',
                'Toki',
                'Poki',
                'Moki',
            ].includes(Device)
        ) {
            // GearedMotor A1 C1  && B1 D1
            let A1connectedGeared_motor =
                sessionStoragePortConnections.A1 !== null
                    ? [
                          'geared_motor',
                          'mini_geared_motor',
                          'dc_motor',
                          'dynamex_motor',
                      ].includes(sessionStoragePortConnections.A1.type)
                        ? true
                        : false
                    : false

            let C1connectedGeared_motor =
                sessionStoragePortConnections.C1 !== null
                    ? [
                          'geared_motor',
                          'mini_geared_motor',
                          'dc_motor',
                          'dynamex_motor',
                      ].includes(sessionStoragePortConnections.C1.type)
                        ? true
                        : false
                    : false

            let B1connectedGeared_motor =
                sessionStoragePortConnections.B1 !== null
                    ? [
                          'geared_motor',
                          'mini_geared_motor',
                          'dc_motor',
                          'dynamex_motor',
                      ].includes(sessionStoragePortConnections.B1.type)
                        ? true
                        : false
                    : false

            let D1connectedGeared_motor =
                sessionStoragePortConnections.D1 !== null
                    ? [
                          'geared_motor',
                          'mini_geared_motor',
                          'dc_motor',
                          'dynamex_motor',
                      ].includes(sessionStoragePortConnections.D1.type)
                        ? true
                        : false
                    : false

            // SERVO MOTORS [A1,A2,C1,C2] [B1,B2,C1,C2]

            let A1connectedServoMotor =
                JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.A1 !== null
                    ? JSON.parse(sessionStorage.getItem('assemblyTwo'))
                          .PortConnections.A1.type == 'servo_motor'
                        ? true
                        : false
                    : false

            let A2connectedServoMotor =
                JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.A2 !== null
                    ? JSON.parse(sessionStorage.getItem('assemblyTwo'))
                          .PortConnections.A2.type == 'servo_motor'
                        ? true
                        : false
                    : false

            let C1connectedServoMotor =
                JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.C1 !== null
                    ? JSON.parse(sessionStorage.getItem('assemblyTwo'))
                          .PortConnections.C1.type == 'servo_motor'
                        ? true
                        : false
                    : false

            let C2connectedServoMotor =
                JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.C2 !== null
                    ? JSON.parse(sessionStorage.getItem('assemblyTwo'))
                          .PortConnections.C2.type == 'servo_motor'
                        ? true
                        : false
                    : false

            let D1connectedServoMotor =
                JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.D1 !== null
                    ? JSON.parse(sessionStorage.getItem('assemblyTwo'))
                          .PortConnections.D1.type == 'servo_motor'
                        ? true
                        : false
                    : false

            let D2connectedServoMotor =
                JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.D2 !== null
                    ? JSON.parse(sessionStorage.getItem('assemblyTwo'))
                          .PortConnections.D2.type == 'servo_motor'
                        ? true
                        : false
                    : false

            let B1connectedServoMotor =
                JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.B1 !== null
                    ? JSON.parse(sessionStorage.getItem('assemblyTwo'))
                          .PortConnections.B1.type == 'servo_motor'
                        ? true
                        : false
                    : false

            let B2connectedServoMotor =
                JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.B2 !== null
                    ? JSON.parse(sessionStorage.getItem('assemblyTwo'))
                          .PortConnections.B2.type == 'servo_motor'
                        ? true
                        : false
                    : false
            //*************************************************** */

            if (
                (connectedTo == 'A1' || connectedTo == 'A2') &&
                !['Toki', 'Poki', 'Moki'].includes(
                    sessionStorage.getItem('connectedDevice')
                )
            ) {
                Object.keys(components).map((dual_splitter) => {
                    if (dual_splitter == 'dual_splitter') {
                        components[dual_splitter].map((component, index) => {
                            if (
                                ![
                                    'geared_motor',
                                    'mini_geared_motor',
                                    'dc_motor',
                                    'dynamex_motor',
                                ].includes(this.props.componentName)
                            ) {
                                if (component.connectedTo == 'A') {
                                    LeftF = component.left
                                    TopF = component.top
                                }
                                if (
                                    component.connectedTo == 'A' &&
                                    (this.props.shield || this.props.armShield)
                                ) {
                                    if (connectedTo == 'A1') {
                                        LeftF = component.left - 87
                                        TopF = component.top - 252
                                    }
                                    if (connectedTo == 'A2') {
                                        LeftF = component.left - 32
                                        TopF = component.top - 285
                                    }
                                }
                            } else {
                                if (component.connectedTo == 'A') {
                                    LeftF = component.left + 28
                                    TopF = isDeviceVersion12
                                        ? component.top + 30
                                        : component.top + 6
                                }
                                if (
                                    component.connectedTo == 'A' &&
                                    (this.props.shield || this.props.armShield)
                                ) {
                                    LeftF = component.left - 60
                                    TopF = isDeviceVersion12
                                        ? component.top - 218
                                        : component.top - 248
                                }
                            }
                        })
                        if (connectedTo == 'A1') {
                            cx1 = left + ImageSizes[ItemTypes.COMPONENT][0] / 2
                            cy1 = top + 2 * ImageSizes[ItemTypes.COMPONENT][1]
                            cx2 = LeftF + Ports(connectedTo)[0]
                            cy2 = TopF + Ports(connectedTo)[1]
                            cy2 -= 50
                        }
                        if (connectedTo == 'A2') {
                            cx1 = left + ImageSizes[ItemTypes.COMPONENT][0] / 2
                            cy1 = top + 2 * ImageSizes[ItemTypes.COMPONENT][1]
                            cx2 = LeftF + Ports(connectedTo)[0]
                            cy2 = TopF + Ports(connectedTo)[1]
                            cy2 -= 50
                        }
                    }
                    if (dual_splitter == 'play_shield') {
                        components[dual_splitter].map((component, index) => {
                            if (
                                ![
                                    'geared_motor',
                                    'mini_geared_motor',
                                    'dc_motor',
                                    'dynamex_motor',
                                    'servo_motor',
                                    'servo_motor_270',
                                    'servo_motor_360',
                                ].includes(this.props.componentName)
                            ) {
                                if (
                                    PortConnections.A == null &&
                                    sessionStorage.getItem('dragingItem') !=
                                        null
                                ) {
                                    if (connectedTo == 'A1') {
                                        LeftF = bibox.left
                                        TopF = bibox.top
                                        cx1 =
                                            left +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2
                                        cy1 =
                                            top +
                                            2 *
                                                ImageSizes[
                                                    ItemTypes.COMPONENT
                                                ][1]
                                        cx2 = LeftF + Ports(connectedTo)[0]
                                        cy2 = TopF + Ports(connectedTo)[1]
                                        cy2 -= 50
                                        cx2 -= 150
                                        cx1 -= 50
                                    }
                                    if (connectedTo == 'A2') {
                                        LeftF = bibox.left
                                        TopF = bibox.top
                                        cx1 =
                                            left +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2
                                        cy1 =
                                            top +
                                            2 *
                                                ImageSizes[
                                                    ItemTypes.COMPONENT
                                                ][1]
                                        cx2 = LeftF + Ports(connectedTo)[0]
                                        cy2 = TopF + Ports(connectedTo)[1]
                                        cy2 -= 50
                                        cx2 -= 150
                                        cx1 -= 50
                                    }
                                }
                            }
                        })
                    }
                    /** */
                    if (dual_splitter == 'pc_motor_driver') {
                        let sdasa = sessionStorage.getItem('dragingItem')

                        components[dual_splitter].map((component, index) => {
                            if (
                                component.connectedTo == 'A' ||
                                component.connectedTo == 'C'
                            ) {
                                // not run initial  it will run after the
                                if (
                                    A1connectedServoMotor == true ||
                                    A2connectedServoMotor == true
                                ) {
                                    if (connectedTo == 'A2') {
                                        LeftF = component.left - 70
                                        TopF = component.top
                                    } else {
                                        LeftF = component.left - 30
                                        TopF = component.top
                                    }
                                } else if (
                                    [
                                        'geared_motor',
                                        'mini_geared_motor',
                                        'dc_motor',
                                        'dynamex_motor',
                                    ].includes(
                                        sessionStorage.getItem('dragingItem')
                                    )
                                ) {
                                    LeftF = component.left - 70
                                    TopF = component.top + 30
                                } else if (
                                    sessionStorage.getItem('dragingItem') ==
                                        'servo_motor' &&
                                    !A1connectedGeared_motor &&
                                    !C1connectedGeared_motor
                                ) {
                                    // this is for when we drag servo_motor  changing the postion at drag time

                                    if (connectedTo == 'A2') {
                                        LeftF = component.left - 70
                                        TopF = component.top
                                    } else {
                                        LeftF = component.left - 30
                                        TopF = component.top
                                    }
                                } else {
                                    LeftF = component.left - 70
                                    TopF = component.top + 30
                                }
                            }
                        })
                        cx1 = left + ImageSizes[ItemTypes.COMPONENT][0] / 2
                        cy1 = top + 2 * ImageSizes[ItemTypes.COMPONENT][1]
                        cx2 = LeftF + Ports(connectedTo)[0]
                        cy2 = TopF + Ports(connectedTo)[1]
                        cx2 +=
                            Ports(connectedTo)[0] -
                            ImageSizes[ItemTypes.COMPONENT][0] / 2
                        cy2 +=
                            Ports(connectedTo)[1] -
                            ImageSizes[ItemTypes.COMPONENT][1] / 2
                    }
                    /** */
                })

                return (
                    <path
                        d={
                            'M ' +
                            (left -
                                10 +
                                ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                            ',' +
                            (top + 85) +
                            ' C ' +
                            cx1 +
                            ',' +
                            cy1 +
                            ' ' +
                            cx2 +
                            ',' +
                            cy2 +
                            ' ' +
                            (LeftF + Ports(connectedTo)[0]) +
                            ',' +
                            (TopF + Ports(connectedTo)[1])
                        }
                    />
                )
            } else if (
                (connectedTo == 'D1' || connectedTo == 'D2') &&
                !['Atr', 'Poki', 'Moki'].includes(
                    sessionStorage.getItem('connectedDevice')
                )
            ) {
                Object.keys(components).map((dual_splitter) => {
                    if (dual_splitter == 'dual_splitter') {
                        components[dual_splitter].map((component, index) => {
                            if (
                                ![
                                    'geared_motor',
                                    'mini_geared_motor',
                                    'dc_motor',
                                    'dynamex_motor',
                                ].includes(this.props.componentName)
                            ) {
                                if (component.connectedTo == 'D') {
                                    LeftF = component.left
                                    TopF = component.top
                                    cx2 = LeftF + Ports(connectedTo)[0]
                                    cy2 = TopF + Ports(connectedTo)[1]
                                    cx2 +=
                                        Ports(connectedTo)[0] -
                                        ImageSizes[ItemTypes.COMPONENT][0] / 2
                                    cy2 +=
                                        Ports(connectedTo)[1] -
                                        ImageSizes[ItemTypes.COMPONENT][1] / 2
                                }
                                if (
                                    component.connectedTo == 'D' &&
                                    (this.props.shield || this.props.armShield)
                                ) {
                                    if (connectedTo == 'D1') {
                                        LeftF = component.left - 230
                                        TopF = component.top - 319
                                        cx2 = LeftF + Ports(connectedTo)[0]
                                        cy2 = TopF + Ports(connectedTo)[1]
                                        cy2 -= 50
                                    }
                                    if (connectedTo == 'D2') {
                                        LeftF = component.left - 139
                                        TopF = component.top - 315
                                        cx2 = LeftF + Ports(connectedTo)[0]
                                        cy2 = TopF + Ports(connectedTo)[1]
                                        cy2 -= 50
                                    }
                                }
                            } else {
                                if (component.connectedTo == 'D') {
                                    LeftF = component.left + 28
                                    TopF = isDeviceVersion12
                                        ? component.top + 30
                                        : component.top + 6
                                }
                                if (
                                    component.connectedTo == 'D' &&
                                    (this.props.shield || this.props.armShield)
                                ) {
                                    LeftF = component.left - 200
                                    TopF = isDeviceVersion12
                                        ? component.top - 284
                                        : component.top - 314
                                }
                                cx2 = LeftF + Ports(connectedTo)[0]
                                cy2 = TopF + Ports(connectedTo)[1]
                                cy2 -= 50
                            }
                        })
                    }

                    if (dual_splitter == 'play_shield') {
                        components[dual_splitter].map((component, index) => {
                            if (
                                [
                                    'servo_motor',
                                    'servo_motor_270',
                                    'servo_motor_360',
                                ].includes(this.props.componentName)
                            ) {
                                if (
                                    (connectedTo == 'D1' ||
                                        connectedTo == 'D2') &&
                                    PortConnections.D == null
                                ) {
                                    if (
                                        sessionStorage.getItem('dragingItem') !=
                                        null
                                    ) {
                                        LeftF = bibox.left
                                        TopF = bibox.top
                                        cx2 = LeftF + Ports(connectedTo)[0]
                                        cy2 = TopF + Ports(connectedTo)[1]
                                        cy2 -= 100
                                        cx2 += 150
                                    }
                                }
                            }
                        })
                    }
                    if (dual_splitter == 'pc_motor_driver') {
                        components[dual_splitter].map((component, index) => {
                            if (
                                component.connectedTo == 'B' ||
                                component.connectedTo == 'D'
                            ) {
                                if (
                                    D1connectedServoMotor == true ||
                                    D2connectedServoMotor == true
                                ) {
                                    if (connectedTo == 'D2') {
                                        LeftF = component.left + 20
                                        TopF = component.top
                                    } else {
                                        LeftF = component.left + 60
                                        TopF = component.top
                                    }
                                } else if (
                                    sessionStorage.getItem('dragingItem') ==
                                        'servo_motor' &&
                                    !B1connectedGeared_motor &&
                                    !D1connectedGeared_motor
                                ) {
                                    // this is for when we drag servo_motor  changing the postion at drag time
                                    if (connectedTo == 'D2') {
                                        LeftF = component.left + 20
                                        TopF = component.top
                                    } else {
                                        LeftF = component.left + 60
                                        TopF = component.top
                                    }
                                } else {
                                    LeftF = component.left + 125
                                    TopF = component.top + 30
                                }
                            }
                        })
                    }
                })

                return (
                    <path
                        d={
                            'M ' +
                            (left -
                                10 +
                                ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                            ',' +
                            (top + 85) +
                            ' C ' +
                            (left +
                                50 +
                                ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                            ',' +
                            (top + 2 * ImageSizes[ItemTypes.COMPONENT][1]) +
                            ' ' +
                            cx2 +
                            ',' +
                            cy2 +
                            ' ' +
                            (LeftF + Ports(connectedTo)[0]) +
                            ',' +
                            (TopF + Ports(connectedTo)[1])
                        }
                    />
                )
            } else if (connectedTo == 'STPM') {
                Object.keys(components).map((dual_splitter) => {
                    if (dual_splitter == 'pc_motor_driver') {
                        components[dual_splitter].map((component, index) => {
                            if (
                                component.connectedTo == 'B' ||
                                component.connectedTo == 'D' ||
                                component.connectedTo == 'A' ||
                                component.connectedTo == 'C'
                            ) {
                                LeftF = component.left
                                TopF = component.top
                            }
                        })
                    }
                })

                cx2 = LeftF + Ports(connectedTo)[0]
                cy2 = TopF + Ports(connectedTo)[1]
                cx2 +=
                    Ports(connectedTo)[0] -
                    ImageSizes[ItemTypes.COMPONENT][0] / 2
                cy2 +=
                    Ports(connectedTo)[1] -
                    ImageSizes[ItemTypes.COMPONENT][1] / 2
                return (
                    <path
                        d={
                            'M ' +
                            (left -
                                10 +
                                ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                            ',' +
                            (top + 85) +
                            ' C ' +
                            (left + ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                            ',' +
                            (top + 2 * ImageSizes[ItemTypes.COMPONENT][1]) +
                            ' ' +
                            cx2 +
                            ',' +
                            cy2 +
                            ' ' +
                            (LeftF + Ports(connectedTo)[0]) +
                            ',' +
                            (TopF + Ports(connectedTo)[1])
                        }
                    />
                )
            } else if (
                (connectedTo == 'C1' || connectedTo == 'C2') &&
                !['Toki', 'Poki', 'Moki'].includes(
                    sessionStorage.getItem('connectedDevice')
                )
            ) {
                Object.keys(components).map((dual_splitter) => {
                    if (dual_splitter == 'dual_splitter') {
                        components[dual_splitter].map((component, index) => {
                            if (
                                ![
                                    'geared_motor',
                                    'mini_geared_motor',
                                    'dc_motor',
                                    'dynamex_motor',
                                ].includes(this.props.componentName)
                            ) {
                                if (component.connectedTo == 'C') {
                                    if (connectedTo == 'C1') {
                                        LeftF = component.left
                                        TopF = component.top
                                        cx1 =
                                            left +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2
                                        cy1 =
                                            top +
                                            2 *
                                                ImageSizes[
                                                    ItemTypes.COMPONENT
                                                ][1]
                                        cx2 = LeftF + Ports(connectedTo)[0]
                                        cy2 = TopF + Ports(connectedTo)[1]
                                        cx2 +=
                                            Ports(connectedTo)[0] -
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2
                                        cy2 +=
                                            Ports(connectedTo)[1] -
                                            ImageSizes[ItemTypes.COMPONENT][1] /
                                                2
                                    }
                                    if (connectedTo == 'C2') {
                                        LeftF = component.left
                                        TopF = component.top
                                        cx1 =
                                            left +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2
                                        cy1 =
                                            top +
                                            2 *
                                                ImageSizes[
                                                    ItemTypes.COMPONENT
                                                ][1]
                                        cx2 = LeftF + Ports(connectedTo)[0]
                                        cy2 = TopF + Ports(connectedTo)[1]
                                        cx2 +=
                                            Ports(connectedTo)[0] -
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2
                                        cy2 +=
                                            Ports(connectedTo)[1] -
                                            ImageSizes[ItemTypes.COMPONENT][1] /
                                                2
                                    }
                                }
                                if (
                                    component.connectedTo == 'C' &&
                                    (this.props.shield || this.props.armShield)
                                ) {
                                    if (connectedTo == 'C1') {
                                        LeftF = component.left - 125
                                        TopF = component.top - 320
                                        cx1 =
                                            left +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2
                                        cy1 =
                                            top +
                                            2 *
                                                ImageSizes[
                                                    ItemTypes.COMPONENT
                                                ][1]
                                        cx2 = LeftF + Ports(connectedTo)[0]
                                        cy2 = TopF + Ports(connectedTo)[1]
                                        cy2 -= 50
                                    }
                                    if (connectedTo == 'C2') {
                                        LeftF = component.left - 105
                                        TopF = component.top - 315
                                        cx1 =
                                            left +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2
                                        cy1 =
                                            top +
                                            2 *
                                                ImageSizes[
                                                    ItemTypes.COMPONENT
                                                ][1]
                                        cx2 = LeftF + Ports(connectedTo)[0]
                                        cy2 = TopF + Ports(connectedTo)[1]
                                        cy2 -= 50
                                    }
                                }
                            } else {
                                if (component.connectedTo == 'C') {
                                    LeftF = component.left + 28
                                    TopF = isDeviceVersion12
                                        ? component.top + 30
                                        : component.top + 6
                                }
                                if (
                                    component.connectedTo == 'C' &&
                                    (this.props.shield || this.props.armShield)
                                ) {
                                    LeftF = component.left - 100
                                    TopF = isDeviceVersion12
                                        ? component.top - 284
                                        : component.top - 315
                                }
                                cx1 =
                                    left +
                                    ImageSizes[ItemTypes.COMPONENT][0] / 2
                                cy1 =
                                    top + 2 * ImageSizes[ItemTypes.COMPONENT][1]
                                cx2 = LeftF + Ports(connectedTo)[0]
                                cy2 = TopF + Ports(connectedTo)[1]
                                cy2 -= 50
                            }
                        })
                    }
                    if (dual_splitter == 'play_shield') {
                        components[dual_splitter].map((component, index) => {
                            if (
                                [
                                    'servo_motor',
                                    'servo_motor_270',
                                    'servo_motor_360',
                                ].includes(this.props.componentName)
                            ) {
                                if (
                                    (connectedTo == 'C1' ||
                                        connectedTo == 'C2') &&
                                    PortConnections.C == null
                                ) {
                                    if (
                                        sessionStorage.getItem('dragingItem') !=
                                        null
                                    ) {
                                        LeftF = bibox.left
                                        TopF = bibox.top
                                        cx1 =
                                            left +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2
                                        cy1 =
                                            top +
                                            2 *
                                                ImageSizes[
                                                    ItemTypes.COMPONENT
                                                ][1]
                                        cx2 = LeftF + Ports(connectedTo)[0]
                                        cy2 = TopF + Ports(connectedTo)[1]
                                        cy2 -= 10
                                        cx2 -= 150
                                        cx1 -= 50
                                    }
                                }
                            }
                        })
                    }

                    if (dual_splitter == 'pc_motor_driver') {
                        components[dual_splitter].map((component, index) => {
                            if (
                                component.connectedTo == 'A' ||
                                component.connectedTo == 'C'
                            ) {
                                if (
                                    C1connectedServoMotor == true ||
                                    C2connectedServoMotor == true
                                ) {
                                    if (connectedTo == 'C2') {
                                        LeftF = component.left + 20
                                        TopF = component.top
                                    } else {
                                        LeftF = component.left + 60
                                        TopF = component.top
                                    }
                                } else if (
                                    sessionStorage.getItem('dragingItem') ==
                                        'servo_motor' &&
                                    !A1connectedGeared_motor &&
                                    !C1connectedGeared_motor
                                ) {
                                    // this is for when we drag servo_motor  changing the postion at drag time
                                    if (connectedTo == 'C2') {
                                        LeftF = component.left + 20
                                        TopF = component.top
                                    } else {
                                        LeftF = component.left + 60
                                        TopF = component.top
                                    }
                                } else {
                                    LeftF = component.left + 125
                                    TopF = component.top + 30
                                }
                            }
                        })
                    }
                })

                return (
                    <path
                        d={
                            'M ' +
                            (left -
                                10 +
                                ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                            ',' +
                            (top + 85) +
                            ' C ' +
                            cx1 +
                            ',' +
                            cy1 +
                            ' ' +
                            cx2 +
                            ',' +
                            cy2 +
                            ' ' +
                            (LeftF + Ports(connectedTo)[0]) +
                            ',' +
                            (TopF + Ports(connectedTo)[1])
                        }
                    />
                )
            } else if (
                (connectedTo == 'B1' || connectedTo == 'B2') &&
                !['Toki', 'Poki', 'Moki'].includes(
                    sessionStorage.getItem('connectedDevice')
                )
            ) {
                Object.keys(components).map((key) => {
                    if (key == 'dual_splitter') {
                        // if(this.props.componentName = "")
                        components[key].map((component, index) => {
                            if (
                                ![
                                    'geared_motor',
                                    'mini_geared_motor',
                                    'dc_motor',
                                    'dynamex_motor',
                                ].includes(this.props.componentName)
                            ) {
                                if (component.connectedTo == 'B') {
                                    LeftF = component.left
                                    TopF = component.top
                                    cx1 =
                                        left +
                                        ImageSizes[ItemTypes.COMPONENT][0] / 2
                                    cy1 =
                                        top +
                                        2 * ImageSizes[ItemTypes.COMPONENT][1]
                                    cx2 = LeftF + Ports(connectedTo)[0]
                                    cy2 = TopF + Ports(connectedTo)[1]
                                    cx2 +=
                                        Ports(connectedTo)[0] -
                                        ImageSizes[ItemTypes.COMPONENT][0] / 2
                                    cy2 +=
                                        Ports(connectedTo)[1] -
                                        ImageSizes[ItemTypes.COMPONENT][1] / 2
                                }
                                if (
                                    component.connectedTo == 'B' &&
                                    (this.props.shield || this.props.armShield)
                                ) {
                                    if (connectedTo == 'B1') {
                                        LeftF = component.left - 268
                                        TopF = component.top - 256
                                        cx1 =
                                            left +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2
                                        cy1 =
                                            top +
                                            2 *
                                                ImageSizes[
                                                    ItemTypes.COMPONENT
                                                ][1]
                                        cx2 = LeftF + Ports(connectedTo)[0]
                                        cy2 = TopF + Ports(connectedTo)[1]
                                        cy2 -= 50
                                    }
                                    if (connectedTo == 'B2') {
                                        LeftF = component.left - 212
                                        TopF = component.top - 287
                                        cx1 =
                                            left +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2
                                        cy1 =
                                            top +
                                            2 *
                                                ImageSizes[
                                                    ItemTypes.COMPONENT
                                                ][1]
                                        cx2 = LeftF + Ports(connectedTo)[0]
                                        cy2 = TopF + Ports(connectedTo)[1]
                                        cy2 -= 50
                                    }
                                }
                            } else {
                                if (component.connectedTo == 'B') {
                                    LeftF = component.left + 28
                                    TopF = isDeviceVersion12
                                        ? component.top + 30
                                        : component.top + 6
                                }
                                if (
                                    component.connectedTo == 'B' &&
                                    (this.props.shield || this.props.armShield)
                                ) {
                                    LeftF = component.left - 240
                                    TopF = isDeviceVersion12
                                        ? component.top - 220
                                        : component.top - 250
                                }
                                cx1 =
                                    left +
                                    ImageSizes[ItemTypes.COMPONENT][0] / 2
                                cy1 =
                                    top + 2 * ImageSizes[ItemTypes.COMPONENT][1]
                                cx2 = LeftF + Ports(connectedTo)[0]
                                cy2 = TopF + Ports(connectedTo)[1]
                                cy2 -= 50
                            }
                        })
                    }
                    if (key == 'play_shield') {
                        components[key].map((component, index) => {
                            if (
                                ![
                                    'geared_motor',
                                    'mini_geared_motor',
                                    'dc_motor',
                                    'dynamex_motor',
                                    'servo_motor',
                                    'servo_motor_270',
                                    'servo_motor_360',
                                ].includes(this.props.componentName)
                            ) {
                                if (PortConnections.B == null) {
                                    if (
                                        connectedTo == 'B1' &&
                                        sessionStorage.getItem('dragingItem') !=
                                            null
                                    ) {
                                        LeftF = bibox.left + 4
                                        TopF = bibox.top + 2
                                        cx1 =
                                            left +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2
                                        cy1 =
                                            top +
                                            2 *
                                                ImageSizes[
                                                    ItemTypes.COMPONENT
                                                ][1]
                                        cx2 = LeftF + Ports(connectedTo)[0]
                                        cy2 = TopF + Ports(connectedTo)[1]
                                        cy2 -= 50
                                        cx2 += 150
                                        cx1 += 50
                                    }

                                    if (
                                        connectedTo == 'B2' &&
                                        sessionStorage.getItem('dragingItem') !=
                                            null
                                    ) {
                                        LeftF = bibox.left + 4
                                        TopF = bibox.top + 2
                                        cx1 =
                                            left +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2
                                        cy1 =
                                            top +
                                            2 *
                                                ImageSizes[
                                                    ItemTypes.COMPONENT
                                                ][1]
                                        cx2 = LeftF + Ports(connectedTo)[0]
                                        cy2 = TopF + Ports(connectedTo)[1]
                                        cy2 -= 50
                                        cx2 += 150
                                        cx1 += 50
                                    }
                                }
                            }
                        })
                    }
                    if (key == 'servo_extender') {
                        components[key].map((component, index) => {
                            if (component.connectedTo == 'B') {
                                LeftF = component.left + 30
                                TopF = component.top + 5
                            }
                        })
                    }

                    let adads = sessionStorage.getItem('dragingItem')

                    if (key == 'pc_motor_driver') {
                        components[key].map((component, index) => {
                            if (
                                component.connectedTo == 'B' ||
                                component.connectedTo == 'D'
                            ) {
                                // not run initial  it will run after the
                                if (
                                    B1connectedServoMotor == true ||
                                    B2connectedServoMotor == true
                                ) {
                                    if (connectedTo == 'B2') {
                                        LeftF = component.left - 70
                                        TopF = component.top
                                    } else {
                                        LeftF = component.left - 30
                                        TopF = component.top
                                    }
                                } else if (
                                    [
                                        'geared_motor',
                                        'mini_geared_motor',
                                        'dc_motor',
                                        'dynamex_motor',
                                    ].includes(
                                        sessionStorage.getItem('dragingItem')
                                    )
                                ) {
                                    LeftF = component.left - 70
                                    TopF = component.top + 30
                                } else if (
                                    sessionStorage.getItem('dragingItem') ==
                                        'servo_motor' &&
                                    !B1connectedGeared_motor &&
                                    !D1connectedGeared_motor
                                ) {
                                    // this is for when we drag servo_motor  changing the postion at drag time

                                    if (connectedTo == 'B2') {
                                        LeftF = component.left - 70
                                        TopF = component.top
                                    } else {
                                        LeftF = component.left - 30
                                        TopF = component.top
                                    }
                                } else {
                                    LeftF = component.left - 70
                                    TopF = component.top + 30
                                }
                            }
                        })
                    }
                })

                return (
                    <path
                        d={
                            'M ' +
                            (left -
                                10 +
                                ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                            ',' +
                            (top + 85) +
                            ' C ' +
                            cx1 +
                            ',' +
                            cy1 +
                            ' ' +
                            cx2 +
                            ',' +
                            cy2 +
                            ' ' +
                            (LeftF + Ports(connectedTo)[0]) +
                            ',' +
                            (TopF + Ports(connectedTo)[1])
                        }
                    />
                )
            } else if (
                (connectedTo == 'E1' || connectedTo == 'E2') &&
                !['Moki'].includes(sessionStorage.getItem('connectedDevice'))
            ) {
                let isCurveGenerat = false
                Object.keys(components).map((key) => {
                    if (key == 'dual_splitter') {
                        // if(this.props.componentName = "")
                        components[key].map((component, index) => {
                            if (
                                ![
                                    'geared_motor',
                                    'mini_geared_motor',
                                    'dc_motor',
                                    'dynamex_motor',
                                ].includes(this.props.componentName)
                            ) {
                                if (component.connectedTo == 'E') {
                                    LeftF = component.left
                                    TopF = component.top
                                }
                                if (
                                    component.connectedTo == 'E' &&
                                    this.props.shield == true
                                ) {
                                    if (connectedTo == 'E1') {
                                        LeftF = component.left + 5
                                        TopF = component.top - 74
                                    }
                                    if (connectedTo == 'E2') {
                                        LeftF = component.left - 5
                                        TopF = component.top - 68
                                    }
                                }
                                cx2 = LeftF + Ports(connectedTo)[0]
                                cy2 = TopF + Ports(connectedTo)[1]
                                cx2 +=
                                    Ports(connectedTo)[0] -
                                    ImageSizes[ItemTypes.COMPONENT][0] / 2
                                cy2 +=
                                    Ports(connectedTo)[1] -
                                    ImageSizes[ItemTypes.COMPONENT][1] / 2
                            } else {
                                if (component.connectedTo == 'E') {
                                    LeftF = component.left + 30
                                    TopF = isDeviceVersion12
                                        ? component.top - 40
                                        : component.top - 70
                                }
                                cx2 = LeftF + Ports(connectedTo)[0]
                                cy2 = TopF + Ports(connectedTo)[1]
                                cy2 -= 50
                            }
                        })
                    } else if (
                        key == 'OLED' &&
                        sessionStorage.getItem('connectedDevice') === 'Poki'
                    ) {
                        // if(this.props.componentName = "")
                        components[key].map((component, index) => {
                            if (component.connectedTo === 'E') {
                                isCurveGenerat = true

                                LeftF = component.left - 13
                                TopF = component.top - 127

                                cx2 = LeftF + Ports(connectedTo)[0]
                                cy2 = TopF + Ports(connectedTo)[1]
                                cy2 -= 50
                            }
                        })
                    }
                })
                if (
                    !isCurveGenerat &&
                    sessionStorage.getItem('connectedDevice') === 'Poki' &&
                    ![
                        'Magnetometer',
                        'Magnetic_encoder',
                        'IMU',
                        'OLED',
                        'Color_sensor',
                    ].includes(this.props.componentName)
                ) {
                    return this.defaultCurve({ bibox, left, top, connectedTo })
                }

                return (
                    <path
                        d={
                            'M ' +
                            (left -
                                10 +
                                ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                            ',' +
                            (top + 85) +
                            ' C ' +
                            (left + ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                            ',' +
                            (top + 2 * ImageSizes[ItemTypes.COMPONENT][1]) +
                            ' ' +
                            cx2 +
                            ',' +
                            cy2 +
                            ' ' +
                            (LeftF + Ports(connectedTo)[0]) +
                            ',' +
                            (TopF + Ports(connectedTo)[1])
                        }
                    />
                )
            } else if (
                (connectedTo == 'F1' || connectedTo == 'F2') &&
                !['Moki', 'Poki'].includes(
                    sessionStorage.getItem('connectedDevice')
                )
            ) {
                if (sessionStorage.getItem('connectedDevice') == 'Klaw') {
                    if (
                        connectedTo == 'F1' &&
                        sessionStorage.getItem('dragingItem') != null
                    ) {
                        LeftF = bibox.left
                        TopF = bibox.top
                        cx1 = left + ImageSizes[ItemTypes.COMPONENT][0] / 2
                        cy1 = top + 2 * ImageSizes[ItemTypes.COMPONENT][1]
                        cx2 = LeftF + Ports(connectedTo)[0]
                        cy2 = TopF + Ports(connectedTo)[1]
                        cy2 += 75
                    }
                    if (
                        connectedTo == 'F2' &&
                        sessionStorage.getItem('dragingItem') != null
                    ) {
                        LeftF = bibox.left
                        TopF = bibox.top
                        cx1 = left + 50 + ImageSizes[ItemTypes.COMPONENT][0] / 2
                        cy1 = top + 2 * ImageSizes[ItemTypes.COMPONENT][1]
                        cx2 = LeftF + Ports(connectedTo)[0]
                        cy2 = TopF + Ports(connectedTo)[1]

                        cy2 += 75
                    }
                }
                Object.keys(components).map((key) => {
                    if (key == 'dual_splitter') {
                        // if(this.props.componentName = "")
                        components[key].map((component, index) => {
                            if (
                                ![
                                    'geared_motor',
                                    'mini_geared_motor',
                                    'dc_motor',
                                    'dynamex_motor',
                                ].includes(this.props.componentName)
                            ) {
                                if (component.connectedTo == 'F') {
                                    LeftF = component.left
                                    TopF = component.top + 30
                                }
                                if (
                                    component.connectedTo == 'F' &&
                                    this.props.shield == true
                                ) {
                                    if (connectedTo == 'F1') {
                                        LeftF = component.left + 5
                                        TopF = component.top - 74
                                    }
                                    if (connectedTo == 'F2') {
                                        LeftF = component.left - 5
                                        TopF = component.top - 68
                                    }
                                }
                                cx2 = LeftF + Ports(connectedTo)[0]
                                cy2 = TopF + Ports(connectedTo)[1]
                                cx2 +=
                                    Ports(connectedTo)[0] -
                                    ImageSizes[ItemTypes.COMPONENT][0] / 2
                                cy2 +=
                                    Ports(connectedTo)[1] -
                                    ImageSizes[ItemTypes.COMPONENT][1] / 2
                            } else {
                                if (component.connectedTo == 'F') {
                                    LeftF = component.left + 30
                                    TopF = isDeviceVersion12
                                        ? component.top - 40
                                        : component.top - 70
                                }
                                cx2 = LeftF + Ports(connectedTo)[0]
                                cy2 = TopF + Ports(connectedTo)[1]
                                cy2 -= 50
                            }
                        })
                    }
                })

                return (
                    <path
                        d={
                            'M ' +
                            (left -
                                10 +
                                ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                            ',' +
                            (top + 85) +
                            ' C ' +
                            (left + ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                            ',' +
                            (top + 2 * ImageSizes[ItemTypes.COMPONENT][1]) +
                            ' ' +
                            cx2 +
                            ',' +
                            cy2 +
                            ' ' +
                            (LeftF + Ports(connectedTo)[0]) +
                            ',' +
                            (TopF + Ports(connectedTo)[1])
                        }
                    />
                )
            } else if (
                connectedTo == 'M1' ||
                connectedTo == 'M2' ||
                connectedTo == 'M3' ||
                connectedTo == 'M4' ||
                connectedTo == 'G' ||
                connectedTo == 'H'
            ) {
                if (
                    ['Roboki', 'Klaw', 'Atr', 'Toki', 'Poki', 'Moki'].includes(
                        sessionStorage.getItem('connectedDevice')
                    )
                ) {
                    if (
                        connectedTo == 'M1' &&
                        sessionStorage.getItem('dragingItem') != null
                    ) {
                        LeftF = bibox.left
                        TopF = bibox.top
                        cx1 = left + ImageSizes[ItemTypes.COMPONENT][0] / 2
                        cy1 = top + 2 * ImageSizes[ItemTypes.COMPONENT][1]
                        cx2 = LeftF + Ports(connectedTo)[0]
                        cy2 = TopF + Ports(connectedTo)[1]
                        cy2 += 75
                    }
                    if (
                        connectedTo == 'M3' &&
                        sessionStorage.getItem('dragingItem') != null
                    ) {
                        LeftF = bibox.left
                        TopF = bibox.top
                        cx1 = left + 50 + ImageSizes[ItemTypes.COMPONENT][0] / 2
                        cy1 = top + 2 * ImageSizes[ItemTypes.COMPONENT][1]
                        cx2 = LeftF + Ports(connectedTo)[0]
                        cy2 = TopF + Ports(connectedTo)[1]

                        cy2 += 75
                    }
                }
                Object.keys(components).map((key) => {
                    if (key == 'play_shield' || key == 'play_shield_v1') {
                        components[key].map((component, index) => {
                            if (
                                [
                                    'geared_motor',
                                    'mini_geared_motor',
                                    'dc_motor',
                                    'dynamex_motor',
                                ].includes(this.props.componentName)
                            ) {
                                if (
                                    connectedTo == 'M1' &&
                                    sessionStorage.getItem('dragingItem') !=
                                        null
                                ) {
                                    LeftF = bibox.left
                                    TopF = bibox.top
                                    cx1 =
                                        left +
                                        ImageSizes[ItemTypes.COMPONENT][0] / 2
                                    cy1 =
                                        top +
                                        2 * ImageSizes[ItemTypes.COMPONENT][1]
                                    cx2 = LeftF + Ports(connectedTo)[0]
                                    cy2 = TopF + Ports(connectedTo)[1]
                                    cy2 += 75
                                }
                                if (
                                    connectedTo == 'M3' &&
                                    sessionStorage.getItem('dragingItem') !=
                                        null
                                ) {
                                    LeftF = bibox.left
                                    TopF = bibox.top
                                    cx1 =
                                        left +
                                        50 +
                                        ImageSizes[ItemTypes.COMPONENT][0] / 2
                                    cy1 =
                                        top +
                                        2 * ImageSizes[ItemTypes.COMPONENT][1]
                                    cx2 = LeftF + Ports(connectedTo)[0]
                                    cy2 = TopF + Ports(connectedTo)[1]

                                    cy2 += 75
                                }
                            }
                        })
                    } else if (key == 'peeCee_ATR') {
                        components[key].map((component, index) => {
                            if (this.props.peeCeeATR) {
                                LeftF = bibox.left
                                TopF = bibox.top
                                cx1 =
                                    left +
                                    ImageSizes[ItemTypes.COMPONENT][0] / 2
                                cy1 =
                                    top + 2 * ImageSizes[ItemTypes.COMPONENT][1]
                                cx2 = LeftF + Ports(connectedTo)[0]
                                cy2 = TopF + Ports(connectedTo)[1]
                                cy2 += 75
                            }
                        })
                    }
                })

                // DEFINE OFFSET: Use 85 (original) for dragging, 195 (fixed) for static
                // const wireYOffset = this.props.isDragging ? 85 : 85;
                const wireYOffset = 90
                console.log(
                    'isbeingdragged',
                    this.props.isDragging,
                    'using wireYOffset',
                    wireYOffset
                )

                return (
                    <path
                        d={
                            'M ' +
                            (left -
                                10 +
                                ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                            ',' +
                            (top + wireYOffset) +
                            ' C ' +
                            cx1 +
                            ',' +
                            cy1 +
                            ' ' +
                            cx2 +
                            ',' +
                            cy2 +
                            ' ' +
                            (LeftF + Ports(connectedTo)[0]) +
                            ',' +
                            (TopF + Ports(connectedTo)[1])
                        }
                    />
                )
            } else if (
                (connectedTo == 'I1' || connectedTo == 'I2') &&
                !['Moki'].includes(sessionStorage.getItem('connectedDevice'))
            ) {
                Object.keys(components).map((dual_splitter) => {
                    if (dual_splitter == 'dual_splitter') {
                        components[dual_splitter].map((component, index) => {
                            if (component.connectedTo == 'I') {
                                LeftF = component.left
                                TopF = component.top
                            }
                        })
                    }
                })

                cx2 = LeftF + Ports(connectedTo)[0]
                cy2 = TopF + Ports(connectedTo)[1]
                cx2 +=
                    Ports(connectedTo)[0] -
                    ImageSizes[ItemTypes.COMPONENT][0] / 2
                cy2 +=
                    Ports(connectedTo)[1] -
                    ImageSizes[ItemTypes.COMPONENT][1] / 2
                return (
                    <path
                        d={
                            'M ' +
                            (left -
                                10 +
                                ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                            ',' +
                            (top + 85) +
                            ' C ' +
                            (left + ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                            ',' +
                            (top + 2 * ImageSizes[ItemTypes.COMPONENT][1]) +
                            ' ' +
                            cx2 +
                            ',' +
                            cy2 +
                            ' ' +
                            (LeftF + Ports(connectedTo)[0]) +
                            ',' +
                            (TopF + Ports(connectedTo)[1])
                        }
                    />
                )
            } else if (
                (connectedTo == 'servo_motor1' ||
                    connectedTo == 'servo_motor2') &&
                !['Toki', 'Poki', 'Moki'].includes(
                    sessionStorage.getItem('connectedDevice')
                )
            ) {
                if (
                    ['Roboki', 'Atr', 'Toki', 'Poki', 'Moki'].includes(
                        sessionStorage.getItem('connectedDevice')
                    )
                ) {
                    if (
                        [
                            'servo_motor',
                            'servo_motor_270',
                            'servo_motor_360',
                            'servo_motor_sg90',
                        ].includes(this.props.componentName) &&
                        sessionStorage.getItem('dragingItem') != null
                    ) {
                        LeftF = bibox.left
                        TopF = bibox.top
                        cx1 = left + ImageSizes[ItemTypes.COMPONENT][0] / 2
                        cy1 = top + 2 * ImageSizes[ItemTypes.COMPONENT][1]
                        cx2 = LeftF + Ports(connectedTo)[0]
                        cy2 = TopF + Ports(connectedTo)[1]
                        cy2 += 75
                    }
                    if (
                        [
                            'servo_motor',
                            'servo_motor_270',
                            'servo_motor_360',
                            'servo_motor_sg90',
                        ].includes(this.props.componentName) &&
                        sessionStorage.getItem('dragingItem') != null
                    ) {
                        LeftF = bibox.left
                        TopF = bibox.top
                        cx1 = left + 50 + ImageSizes[ItemTypes.COMPONENT][0] / 2
                        cy1 = top + 2 * ImageSizes[ItemTypes.COMPONENT][1]
                        cx2 = LeftF + Ports(connectedTo)[0]
                        cy2 = TopF + Ports(connectedTo)[1]

                        cy2 += 75
                    }
                }
                Object.keys(components).map((key) => {
                    if (key == 'play_shield_v1') {
                        components[key].map((component, index) => {
                            if (
                                [
                                    'servo_motor',
                                    'servo_motor_270',
                                    'servo_motor_360',
                                ].includes(this.props.componentName)
                            ) {
                                if (
                                    connectedTo == 'servo_motor1' &&
                                    sessionStorage.getItem('dragingItem') !=
                                        null
                                ) {
                                    LeftF = bibox.left
                                    TopF = bibox.top
                                    cx1 =
                                        left +
                                        ImageSizes[ItemTypes.COMPONENT][0] / 2
                                    cy1 =
                                        top +
                                        2 * ImageSizes[ItemTypes.COMPONENT][1]
                                    cx2 = LeftF + Ports(connectedTo)[0]
                                    cy2 = TopF + Ports(connectedTo)[1]
                                    cy2 += 75
                                }
                                if (
                                    connectedTo == 'servo_motor2' &&
                                    sessionStorage.getItem('dragingItem') !=
                                        null
                                ) {
                                    LeftF = bibox.left
                                    TopF = bibox.top
                                    cx1 =
                                        left +
                                        50 +
                                        ImageSizes[ItemTypes.COMPONENT][0] / 2
                                    cy1 =
                                        top +
                                        2 * ImageSizes[ItemTypes.COMPONENT][1]
                                    cx2 = LeftF + Ports(connectedTo)[0]
                                    cy2 = TopF + Ports(connectedTo)[1]

                                    cy2 += 75
                                }
                            }
                        })
                    }
                })

                return (
                    <path
                        d={
                            'M ' +
                            (left -
                                10 +
                                ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                            ',' +
                            (top + 85) +
                            ' C ' +
                            cx1 +
                            ',' +
                            cy1 +
                            ' ' +
                            cx2 +
                            ',' +
                            cy2 +
                            ' ' +
                            (LeftF + Ports(connectedTo)[0]) +
                            ',' +
                            (TopF + Ports(connectedTo)[1])
                        }
                    />
                )
            } else if (connectedTo == 'A') {
                Top = bibox.top
                Left = bibox.left

                cx2 = Left + Ports(connectedTo)[0]
                cy2 = Top + Ports(connectedTo)[1]
                cx2 +=
                    Ports(connectedTo)[0] - ImageSizes[ItemTypes.BIBOX][0] / 2
                cy2 +=
                    Ports(connectedTo)[1] - ImageSizes[ItemTypes.BIBOX][1] / 2
                if (this.props.componentName == 'pc_motor_driver') {
                    if (connectedTo == 'A' || connectedTo == 'C') {
                        return (
                            <>
                                <path
                                    d={
                                        'M ' +
                                        (left -
                                            100 +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top + 5) +
                                        ' C ' +
                                        (left +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top -
                                            2 *
                                                ImageSizes[
                                                    ItemTypes.COMPONENT
                                                ][1]) +
                                        ' ' +
                                        cx2 +
                                        ',' +
                                        cy2 +
                                        ' ' +
                                        (Left + Ports('A')[0]) +
                                        ',' +
                                        (Top + Ports('A')[1])
                                    }
                                />
                                <path
                                    d={
                                        'M ' +
                                        (left +
                                            100 +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top + 5) +
                                        ' C ' +
                                        (left +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top -
                                            2 *
                                                ImageSizes[
                                                    ItemTypes.COMPONENT
                                                ][1]) +
                                        ' ' +
                                        cx2 +
                                        ',' +
                                        cy2 +
                                        ' ' +
                                        (Left + Ports('C')[0]) +
                                        ',' +
                                        (Top + Ports('C')[1])
                                    }
                                />
                            </>
                        )
                    }

                    if (connectedTo == 'B' || connectedTo == 'D') {
                        return (
                            <>
                                <path
                                    d={
                                        'M ' +
                                        (left -
                                            100 +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top + 5) +
                                        ' C ' +
                                        (left +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top -
                                            2 *
                                                ImageSizes[
                                                    ItemTypes.COMPONENT
                                                ][1]) +
                                        ' ' +
                                        cx2 +
                                        ',' +
                                        cy2 +
                                        ' ' +
                                        (Left + Ports('B')[0]) +
                                        ',' +
                                        (Top + Ports('B')[1])
                                    }
                                />
                                <path
                                    d={
                                        'M ' +
                                        (left +
                                            100 +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top + 5) +
                                        ' C ' +
                                        (left +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top -
                                            2 *
                                                ImageSizes[
                                                    ItemTypes.COMPONENT
                                                ][1]) +
                                        ' ' +
                                        cx2 +
                                        ',' +
                                        cy2 +
                                        ' ' +
                                        (Left + Ports('D')[0]) +
                                        ',' +
                                        (Top + Ports('D')[1])
                                    }
                                />
                            </>
                        )
                    }
                } else if (this.props.componentName == 'RGB') {
                    return (
                        <path
                            d={
                                'M ' +
                                (left -
                                    15 +
                                    ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                                ',' +
                                (top + 80) +
                                ' C ' +
                                (left -
                                    120 +
                                    ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                                ',' +
                                (top + 2 * ImageSizes[ItemTypes.COMPONENT][1]) +
                                ' ' +
                                cx2 +
                                ',' +
                                cy2 +
                                ' ' +
                                (Left + Ports(connectedTo)[0]) +
                                ',' +
                                (Top + Ports(connectedTo)[1])
                            }
                        />
                    )
                } else {
                    return (
                        <path
                            d={
                                'M ' +
                                (left -
                                    15 +
                                    ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                                ',' +
                                (top + 80) +
                                ' C ' +
                                (left +
                                    60 +
                                    ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                                ',' +
                                (top + 2 * ImageSizes[ItemTypes.COMPONENT][1]) +
                                ' ' +
                                cx2 +
                                ',' +
                                cy2 +
                                ' ' +
                                (Left + Ports(connectedTo)[0]) +
                                ',' +
                                (Top + Ports(connectedTo)[1])
                            }
                        />
                    )
                }
            } else if (connectedTo == 'B') {
                Top = bibox.top
                Left = bibox.left
                cx2 = Left + Ports(connectedTo)[0]
                cy2 = Top + Ports(connectedTo)[1]
                cx2 +=
                    Ports(connectedTo)[0] - ImageSizes[ItemTypes.BIBOX][0] / 2
                cy2 +=
                    Ports(connectedTo)[1] - ImageSizes[ItemTypes.BIBOX][1] / 2
                if (this.props.componentName == 'pc_motor_driver') {
                    if (connectedTo == 'A' || connectedTo == 'C') {
                        return (
                            <>
                                <path
                                    d={
                                        'M ' +
                                        (left -
                                            100 +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top + 5) +
                                        ' C ' +
                                        (left +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top -
                                            2 *
                                                ImageSizes[
                                                    ItemTypes.COMPONENT
                                                ][1]) +
                                        ' ' +
                                        cx2 +
                                        ',' +
                                        cy2 +
                                        ' ' +
                                        (Left + Ports('A')[0]) +
                                        ',' +
                                        (Top + Ports('A')[1])
                                    }
                                />
                                <path
                                    d={
                                        'M ' +
                                        (left +
                                            100 +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top + 5) +
                                        ' C ' +
                                        (left +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top -
                                            2 *
                                                ImageSizes[
                                                    ItemTypes.COMPONENT
                                                ][1]) +
                                        ' ' +
                                        cx2 +
                                        ',' +
                                        cy2 +
                                        ' ' +
                                        (Left + Ports('C')[0]) +
                                        ',' +
                                        (Top + Ports('C')[1])
                                    }
                                />
                            </>
                        )
                    }

                    if (connectedTo == 'B' || connectedTo == 'D') {
                        return (
                            <>
                                <path
                                    d={
                                        'M ' +
                                        (left -
                                            100 +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top + 5) +
                                        ' C ' +
                                        (left +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top -
                                            2 *
                                                ImageSizes[
                                                    ItemTypes.COMPONENT
                                                ][1]) +
                                        ' ' +
                                        cx2 +
                                        ',' +
                                        cy2 +
                                        ' ' +
                                        (Left + Ports('B')[0]) +
                                        ',' +
                                        (Top + Ports('B')[1])
                                    }
                                />
                                <path
                                    d={
                                        'M ' +
                                        (left +
                                            100 +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top + 5) +
                                        ' C ' +
                                        (left +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top -
                                            2 *
                                                ImageSizes[
                                                    ItemTypes.COMPONENT
                                                ][1]) +
                                        ' ' +
                                        cx2 +
                                        ',' +
                                        cy2 +
                                        ' ' +
                                        (Left + Ports('D')[0]) +
                                        ',' +
                                        (Top + Ports('D')[1])
                                    }
                                />
                            </>
                        )
                    }
                } else if (this.props.componentName == 'RGB') {
                    return (
                        <path
                            d={
                                'M ' +
                                (left -
                                    15 +
                                    ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                                ',' +
                                (top + 80) +
                                ' C ' +
                                (left -
                                    120 +
                                    ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                                ',' +
                                (top + 2 * ImageSizes[ItemTypes.COMPONENT][1]) +
                                ' ' +
                                cx2 +
                                ',' +
                                cy2 +
                                ' ' +
                                (Left + Ports(connectedTo)[0]) +
                                ',' +
                                (Top + Ports(connectedTo)[1])
                            }
                        />
                    )
                } else {
                    return (
                        <path
                            d={
                                'M ' +
                                (left -
                                    15 +
                                    ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                                ',' +
                                (top + 80) +
                                ' C ' +
                                (left +
                                    60 +
                                    ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                                ',' +
                                (top + 2 * ImageSizes[ItemTypes.COMPONENT][1]) +
                                ' ' +
                                cx2 +
                                ',' +
                                cy2 +
                                ' ' +
                                (Left + Ports(connectedTo)[0]) +
                                ',' +
                                (Top + Ports(connectedTo)[1])
                            }
                        />
                    )
                }
            } else if (connectedTo == 'F') {
                Top = bibox.top
                Left = bibox.left
                cx2 = Left + Ports(connectedTo)[0]
                cy2 = Top + Ports(connectedTo)[1]
                cy2 -= 50
                cx2 += 150
                cx1 += 50
                return (
                    <path
                        d={
                            'M ' +
                            (left -
                                15 +
                                ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                            ',' +
                            (top + 80) +
                            ' C ' +
                            (left +
                                60 +
                                ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                            ',' +
                            (top + 2 * ImageSizes[ItemTypes.COMPONENT][1]) +
                            ' ' +
                            cx2 +
                            ',' +
                            cy2 +
                            ' ' +
                            (Left + Ports(connectedTo)[0]) +
                            ',' +
                            (Top + Ports(connectedTo)[1])
                        }
                    />
                )
            } else if (
                connectedTo == 'C' ||
                connectedTo == 'D' ||
                connectedTo == 'E'
            ) {
                Top = bibox.top
                Left = bibox.left
                cx2 = Left + Ports(connectedTo)[0]
                cy2 = Top + Ports(connectedTo)[1]
                cx2 +=
                    Ports(connectedTo)[0] - ImageSizes[ItemTypes.BIBOX][0] / 2
                cy2 +=
                    Ports(connectedTo)[1] - ImageSizes[ItemTypes.BIBOX][1] / 2
                if (this.props.componentName == 'pc_motor_driver') {
                    if (connectedTo == 'A' || connectedTo == 'C') {
                        return (
                            <>
                                <path
                                    d={
                                        'M ' +
                                        (left -
                                            100 +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top + 5) +
                                        ' C ' +
                                        (left +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top -
                                            2 *
                                                ImageSizes[
                                                    ItemTypes.COMPONENT
                                                ][1]) +
                                        ' ' +
                                        cx2 +
                                        ',' +
                                        cy2 +
                                        ' ' +
                                        (Left + Ports('A')[0]) +
                                        ',' +
                                        (Top + Ports('A')[1])
                                    }
                                />
                                <path
                                    d={
                                        'M ' +
                                        (left +
                                            100 +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top + 5) +
                                        ' C ' +
                                        (left +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top -
                                            2 *
                                                ImageSizes[
                                                    ItemTypes.COMPONENT
                                                ][1]) +
                                        ' ' +
                                        cx2 +
                                        ',' +
                                        cy2 +
                                        ' ' +
                                        (Left + Ports('C')[0]) +
                                        ',' +
                                        (Top + Ports('C')[1])
                                    }
                                />
                            </>
                        )
                    }

                    if (connectedTo == 'B' || connectedTo == 'D') {
                        return (
                            <>
                                <path
                                    d={
                                        'M ' +
                                        (left -
                                            100 +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top + 5) +
                                        ' C ' +
                                        (left +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top -
                                            2 *
                                                ImageSizes[
                                                    ItemTypes.COMPONENT
                                                ][1]) +
                                        ' ' +
                                        cx2 +
                                        ',' +
                                        cy2 +
                                        ' ' +
                                        (Left + Ports('B')[0]) +
                                        ',' +
                                        (Top + Ports('B')[1])
                                    }
                                />
                                <path
                                    d={
                                        'M ' +
                                        (left +
                                            100 +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top + 5) +
                                        ' C ' +
                                        (left +
                                            ImageSizes[ItemTypes.COMPONENT][0] /
                                                2) +
                                        ',' +
                                        (top -
                                            2 *
                                                ImageSizes[
                                                    ItemTypes.COMPONENT
                                                ][1]) +
                                        ' ' +
                                        cx2 +
                                        ',' +
                                        cy2 +
                                        ' ' +
                                        (Left + Ports('D')[0]) +
                                        ',' +
                                        (Top + Ports('D')[1])
                                    }
                                />
                            </>
                        )
                    }
                } else if (this.props.componentName == 'RGB') {
                    return (
                        <path
                            d={
                                'M ' +
                                (left -
                                    15 +
                                    ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                                ',' +
                                (top + 80) +
                                ' C ' +
                                (left -
                                    120 +
                                    ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                                ',' +
                                (top + 2 * ImageSizes[ItemTypes.COMPONENT][1]) +
                                ' ' +
                                cx2 +
                                ',' +
                                cy2 +
                                ' ' +
                                (Left + Ports(connectedTo)[0]) +
                                ',' +
                                (Top + Ports(connectedTo)[1])
                            }
                        />
                    )
                } else {
                    return (
                        <path
                            d={
                                'M ' +
                                (left -
                                    15 +
                                    ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                                ',' +
                                (top + 80) +
                                ' C ' +
                                (left +
                                    60 +
                                    ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                                ',' +
                                (top + 2 * ImageSizes[ItemTypes.COMPONENT][1]) +
                                ' ' +
                                cx2 +
                                ',' +
                                cy2 +
                                ' ' +
                                (Left + Ports(connectedTo)[0]) +
                                ',' +
                                (Top + Ports(connectedTo)[1])
                            }
                        />
                    )
                }
            } else if (
                connectedTo == 'P0' ||
                connectedTo == 'P1' ||
                connectedTo == 'P2' ||
                connectedTo == 'SS' ||
                connectedTo == 'SPK' ||
                connectedTo == 'MOTOR1'
            ) {
                Object.keys(components).map((key) => {
                    components[key].map((component, index) => {
                        if (this.props.armShield) {
                            LeftF = bibox.left
                            TopF = bibox.top
                            cx1 = left + ImageSizes[ItemTypes.COMPONENT][0] / 2
                            cy1 = top + 2 * ImageSizes[ItemTypes.COMPONENT][1]
                            cx2 = LeftF + Ports(connectedTo)[0]
                            cy2 = TopF + Ports(connectedTo)[1]
                            cy2 += 75
                        }
                    })
                })
                return (
                    <path
                        d={
                            'M ' +
                            (left -
                                10 +
                                ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                            ',' +
                            (top + 85) +
                            ' C ' +
                            cx1 +
                            ',' +
                            cy1 +
                            ' ' +
                            cx2 +
                            ',' +
                            cy2 +
                            ' ' +
                            (LeftF + Ports(connectedTo)[0]) +
                            ',' +
                            (TopF + Ports(connectedTo)[1])
                        }
                    />
                )
            } else if (
                (connectedTo == 'S1' || connectedTo == 'S2') &&
                !['Atr'].includes(sessionStorage.getItem('connectedDevice'))
            ) {
                // For component dropped directly on the port: use defaultCurve to draw the 3 colored wires
                if (this.props.componentName === 'RGB') {
                    return this.defaultCurve({ bibox, left, top, connectedTo })
                }
                Object.keys(components).map((key) => {
                    components[key].map((component, index) => {
                        if (this.props.peeCeeATR) {
                            LeftF = bibox.left
                            TopF = bibox.top
                            cx1 = left + ImageSizes[ItemTypes.COMPONENT][0] / 2
                            cy1 = top + 2 * ImageSizes[ItemTypes.COMPONENT][1]
                            cx2 = LeftF + Ports(connectedTo)[0]
                            cy2 = TopF + Ports(connectedTo)[1]
                            cy2 += 75
                        }
                    })
                })
                return (
                    <path
                        d={
                            'M ' +
                            (left -
                                10 +
                                ImageSizes[ItemTypes.COMPONENT][0] / 2) +
                            ',' +
                            (top + 85) +
                            ' C ' +
                            cx1 +
                            ',' +
                            cy1 +
                            ' ' +
                            cx2 +
                            ',' +
                            cy2 +
                            ' ' +
                            (LeftF + Ports(connectedTo)[0]) +
                            ',' +
                            (TopF + Ports(connectedTo)[1])
                        }
                    />
                )
            } else if (connectedTo) {
                return this.defaultCurve({ bibox, left, top, connectedTo })
            }
        }
    }
}

//                 // PPP

class PortCircle extends Component {
    renderhighlighted = () => {
        const { PortConnections } = this.props
        let newHumanoidPortData = JSON.parse(
            sessionStorage.getItem('humanoidPortData')
        )
        let internalAccessoriesData = JSON.parse(
            sessionStorage.getItem('concept')
        ).internalaccessories
        let dragItem = sessionStorage.getItem('dragingItem')
        let deviceVersion = sessionStorage.getItem('deviceVersion') || '0.0.00'
        const connectedDevice = sessionStorage.getItem('connectedDevice') || ''
        if (
            deviceVersion[0] == '1' &&
            ['Hexapod', 'Humanoid'].includes(connectedDevice)
            //     sessionStorage.getItem('connectedDevice') == 'Humanoid') ||
            // (sessionStorage.getItem('connectedDevice') == 'Hexapod' &&
            //     deviceVersion[0] == '1')
        ) {
            if (
                this.props.portName == 'D' &&
                dragItem != 'OLED' &&
                (newHumanoidPortData[23].isPortSelected == true ||
                    newHumanoidPortData[24].isPortSelected == true ||
                    newHumanoidPortData[25].isPortSelected == true ||
                    PortConnections['D1'] != null ||
                    PortConnections['D2'] != null)
            ) {
                return 0
            } else if (
                this.props.portName == 'B' &&
                newHumanoidPortData[40].isPortSelected == true
            ) {
                return 0
            }
        }
        if (!sessionStorage.getItem('deviceVersion')?.startsWith('1')) {
            if (
                this.props.portName == 'A' &&
                (internalAccessoriesData.isTouchZero == true ||
                    internalAccessoriesData.isTouchZeroOutput == true ||
                    PortConnections['A1'] != null ||
                    PortConnections['A2'] != null)
            ) {
                return 0
            } else if (
                this.props.portName == 'B' &&
                (internalAccessoriesData.isTouchOne == true ||
                    internalAccessoriesData.isTouchOneOutput == true ||
                    PortConnections['B1'] != null ||
                    PortConnections['B2'] != null)
            ) {
                return 0
            } else if (
                this.props.portName == 'C' &&
                (internalAccessoriesData.isTouchTwo == true ||
                    internalAccessoriesData.isTouchTwoOutput == true ||
                    PortConnections['C1'] != null ||
                    PortConnections['C2'] != null)
            ) {
                return 0
            } else if (
                this.props.portName == 'D' &&
                dragItem != 'OLED' &&
                (internalAccessoriesData.isFour_in_one_sensor == true ||
                    PortConnections['D1'] != null ||
                    PortConnections['D2'] != null)
            ) {
                return 0
            } else {
                return 1.4
            }
        } else {
            if (
                sessionStorage.getItem('deviceVersion')?.startsWith('1') &&
                JSON.parse(sessionStorage.getItem('peeCeeATR') || 'false') &&
                ['M2', 'M4'].includes(this.props.portName)
            ) {
                return 0
            }
            // if (this.props.portName === 'M2') {
            //     console.log("WWWWWWWWWWW")
            //     return 0
            // }
            if (
                sessionStorage.getItem('dragingItem') != 'OLED' &&
                this.props.portName == 'D' &&
                (internalAccessoriesData.isFour_in_one_sensor === true ||
                    internalAccessoriesData.isAccelerometer === true)
            ) {
                return 0
            }
            if (
                [
                    'geared_motor',
                    'mini_geared_motor',
                    'dc_motor',
                    'dynamex_motor',
                ].includes(sessionStorage.getItem('dragingItem')) &&
                this.props.portName == 'M1' &&
                (internalAccessoriesData.isSmileOne === true ||
                    internalAccessoriesData.isSmileTwo === true)
            ) {
                return 0
            }
            if (
                [
                    'geared_motor',
                    'mini_geared_motor',
                    'dc_motor',
                    'dynamex_motor',
                ].includes(sessionStorage.getItem('dragingItem')) &&
                this.props.portName == 'M3' &&
                (internalAccessoriesData.isSmileThree === true ||
                    internalAccessoriesData.isSmileFour === true)
            ) {
                return 0
            }
            if (sessionStorage.getItem('shield') === 'true') {
                const components = JSON.parse(
                    sessionStorage.getItem('assemblyTwo')
                ).workspace.components
                if (
                    [
                        'servo_motor_360',
                        'servo_motor_270',
                        'servo_motor',
                        'dc_motor',
                        'geared_motor',
                        'mini_geared_motor',
                        'dynamex_motor',
                    ].includes(sessionStorage.getItem('dragingItem'))
                ) {
                    const cal_length = (motorlist) => {
                        let sum = 0
                        motorlist.map((motor) => {
                            if (motor.connectedTo !== undefined) {
                                sum = sum + 1
                            }
                        })
                        return sum
                    }
                    const servo_motor =
                        components.servo_motor === undefined
                            ? 0
                            : cal_length(components.servo_motor)
                    const servo_motor_270 =
                        components.servo_motor_270 === undefined
                            ? 0
                            : cal_length(components.servo_motor_270)
                    const servo_motor_360 =
                        components.servo_motor_360 === undefined
                            ? 0
                            : cal_length(components.servo_motor_360)
                    const dc_motor =
                        components.dc_motor === undefined
                            ? 0
                            : cal_length(components.dc_motor)
                    const dynamex_motor =
                        components.dynamex_motor === undefined
                            ? 0
                            : cal_length(components.dynamex_motor)
                    const geared_motor =
                        components.geared_motor === undefined
                            ? 0
                            : cal_length(components.geared_motor)
                    const mini_geared_motor =
                        components.mini_geared_motor === undefined
                            ? 0
                            : cal_length(components.mini_geared_motor)
                    if (
                        (components.dc_motor === undefined
                            ? true
                            : components.dc_motor.length == 0) &&
                        (components.dynamex_motor === undefined
                            ? true
                            : components.dynamex_motor.length == 0) &&
                        (components.geared_motor === undefined
                            ? true
                            : components.geared_motor.length == 0) &&
                        (components.mini_geared_motor === undefined
                            ? true
                            : components.mini_geared_motor.length == 0) &&
                        (components.servo_motor !== undefined ||
                            components.servo_motor_270 !== undefined ||
                            components.servo_motor_360 !== undefined)
                    ) {
                        if (
                            !(
                                servo_motor +
                                    servo_motor_270 +
                                    servo_motor_360 <
                                14
                            )
                        ) {
                            return 0
                        } else {
                            return 1.4
                        }
                    } else if (
                        ((components.dc_motor === undefined
                            ? false
                            : components.dc_motor.length != 0) ||
                            (components.dynamex_motor === undefined
                                ? false
                                : components.dynamex_motor.length != 0) ||
                            (components.geared_motor === undefined
                                ? false
                                : components.geared_motor.length != 0) ||
                            (components.mini_geared_motor === undefined
                                ? false
                                : components.mini_geared_motor.length != 0)) &&
                        ((components.servo_motor === undefined
                            ? false
                            : components.servo_motor.length != 0) ||
                            (components.servo_motor_360 === undefined
                                ? false
                                : components.servo_motor_360.length != 0) ||
                            (components.servo_motor_270 === undefined
                                ? false
                                : components.servo_motor_270.length != 0))
                    ) {
                        const noMotors =
                            (dc_motor +
                                mini_geared_motor +
                                geared_motor +
                                dynamex_motor) *
                                2 +
                            servo_motor +
                            servo_motor_270 +
                            servo_motor_360
                        if (noMotors == 12) {
                            return 0
                        } else if (noMotors == 11) {
                            if (
                                noMotors % 2 == 1 &&
                                [
                                    'dc_motor',
                                    'geared_motor',
                                    'mini_geared_motor',
                                    'dynamex_motor',
                                ].includes(
                                    sessionStorage.getItem('dragingItem')
                                )
                            ) {
                                return 0
                            } else {
                                return 1.4
                            }
                        } else {
                            return 1.4
                        }
                    } else {
                        return 1.4
                    }
                } else {
                    return 1.4
                }
            } else {
                return 1.4
            }
        }
    }

    render() {
        if (
            ImageSizes[ItemTypes.PORT_CIRCLE][0] /
                (this.props.highlighted ? 1.4 : 0) ==
            'Infinity'
        ) {
            return <circle cx={this.props.left} cy={this.props.top} r={0} />
        } else {
            return (
                <circle
                    cx={this.props.left}
                    cy={this.props.top}
                    r={
                        (ImageSizes[ItemTypes.PORT_CIRCLE][0] /
                            (this.props.highlighted && !this.props.isFinalSlide
                                ? this.renderhighlighted()
                                : 0)) *
                        0.1
                    }
                    style={{ cursor: 'pointer', pointerEvents: 'all' }}
                    onClick={(e) => {
                        e.stopPropagation()
                        if (
                            window.appState &&
                            window.appState.state.activeRgbWire
                        ) {
                            window.appState.connectActivePinToPort(
                                this.props.portName || 'S1'
                            )
                        }
                    }}
                />
            )
        }
    }
}

class ComponentPort extends Component {
    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.PortConnections !== this.props.PortConnections
    }
    render() {
        console.log('konektion', this.props)
        const PortConnections = this.props.PortConnections
        var { left, top } = this.props.component
        left += ImageSizes[ItemTypes.COMPONENT][0] / 2
        return (
            <PortCircle
                appState={this.props.appState}
                PortConnections={PortConnections}
                left={left}
                top={top}
            />
        )
    }
}

const PORT_NAME_MAP = {
    servo_motor1: 'S1',
    servo_motor2: 'S2',
    M3: 'M2',
    
    'M1+': ' ',
    'M1-': ' ',
    'M3+': ' ',
    'M3-': ' ',
    'M+': ' ',
    'M-': ' ',
}

// Board-port key → its `_FULL` port id in PortData. Some pins are referenced by
// their UI name (S1/S2) and some by their internal name (servo_motor1); both
// resolve to the same `_FULL` record that carries the pin coords + line data.
const POKI_FULL_PORT_BY_KEY = {
    S1: 'servo_motor1_FULL',
    S2: 'servo_motor2_FULL',
    servo_motor1: 'servo_motor1_FULL',
    servo_motor2: 'servo_motor2_FULL',
    A1: 'A1_FULL',
    A2: 'A2_FULL',
    C1: 'C1_FULL',
    C2: 'C2_FULL',
    B1: 'B1_FULL',
    B2: 'B2_FULL',
    D1: 'D1_FULL',
    D2: 'D2_FULL',
    M1: 'M1_FULL',
    M3: 'M3_FULL',
    fallbackPins: 'fallbackPins',
    fallbackPins2: 'fallbackPins2',
}

// Safely resolves to a shared power rail header if the current port lacks power lines (+ / -)
const getFallbackPortData = (currentPortFullId, lookupPinKey) => {
    const primaryData = Ports(currentPortFullId)

    // If the pin exists directly on the target header, use it
    if (primaryData?.pins?.[lookupPinKey]) {
        return { portData: primaryData, resolvedPinKey: lookupPinKey }
    }

    // Fallback rule: + / - that the target port doesn't own land on a shared power
    // rail. The dedicated `fallbackPins2` rail is used when a wire was explicitly
    // routed there (the primary `fallbackPins` rail was already taken); everything
    // else collapses onto the primary `fallbackPins` rail.
    if (['+', '-'].includes(lookupPinKey)) {
        const rail =
            currentPortFullId === 'fallbackPins2' ||
            currentPortFullId === 'fallbackPins2_FULL'
                ? 'fallbackPins2'
                : 'fallbackPins'
        return {
            portData: Ports(rail),
            resolvedPinKey: lookupPinKey,
        }
    }

    return { portData: primaryData, resolvedPinKey: lookupPinKey }
}

// Resolve which board _FULL port + pin-key a component pin's WIRE should visually
// attach to. `assignedPort` is the bare port stored in pinConnections — and on
// AUTO-DROP that single value is shared by every pin (it's just `connectedTo`),
// which is why a multi-signal-pin component used to collapse all its signal wires
// onto one port. Resolution rules:
//   • Power pins (+ / -): no allowedTargets → keep assignedPort; getFallbackPortData
//     handles the +/- rail fallback downstream.
//   • Signal pin whose allowedTargets INCLUDE the dropped port → draw there
//     (manual wiring and single-signal components hit this; behaviour unchanged).
//   • Signal pin with exactly ONE allowedTarget that ISN'T the dropped port →
//     draw to that one target. This is what lets a component split its signal pins
//     across different ports on auto-drop (e.g. IMU: E1→E1_FULL, E2→E2_FULL) even
//     though every pin shares the same stored connectedTo. To add another such
//     component, give each signal pin a single-entry allowedTargets[ByDevice].
// Returns { fullPortId, lookupKey } ready for getFallbackPortData.
const resolvePinVisualTarget = (pinKey, pinMeta, assignedPort, device) => {
    let lookupKey = pinMeta.targetPinKey || pinKey
    let fullPortId = assignedPort + '_FULL'
    const allowedTargets = getAllowedTargets(pinMeta, device)
    if (allowedTargets && allowedTargets.length) {
        const exactMatch = allowedTargets.find((t) => t.pinKey === assignedPort)
        if (exactMatch) {
            return { fullPortId: exactMatch.portId, lookupKey: exactMatch.pinKey }
        }

        const match = allowedTargets.find(
            (t) => t.portId === assignedPort + '_FULL'
        )
        const chosen =
            match || (allowedTargets.length === 1 ? allowedTargets[0] : null)
        if (chosen) {
            lookupKey = chosen.pinKey
            fullPortId = chosen.portId
        }
    }
    return { fullPortId, lookupKey }
}

// Renders a grouped socket's special hint. The blob adapts to `activeKey`, drawing
// circles at their own circles.pos (never a fixed position):
//   • group PARENT (E / F) — or no activeKey — draws the WHOLE blob: every alias
//     circle at its own circles.pos, sharing the parent's decorative path. Used when
//     a component targets the socket as a whole (I2C).
//   • a specific alias (E1 / E2 / F1 / F2) draws ONLY that alias's circle at its own
//     circles.pos, plus that alias's own path (the tutorial's target alias).
// Pass onClickKey to make the circle(s) interactive (re-route); omit for a passive
// preview. Geometry comes straight from the GROUP_BLOBS entry.
const renderGroupBlob = ({ key, bibox, blob, activeKey, opacity, onClickKey }) => {
    const isParent = !activeKey || activeKey === blob.members[0]
    // The alias whose path draws. Full-blob (parent) uses the parent's path; a single
    // alias uses its own. Fall back to the first member for anything unexpected.
    const pathKey = blob.paths[activeKey] ? activeKey : blob.members[0]
    const circlesToDraw = isParent
        ? blob.circles
        : blob.circles.filter((c) => c.key === activeKey)

    const d = blob.paths[pathKey]
        .map(
            (p, i) =>
                `${i === 0 ? 'M' : 'L'} ${bibox.left + p[0]},${bibox.top + p[1]}`
        )
        .join(' ')

    const xs = circlesToDraw.map((c) => c.pos[0])
    const ys = circlesToDraw.map((c) => c.pos[1])

    const circleRadius = 8
    const padding = 8

    const minX = Math.min(...xs) - circleRadius - padding
    const maxX = Math.max(...xs) + circleRadius + padding

    const minY = Math.min(...ys) - circleRadius - padding
    const maxY = Math.max(...ys) + circleRadius + padding

    const width = maxX - minX
    const height = maxY - minY

    return (
        <g key={key} opacity={opacity}>
            <path d={d} stroke="green" strokeWidth="1" fill="none" />
            <rect
                x={bibox.left + minX}
                y={bibox.top + minY}
                width={width}
                height={height}
                rx={height / 2}
                ry={height / 2}
                fill="#e7e7e7"
                stroke="#ffffff"
                strokeWidth="3"
                filter="url(#blobShadow)"
            />
            {circlesToDraw.map((c) => {
                const cx = bibox.left + c.pos[0]
                const cy = bibox.top + c.pos[1]
                return (
                    <g key={c.key}>
                        <circle
                            cx={cx}
                            cy={cy}
                            r={10}
                            stroke="black"
                            strokeWidth="1"
                            fill="black"
                            style={{
                                cursor: onClickKey ? 'pointer' : 'default',
                                pointerEvents: onClickKey ? 'all' : 'none',
                            }}
                            onClick={
                                onClickKey
                                    ? (e) => {
                                          e.stopPropagation()
                                          onClickKey(c.key)
                                      }
                                    : undefined
                            }
                        />
                        <text
                            x={cx}
                            y={cy + 5}
                            fontSize="14"
                            fontWeight="bold"
                            fontFamily="sans-serif"
                            fill="white"
                            textAnchor="middle"
                            pointerEvents="none"
                        >
                            {c.label}
                        </text>
                    </g>
                )
            })}
        </g>
    )
}

// Renders one Poki pin "hint": the 3 green extended-wire segments (only when the
// target pin has line data — signal pins don't) plus the black badge circle and
// its label. Shared by the connected-pin persistence and the drag-time preview
// so both look identical to the routing hints drawn inline by renderHint.
// Pass onClick to make the badge interactive; omit it for a passive preview
// (pointerEvents:none so it never intercepts a drag/drop).
const renderPokiHintBadge = ({
    key,
    bibox,
    pinCoords,
    lineData,
    displayLabel,
    opacity,
    onClick,
}) => {
    const hintX = bibox.left + pinCoords[0]
    const hintY = bibox.top + pinCoords[1]
    const line1EndX = lineData ? bibox.left + lineData.line1End[0] : hintX
    const line1EndY = lineData ? bibox.top + lineData.line1End[1] : hintY
    const line2EndX = lineData ? bibox.left + lineData.line2End[0] : hintX
    const line2EndY = lineData ? bibox.top + lineData.line2End[1] : hintY
    return (
        <g key={key} opacity={opacity}>
            {lineData && (
                <>
                    <path
                        d={`M ${hintX},${hintY} L ${line1EndX},${line1EndY}`}
                        stroke="red"
                        strokeWidth="1"
                        fill="none"
                    />
                    <path
                        d={`M ${line1EndX},${line1EndY} L ${line1EndX},${line2EndY}`}
                        stroke="red"
                        strokeWidth="1"
                        fill="none"
                    />
                    <path
                        d={`M ${line1EndX},${line2EndY} L ${line2EndX},${line2EndY}`}
                        stroke="red"
                        strokeWidth="1"
                        fill="none"
                    />
                </>
            )}
            <circle
                cx={hintX}
                cy={hintY}
                r={10}
                stroke="black"
                strokeWidth="1"
                fill="black"
                style={{
                    cursor: onClick ? 'pointer' : 'default',
                    pointerEvents: onClick ? 'all' : 'none',
                }}
                onClick={onClick || undefined}
            />
            <text
                x={hintX}
                y={hintY + 5}
                fontSize="14"
                fontWeight="bold"
                fontFamily="sans-serif"
                fill="white"
                textAnchor="middle"
                pointerEvents="none"
            >
                {displayLabel}
            </text>
        </g>
    )
}

class Connections extends Component {
    getPortHighlightStatus({
        port,
        PortConnections,
        highlighted,
        connectedDevice,
    }) {
        // highlighted =
        // PortConnections[port] == null
        //     ? !PortConnections[port] && highlighted
        //     : sessionStorage.getItem('dragingItem') != 'pc_motor_driver'
        //     ? PortConnections[port].notDriverMotot == 'notConnectedDriverMotor'
        //         ? true && highlighted
        //         : !PortConnections[port] && highlighted
        //     : !PortConnections[port] && highlighted

        const connection = PortConnections[port]
        const draggingItem = sessionStorage.getItem('dragingItem')

        // Grouped sockets (e.g. Poki E/E1/E2, F/F1/F2): if a SIBLING alias is
        // already taken, this port can't be highlighted as available even though
        // its own slot is empty. The connected alias itself falls through to the
        // normal logic below. See PortGroups.js.
        if (
            connection == null &&
            isPortGroupOccupied(connectedDevice, port, PortConnections)
        ) {
            return false
        }

        // If no connection exists
        if (connection == null) {
            return highlighted
        }
        // When dragging item is NOT pc_motor_driver
        if (draggingItem !== 'pc_motor_driver') {
            if (
                connection.notDriverMotot === 'notConnectedDriverMotor' ||
                (connectedDevice === 'Poki' &&
                    ['Magnetometer', 'Color_sensor', 'IMU'].includes(
                        draggingItem
                    ))
            ) {
                return highlighted
            }

            return false
        }

        // When dragging item IS pc_motor_driver
        return highlighted ?? false
    }
    render() {
        const {
            bibox,
            components,
            extraComponent,
            Camera,
            PortConnections,
            allowedPortTypeData,
            highlightPort,
            isFinalSlide,
        } = this.props
        console.log('konektion', this.props)
        console.log('port', Ports('A1'))
        let connectedDevice = sessionStorage.getItem('connectedDevice')
        if (
            ![
                'Ace',
                'Humanoid',
                'Hexapod',
                'Roboki',
                'Klaw',
                'Toki',
                'Poki',
                'Atr',
                'Moki',
            ].includes(connectedDevice)
        ) {
            connectedDevice = 'Ace'
        }
        let shield = JSON.parse(sessionStorage.getItem('shield')) || false
        let armShield = JSON.parse(sessionStorage.getItem('armShield')) || false
        let peeCeeATR = JSON.parse(sessionStorage.getItem('peeCeeATR')) || false

        let deviceVersion = sessionStorage.getItem('deviceVersion')

        let internalAccessoriesData = JSON.parse(
            sessionStorage.getItem('concept')
        ).internalaccessories

        let CameraOffsetLeft = this.props.Camera.offset.left
        let CameraOffsetTop = this.props.Camera.offset.top

        if (localStorage.getItem('programMode') == 'learn') {
            var PortConnectionsTutor = JSON.parse(
                sessionStorage.getItem('tutorialPort')
            )
            //  var AllowedPortTypesTutor = AllowedPortTypes
            var AllowedPortTypesTutor = {}
            Object.entries(PortConnectionsTutor).map(([key, value]) => {
                if (AllowedPortTypesTutor[value]) {
                    AllowedPortTypesTutor[value].push(key)
                } else {
                    AllowedPortTypesTutor[value] = [key]
                }
            })
        } else {
            // var PortConnectionsTutor = JSON.parse(sessionStorage.getItem("tutorialPort"))
            var AllowedPortTypesTutor = allowedPortTypeData

            // if (shield != false) {
            //     AllowedPortTypesTutor =
            //         AllowedPortTypes[`SHIELD${deviceVersion.slice(0, 1)}`]
            // } else if (peeCeeATR != false) {
            //     AllowedPortTypesTutor =
            //         AllowedPortTypes[`PEECEEATR${deviceVersion.slice(0, 1)}`]
            // } else if (armShield) {
            //     AllowedPortTypesTutor =
            //         AllowedPortTypes[`ARMSHIELD${deviceVersion.slice(0, 1)}`]
            // } else {
            //     AllowedPortTypesTutor =
            //         AllowedPortTypes[
            //             `${connectedDevice.toUpperCase()}${deviceVersion.slice(
            //                 0,
            //                 1
            //             )}`
            //         ]
            // }

            // var AllowedPortTypesTutor = {}
            Object.entries(PortConnections).map(
                ([key, value]) => (AllowedPortTypesTutor[value] = [key])
            )
        }
        var Left
        var Top
        var connections = []
        var portCircles = []

        // ** cHECHING THE CONNECTED PORT  return the type of motor connected on the port **
        let isMotorConnected_BD = () => {
            if (
                JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.STPM !== null
            ) {
                let value = JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.STPM.type
                return value
            }

            if (
                JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.B1 !== null
            ) {
                let value = JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.B1.type
                return value
            }

            if (
                JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.B2 !== null
            ) {
                let value = JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.B2.type
                return value
            }

            if (
                JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.D1 !== null
            ) {
                let value = JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.D1.type
                return value
            }
            if (
                JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.D2 !== null
            ) {
                let value = JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.D2.type
                return value
            }
        }

        let isMotorConnected_AC = () => {
            if (
                JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.STPM !== null
            ) {
                let value = JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.STPM.type
                return value
            }

            if (
                JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.A1 !== null
            ) {
                let value = JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.A1.type
                return value
            }

            if (
                JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.A2 !== null
            ) {
                let value = JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.A2.type
                return value
            }

            if (
                JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.C1 !== null
            ) {
                let value = JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.C1.type
                return value
            }
            if (
                JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.C2 !== null
            ) {
                let value = JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.C2.type
                return value
            }
        }

        /*
        RETURN THE PORT WHERE PC_MOTOR_DIRVER is CONNECTED
     */
        let isPc_motor_driverConnected_BD_AC = () => {
            if (
                JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.B != null
            ) {
                if (
                    JSON.parse(sessionStorage.getItem('assemblyTwo'))
                        .PortConnections.B.type == 'pc_motor_driver'
                ) {
                    return 'B'
                }
            }
            if (
                JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.D != null
            ) {
                if (
                    JSON.parse(sessionStorage.getItem('assemblyTwo'))
                        .PortConnections.D.type == 'pc_motor_driver'
                ) {
                    return 'D'
                }
            }
            if (
                JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.A != null
            ) {
                if (
                    JSON.parse(sessionStorage.getItem('assemblyTwo'))
                        .PortConnections.A.type == 'pc_motor_driver'
                ) {
                    return 'A'
                }
            }
            if (
                JSON.parse(sessionStorage.getItem('assemblyTwo'))
                    .PortConnections.C != null
            ) {
                if (
                    JSON.parse(sessionStorage.getItem('assemblyTwo'))
                        .PortConnections.C.type == 'pc_motor_driver'
                ) {
                    return 'C'
                }
            }
        }

        // only for ge

        Object.keys(components).map((key) => {
            components[key].map((component, index) => {
                const { connectedTo } = component
                console.log('component connectedTo', component)
                var sdarafs = component

                const isBeingDragged =
                    DraggingInfo.isDragging &&
                    DraggingInfo.draggingComponentOld &&
                    DraggingInfo.draggingComponentOld.type === key &&
                    DraggingInfo.draggingComponentOld.index === index

                console.log('isBeingDragged', isBeingDragged)

                // WHEN we connect the components to port commectedTO will be the port
                if (connectedTo) {
                    connections.push(
                        <Curve
                            bibox={bibox}
                            component={component}
                            componentName={key}
                            components={components}
                            key={`curve-${key}-${index}`}
                            style={{ zIndex: -1 }}
                            PortConnections={PortConnections}
                            shield={this.props.shield}
                            armShield={this.props.armShield}
                            peeCeeATR={this.props.peeCeeATR}
                            isDragging={isBeingDragged}
                        />
                    )
                    // }
                }

                if (
                    !(
                        DraggingInfo.isDragging &&
                        DraggingInfo.draggingComponentOld &&
                        key == DraggingInfo.draggingComponentOld.type &&
                        index === DraggingInfo.draggingComponentOld.index
                    )
                ) {
                    let keyData = key
                    // PPP

                    portCircles.push(
                        <ComponentPort
                            PortConnections={PortConnections}
                            component={component}
                            key={`portCircle-${key}-${index}`}
                            appState={this.props.appState}
                        />
                    )
                }
            })
        })

        const isBeingDragged =
            DraggingInfo.isDragging && DraggingInfo.draggingComponentOld

        if (extraComponent) {
            if (extraComponent.connectedTo) {
                connections.push(
                    <Curve
                        bibox={bibox}
                        component={extraComponent}
                        components={components}
                        key={`curve-extra-${extraComponent.type}`}
                        componentName={extraComponent.type}
                        PortConnections={PortConnections}
                        shield={this.props.shield}
                        armShield={this.props.armShield}
                        peeCeeATR={this.props.peeCeeATR}
                        isDragging={isBeingDragged}
                    />
                )
            }
            console.log('konekkk', extraComponent)
            portCircles.push(
                <ComponentPort
                    PortConnections={PortConnections}
                    component={extraComponent}
                    key={`portCircle-${extraComponent.type}`}
                />
            )
        }

        // === MODULAR MAGNIFIER ENGINE FLOW ===
        // Single source of truth for Toki multi-pin wires: each instance's per-pin
        // `pinConnections`. We draw a static wire for every connected pin (whether the
        // component was dropped-on-port or wired manually) plus the live wire for the
        // pin currently being routed from the cursor.
        if (window.appState && ['Toki', 'Poki'].includes(connectedDevice)) {
            const { activeRgbWire, mouseX, mouseY, activeRgbComponent } =
                window.appState.state

            Object.keys(components).forEach((compKey) => {
                const config = getHardwareWireConfig(compKey, connectedDevice)
                if (config) {
                    components[compKey].forEach((componentInstance, idx) => {
                        // While this instance is being dragged, its stored left/top are
                        // stale (they only update on drop) and `removeConnection` has
                        // cleared its `connectedTo`. Mirror what single-wire components do:
                        // use the live cursor-tracked position + port from `extraComponent`
                        // so the whole wire bundle recalculates and follows the component.
                        const isBeingDragged =
                            DraggingInfo.isDragging &&
                            DraggingInfo.draggingComponentOld &&
                            DraggingInfo.draggingComponentOld.type ===
                                compKey &&
                            DraggingInfo.draggingComponentOld.index === idx

                        // Per-pin map is the source of truth. Legacy/restored components
                        // may only have `connectedTo` (no pinConnections) — treat those as
                        // every pin wired to that port so their wires still render. During a
                        // drag the live port comes from DraggingInfo.newComponentPort since
                        // `connectedTo` was cleared on drag start.
                        let pinConnections = componentInstance.pinConnections
                        const fallbackPort = isBeingDragged
                            ? DraggingInfo.newComponentPort
                            : componentInstance.connectedTo
                        if (
                            isBeingDragged &&
                            connectedDevice === 'Poki' &&
                            fallbackPort
                        ) {
                            // Live preview: the stored pinConnections still point at
                            // the OLD port (removeConnection only cleared connectedTo),
                            // so recompute against current occupancy — excluding this
                            // instance — exactly as the drop handler will. This makes
                            // the + / - wires preview their real target pin instead of
                            // the stale one.
                            const preview = computeAutoDropPinConnections(
                                Ports,
                                compKey,
                                fallbackPort,
                                connectedDevice,
                                components,
                                { type: compKey, index: idx }
                            )
                            // Invalid drop (a required + / - has no free slot) →
                            // show no wires at all.
                            pinConnections =
                                preview && preview.allConnected
                                    ? preview.pinConnections
                                    : {}
                        } else if (
                            (!pinConnections ||
                                Object.keys(pinConnections).length === 0) &&
                            fallbackPort
                        ) {
                            pinConnections = {}
                            Object.keys(config.pins).forEach((pk) => {
                                pinConnections[pk] = fallbackPort
                            })
                        }
                        pinConnections = pinConnections || {}
                        const rl =
                            isBeingDragged && extraComponent
                                ? extraComponent.left
                                : componentInstance.left
                        const rt =
                            isBeingDragged && extraComponent
                                ? extraComponent.top
                                : componentInstance.top
                        const startX =
                            rl - 10 + ImageSizes[ItemTypes.COMPONENT][0] / 2
                        const startY = rt + 85
                        const cx1base =
                            rl + ImageSizes[ItemTypes.COMPONENT][0] / 2
                        const cy1base =
                            rt + 2 * ImageSizes[ItemTypes.COMPONENT][1]

                        // Draw established connection lines from this instance's pins
                        Object.entries(config.pins).forEach(
                            ([pinKey, pinMeta]) => {
                                const assignedPort = pinConnections[pinKey]
                                if (assignedPort) {
                                    // Resolve which board port + pin this wire draws
                                    // to. For a multi-signal-pin component the stored
                                    // assignedPort is the SAME for every pin (the
                                    // shared connectedTo), so the resolver redirects
                                    // each signal pin to its own allowedTarget (e.g.
                                    // IMU E1→E1_FULL, E2→E2_FULL).
                                    const { fullPortId, lookupKey } =
                                        resolvePinVisualTarget(
                                            pinKey,
                                            pinMeta,
                                            assignedPort,
                                            connectedDevice
                                        )
                                    const {
                                        portData: fullPortData,
                                        resolvedPinKey,
                                    } = getFallbackPortData(
                                        fullPortId,
                                        lookupKey
                                    )
                                    const pinCoords =
                                        fullPortData?.pins?.[resolvedPinKey]
                                    const visualPort = fullPortId.replace(
                                        '_FULL',
                                        ''
                                    )

                                    const ex = pinCoords
                                        ? bibox.left + pinCoords[0]
                                        : bibox.left +
                                          (Ports(visualPort)?.[0] || 0)
                                    const ey = pinCoords
                                        ? bibox.top + pinCoords[1]
                                        : bibox.top +
                                          (Ports(visualPort)?.[1] || 0)

                                    const pathString = computeModularWirePath({
                                        startX,
                                        startY,
                                        cx1: cx1base,
                                        cy1: cy1base,
                                        endX: ex,
                                        endY: ey,
                                        offsetWire: pinMeta.offsetWire,
                                        flatLength:
                                            fullPortData?.flatLength ??
                                            config.flatLength,
                                        verticalLength:
                                            fullPortData?.verticalLength ??
                                            config.verticalLength,
                                    }).d

                                    connections.push(
                                        <path
                                            key={`mag-static-${compKey}-${idx}-${pinKey}`}
                                            stroke={pinMeta.stroke}
                                            strokeWidth="3px"
                                            fill="none"
                                            d={pathString}
                                        />
                                    )
                                }
                            }
                        )

                        // Draw real-time dynamic cursor trailing path — only for the
                        // instance whose pin is actively being routed.
                        if (
                            activeRgbWire &&
                            activeRgbComponent &&
                            activeRgbComponent.type === compKey &&
                            activeRgbComponent.index === idx &&
                            config.pins[activeRgbWire] &&
                            !pinConnections[activeRgbWire]
                        ) {
                            const activePinMeta = config.pins[activeRgbWire]
                            const navH =
                                document.getElementById('make-main-header')
                                    ?.offsetHeight || Sizes.navHeight
                            const worldMX =
                                (mouseX - Sizes.sidebarWidth) / Camera.scale -
                                Camera.offset.left
                            const worldMY =
                                (mouseY - navH) / Camera.scale -
                                Camera.offset.top

                            const livePathString = computeModularWirePath({
                                startX,
                                startY,
                                cx1: cx1base,
                                cy1: cy1base,
                                endX: worldMX,
                                endY: worldMY,
                                offsetWire: activePinMeta.offsetWire,
                                flatLength: config.flatLength,
                                verticalLength: config.verticalLength
                            }).d

                            connections.push(
                                <path
                                    key={`mag-dynamic-${compKey}-${idx}`}
                                    stroke={activePinMeta.stroke}
                                    strokeWidth="3px"
                                    fill="none"
                                    d={livePathString}
                                />
                            )
                        }
                    })
                }
            })

            // Live preview for a NEW 3-wire component dragged in from the sidebar.
            // It isn't in `components` yet, so the loop above can't draw it (existing
            // components being re-dragged are handled there via DraggingInfo). Mirror
            // the single-wire `extraComponent` Curve: while hovering a valid port, draw
            // the full pin bundle from the live cursor position to that port — so the
            // wires show during the drag instead of only after release.
            if (
                extraComponent &&
                !DraggingInfo.draggingComponentOld &&
                extraComponent.connectedTo &&
                getHardwareWireConfig(extraComponent.type, connectedDevice)
            ) {
                const config = getHardwareWireConfig(
                    extraComponent.type,
                    connectedDevice
                )
                const rl = extraComponent.left
                const rt = extraComponent.top
                const startX = rl - 10 + ImageSizes[ItemTypes.COMPONENT][0] / 2
                const startY = rt + 85
                const cx1base = rl + ImageSizes[ItemTypes.COMPONENT][0] / 2
                const cy1base = rt + 2 * ImageSizes[ItemTypes.COMPONENT][1]

                // Poki AND Toki: compute the SAME per-pin routing the drop will use,
                // so the live + / - wires preview their real free target pin
                // (accounting for occupancy) instead of stacking onto the hover
                // port's already-taken pin. Without this the drag preview shows e.g.
                // a second + on a + pin that's already wired, even though the drop
                // (workspace.newComponent) correctly reroutes it. New sidebar
                // component isn't in `components` yet → no skip needed.
                const previewAuto =
                    connectedDevice === 'Poki' || connectedDevice === 'Toki'
                        ? computeAutoDropPinConnections(
                              Ports,
                              extraComponent.type,
                              extraComponent.connectedTo,
                              connectedDevice,
                              components,
                              null
                          )
                        : null

                Object.entries(config.pins).forEach(([pinKey, pinMeta]) => {
                    // Invalid Poki drop (a required + / - has no free slot) → the
                    // drop will be rejected, so draw no preview wires at all.
                    if (previewAuto && !previewAuto.allConnected) return
                    // Dropping a fresh component on a port wires every pin to it
                    // (see workspace.newComponent); for Poki the + / - resolve to a
                    // free pin instead. null → no free slot, so skip that wire.
                    const assignedPort = previewAuto
                        ? previewAuto.pinConnections[pinKey]
                        : extraComponent.connectedTo
                    if (!assignedPort) return
                    // Same per-pin resolution as the established wire bundle, so a
                    // multi-signal-pin component (e.g. IMU E1/E2) previews each
                    // signal wire to its own port instead of all onto connectedTo.
                    const { fullPortId, lookupKey } = resolvePinVisualTarget(
                        pinKey,
                        pinMeta,
                        assignedPort,
                        connectedDevice
                    )
                    // Poki ports without their own +/- pins (e.g. F1) route the
                    // power wires to the shared fallback rail, exactly like an
                    // established connection (see getFallbackPortData above). The
                    // live sidebar-drag preview must do the same so the +/- wires
                    // land on the rail WHILE dragging — not only after release.
                    // Toki keeps its direct port lookup unchanged.
                    const { portData: fullPortData, resolvedPinKey } =
                        connectedDevice === 'Poki'
                            ? getFallbackPortData(fullPortId, lookupKey)
                            : {
                                  portData: Ports(fullPortId),
                                  resolvedPinKey: lookupKey,
                              }
                    const pinCoords = fullPortData?.pins?.[resolvedPinKey]
                    const visualPort = fullPortId.replace('_FULL', '')
                    const ex = pinCoords
                        ? bibox.left + pinCoords[0]
                        : bibox.left + (Ports(visualPort)?.[0] || 0)
                    const ey = pinCoords
                        ? bibox.top + pinCoords[1]
                        : bibox.top + (Ports(visualPort)?.[1] || 0)

                    const pathString = computeModularWirePath({
                        startX,
                        startY,
                        cx1: cx1base,
                        cy1: cy1base,
                        endX: ex,
                        endY: ey,
                        offsetWire: pinMeta.offsetWire,
                        flatLength:
                            fullPortData?.flatLength ?? config.flatLength,
                        verticalLength:
                            fullPortData?.verticalLength ?? config.verticalLength,
                    }).d

                    connections.push(
                        <path
                            key={`mag-preview-${extraComponent.type}-${pinKey}`}
                            stroke={pinMeta.stroke}
                            strokeWidth="3px"
                            fill="none"
                            d={pathString}
                        />
                    )
                })
            }
        }

        //get the top value for hover red circle in draging time
        const getTopValueRedCircle = (port, Top, Ports, draggingItem) => {
            const isDeviceVersion12 =
                (['1', '2', '3'].includes(deviceVersion[0]) &&
                    ['Ace', 'Humanoid', 'Hexapod'].includes(Device)) ||
                ['Roboki', 'Klaw', 'Atr', 'Toki', 'Poki', 'Moki'].includes(
                    Device
                )

            if (
                isDeviceVersion12 &&
                [
                    'mini_geared_motor',
                    'geared_motor',
                    'dc_motor',
                    'dynamex_motor',
                ].includes(draggingItem) &&
                !['M1', 'M2', 'M3', 'M4', 'H1', 'I1', 'G', 'H'].includes(port)
            ) {
                if (
                    (['Toki'].includes(Device) &&
                        ['C1', 'C2', 'D1'].includes(port)) ||
                    (Device == 'Atr' && ['D1'].includes(port))
                ) {
                    return Top + Ports(port)[1]
                } else return Top + Ports(port)[1] + 25
            } else return Top + Ports(port)[1]
        }

        return (
            <div
                id="connectPort"
                style={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 2,
                    pointerEvents: 'none',
                }}
            >
                <svg height="100%" width="100%">
                    <defs>
                        <filter
                            id="blobShadow"
                            x="-50%"
                            y="-50%"
                            width="200%"
                            height="200%"
                        >
                            <feDropShadow
                                dx="0"
                                dy="2"
                                stdDeviation="2"
                                floodColor="#000"
                                floodOpacity="0.15"
                            />
                        </filter>
                    </defs>

                    {/* id "assembly-wire-camera-g": the board-port magnifier loupe
                        (Component.js) renders a live, auto-updating zoomed copy of the
                        wires via <use href="#assembly-wire-camera-g">. The camera matrix
                        lives on this group, so the referenced copy is already in screen
                        space. */}
                    <g
                        id="assembly-wire-camera-g"
                        transform={
                            'matrix(' +
                            Camera.scale +
                            ' ' +
                            '0 0 ' +
                            Camera.scale +
                            ' ' +
                            Camera.offset.left * Camera.scale +
                            ' ' +
                            Camera.offset.top * Camera.scale +
                            ')'
                        }
                    >
                        <g stroke="#4d4d4d" strokeWidth="4px" fill="none">
                            {connections}
                        </g>
                        <g stroke="black" strokeWidth="4px" fill="white">
                            {portCircles}
                        </g>

                        {/* Highlight the target port from assembly steps */}
                        {highlightPort && Ports(highlightPort) && (
                            <circle
                                cx={bibox.left + Ports(highlightPort)[0]}
                                cy={bibox.top + Ports(highlightPort)[1]}
                                r="12"
                                stroke={
                                    connectedDevice == 'Poki' ? 'red' : 'red'
                                }
                                strokeWidth="2"
                                fill={
                                    connectedDevice == 'Poki' ? 'red' : 'red'
                                }
                                fillOpacity="0.3"
                                opacity="0.8"
                            >
                                <animate
                                    attributeName="r"
                                    values="15;20;15"
                                    dur="1.5s"
                                    repeatCount="indefinite"
                                />
                                <animate
                                    attributeName="opacity"
                                    values="0.8;1;0.8"
                                    dur="1.5s"
                                    repeatCount="indefinite"
                                />
                            </circle>
                        )}

                        {/* Poki only: while a wire is actively following the
                            cursor (activeRgbWire set), also highlight the exact
                            target SIGNAL pin inside the highlighted port. Coords
                            come from PortData's *_FULL.pins. Never highlight the
                            + / - power pins. This disappears automatically once
                            the wire connects or follow mode ends, because
                            activeRgbWire is cleared then. */}
                        {connectedDevice === 'Poki' &&
                            highlightPort &&
                            window.appState &&
                            window.appState.state.activeRgbWire &&
                            (() => {
                                // On Poki, activeRgbWire stays set even AFTER the
                                // pin is dropped on a port (so the placed hint
                                // persists). So "wire is following the cursor"
                                // really means the active pin isn't connected yet
                                // — same gate the live cursor path uses. If it's
                                // already connected, don't show the pin highlight.
                                const {
                                    activeRgbWire,
                                    activeRgbComponent,
                                } = window.appState.state

                                // Only show the circle if the wire being dragged is a signal wire (not + or -)
                                if (activeRgbWire === '+' || activeRgbWire === '-')
                                    return null

                                // Whole-socket components (OLED/IMU/Color_sensor)
                                // get a per-alias group-blob circle highlight in the
                                // dedicated block below, so skip the generic _FULL-pin
                                // highlight here to avoid a doubled marker.
                                if (
                                    getWholeSocketParent(
                                        activeRgbComponent?.type,
                                        connectedDevice,
                                        getPortGroup
                                    )
                                )
                                    return null

                                if (activeRgbComponent) {
                                    const inst =
                                        components[activeRgbComponent.type]?.[
                                            activeRgbComponent.index
                                        ]
                                    if (inst?.pinConnections?.[activeRgbWire])
                                        return null
                                }
                                const fullPort = Ports(highlightPort + '_FULL')
                                if (!fullPort || !fullPort.pins) return null
                                return Object.entries(fullPort.pins)
                                    .filter(
                                        ([pinKey]) =>
                                            pinKey !== '+' && pinKey !== '-'
                                    )
                                    .map(([pinKey, coords]) => (
                                        <circle
                                            key={`pin-highlight-${highlightPort}-${pinKey}`}
                                            cx={bibox.left + coords[0]}
                                            cy={bibox.top + coords[1]}
                                            r="12"
                                            stroke="red"
                                            strokeWidth="2"
                                            fill="red"
                                            fillOpacity="0.8"
                                            opacity="0.8"
                                        >
                                            <animate
                                                attributeName="r"
                                                values="10;16;10"
                                                dur="1.5s"
                                                repeatCount="indefinite"
                                            />
                                            <animate
                                                attributeName="opacity"
                                                values="0.8;1;0.8"
                                                dur="1.5s"
                                                repeatCount="indefinite"
                                            />
                                        </circle>
                                    ))
                            })()}

                        {/* Poki: while routing a wire of a whole-socket component
                            (OLED / IMU / Color_sensor — they wire E1 + E2 into the one
                            E socket), pulse a red highlight on the exact group-blob
                            circle for the alias being routed (E1 → its 22,165 circle,
                            E2 → its 52,165 circle) so the user sees which circle to drop
                            on. Independent of the tutorial highlightPort so it also
                            works in the free sandbox flow. */}
                        {connectedDevice === 'Poki' &&
                            window.appState &&
                            window.appState.state.activeRgbWire &&
                            window.appState.state.activeRgbComponent &&
                            (() => {
                                const { activeRgbWire, activeRgbComponent } =
                                    window.appState.state
                                if (
                                    activeRgbWire === '+' ||
                                    activeRgbWire === '-'
                                )
                                    return null
                                // Whole-socket components only.
                                if (
                                    !getWholeSocketParent(
                                        activeRgbComponent.type,
                                        connectedDevice,
                                        getPortGroup
                                    )
                                )
                                    return null
                                // The wire must still be following the cursor (not yet
                                // wired) — on Poki activeRgbWire lingers after a drop.
                                const inst =
                                    components[activeRgbComponent.type]?.[
                                        activeRgbComponent.index
                                    ]
                                if (inst?.pinConnections?.[activeRgbWire])
                                    return null
                                // The board alias this pin targets, and its circle in
                                // the group blob.
                                const config =
                                    HardwareWireConfigs[activeRgbComponent.type]
                                const pinMeta = config?.pins?.[activeRgbWire]
                                const targets = getAllowedTargets(
                                    pinMeta,
                                    connectedDevice
                                )
                                const alias =
                                    targets && targets.length === 1
                                        ? targets[0].pinKey
                                        : null
                                if (!alias) return null
                                const blob = getGroupBlob(connectedDevice, alias)
                                const circle = blob?.circles.find(
                                    (c) => c.key === alias
                                )
                                if (!circle) return null
                                return (
                                    <circle
                                        key={`whole-socket-highlight-${alias}`}
                                        cx={bibox.left + circle.pos[0]}
                                        cy={bibox.top + circle.pos[1]}
                                        r="12"
                                        stroke="red"
                                        strokeWidth="2"
                                        fill="red"
                                        fillOpacity="0.8"
                                        opacity="0.8"
                                    >
                                        <animate
                                            attributeName="r"
                                            values="10;16;10"
                                            dur="1.5s"
                                            repeatCount="indefinite"
                                        />
                                        <animate
                                            attributeName="opacity"
                                            values="0.8;1;0.8"
                                            dur="1.5s"
                                            repeatCount="indefinite"
                                        />
                                    </circle>
                                )
                            })()}

                        {/* MODULAR MAGNIFIER HOVER TARGET HIGHLIGHT ENGINE */}
                        {window.appState &&
                            window.appState.state.activeRgbWire &&
                            ['Toki', 'Poki'].includes(connectedDevice) &&
                            (() => {
                                const { activeRgbWire, activeRgbComponent } =
                                    window.appState.state
                                const activeWireKey = activeRgbWire

                                // Always derive config from the ACTIVE component's type so that
                                // components sharing the same pin name (e.g. 'signal') resolve to
                                // their own allowedTargets rather than whichever type comes first.
                                const config =
                                    activeRgbComponent &&
                                    HardwareWireConfigs[activeRgbComponent.type]
                                if (!config || !config.pins[activeWireKey])
                                    return null

                                const pinMeta = config.pins[activeWireKey]
                                const circleStroke = pinMeta.stroke
                                const circleFill = `${pinMeta.stroke}44`

                                // Poki: this block draws the routing drop-targets at
                                // EVERY candidate port for the active pin. Once that
                                // pin is actually wired to a port, its hint belongs to
                                // the persistent block (which shows it only at its real
                                // port), so stop drawing the candidate targets here —
                                // otherwise connecting + would keep lighting up every
                                // port's + pin. Re-routing (startPinWire) clears the
                                // connection first, so the targets show again then.
                                if (
                                    connectedDevice === 'Poki' &&
                                    activeRgbComponent
                                ) {
                                    const activePc =
                                        window.appState.getPinConnections(
                                            activeRgbComponent.type,
                                            activeRgbComponent.index
                                        ) || {}
                                    if (activePc[activeWireKey]) return null
                                }

                                // Build a set of already-occupied board pins from every
                                // component instance's pinConnections, EXCLUDING the instance
                                // whose pin is currently being re-routed (it was disconnected
                                // by startPinWire before the wire started following the cursor).
                                const occupiedPins = new Set()
                                Object.keys(components).forEach((compKey) => {
                                    const cfg = HardwareWireConfigs[compKey]
                                    if (!cfg) return
                                    components[compKey].forEach(
                                        (instance, instIdx) => {
                                            if (
                                                activeRgbComponent &&
                                                activeRgbComponent.type ===
                                                    compKey &&
                                                activeRgbComponent.index ===
                                                    instIdx
                                            )
                                                return
                                            const pc =
                                                instance.pinConnections || {}
                                            Object.entries(cfg.pins).forEach(
                                                ([pk, pm]) => {
                                                    const assignedPort = pc[pk]
                                                    if (!assignedPort) return
                                                    let lk =
                                                        pm.targetPinKey || pk
                                                    const pmAllowedTargets =
                                                        getAllowedTargets(
                                                            pm,
                                                            connectedDevice
                                                        )
                                                    if (pmAllowedTargets) {
                                                        const m =
                                                            pmAllowedTargets.find(
                                                                (t) =>
                                                                    t.portId ===
                                                                    assignedPort +
                                                                        '_FULL'
                                                            )
                                                        if (m) lk = m.pinKey
                                                    }
                                                    occupiedPins.add(
                                                        `${assignedPort}_FULL:${lk}`
                                                    )
                                                }
                                            )
                                        }
                                    )
                                })

                                // Render one hint circle + label. Returns null when the pin is
                                // already occupied by another wire or has no coord data.
                                const renderHint = (
                                    portFullId,
                                    lookupPinKey,
                                    displayLabel,
                                    isPrimary = false
                                ) => {
                                    // === MODIFIED: BYPASS DISAPPEARING REJECTION FOR POKI BOARD ===
                                    if (connectedDevice !== 'Poki') {
                                        if (
                                            occupiedPins.has(
                                                `${portFullId}:${lookupPinKey}`
                                            )
                                        ) {
                                            return null
                                        }
                                    }
                                    // Pull tracking lines and coordinates dynamically from the asset ports or the shared power rail
                                    const { portData, resolvedPinKey } =
                                        getFallbackPortData(
                                            portFullId,
                                            lookupPinKey
                                        )
                                    if (!portData?.pins) return null
                                    const pinCoords =
                                        portData.pins[resolvedPinKey]
                                    if (!pinCoords) return null
                                    const hintX = bibox.left + pinCoords[0]
                                    const hintY = bibox.top + pinCoords[1]

                                    const portName = portFullId.replace(
                                        '_FULL',
                                        ''
                                    )
                                    let opacity = isPrimary ? 1 : 0.75

                                    // === NEW: DETECT IF SIGNAL PIN AND FORCE INVISIBILITY BUT KEEP CLICKABLE ===
                                    {
                                        /* const isInvisibleSignal =
                                        connectedDevice === 'Poki' &&
                                        pinMeta.isSignal
                                    if (isInvisibleSignal) {
                                        opacity = 0 // Pushing opacity to 0 keeps the element rendered and interactive in the DOM tree
                                    } */
                                    }

                                    if (connectedDevice === 'Poki') {
                                        // 1. Safely extract line data. If it doesn't exist (e.g., for signal pins), it will be undefined.
                                        const lineData =
                                            portData.lines?.[lookupPinKey]

                                        // 2. Safely calculate line ends. If lineData is missing, fallback to hintX/hintY to prevent math crashes.
                                        const line1EndX = lineData
                                            ? bibox.left + lineData.line1End[0]
                                            : hintX
                                        const line1EndY = lineData
                                            ? bibox.top + lineData.line1End[1]
                                            : hintY
                                        const line2EndX = lineData
                                            ? bibox.left + lineData.line2End[0]
                                            : hintX
                                        const line2EndY = lineData
                                            ? bibox.top + lineData.line2End[1]
                                            : hintY

                                        console.log(
                                            'line 1: ',
                                            `M ${hintX},${hintY} L ${line1EndX},${line1EndY}`
                                        )
                                        console.log(
                                            'line 2: ',
                                            `M ${line1EndX},${line1EndY} L ${line1EndX},${line2EndY}`
                                        )
                                        console.log(
                                            'line 3: ',
                                            `M ${line1EndX},${line2EndY} L ${line2EndX},${line2EndY}`
                                        )

                                        return (
                                            <g
                                                key={`hint-${portFullId}`}
                                                opacity={opacity}
                                            >
                                                {/* 3 solid red lines indicating which pin it's for */}
                                                {/* 3. Conditionally render the 3 lines ONLY if lineData actually exists */}
                                                {lineData && (
                                                    <>
                                                        <path
                                                            d={`M ${hintX},${hintY} L ${line1EndX},${line1EndY}`}
                                                            stroke="green"
                                                            strokeWidth="1"
                                                            fill="none"
                                                        />
                                                        <path
                                                            d={`M ${line1EndX},${line1EndY} L ${line1EndX},${line2EndY}`}
                                                            stroke="green"
                                                            strokeWidth="1"
                                                            fill="none"
                                                        />
                                                        <path
                                                            d={`M ${line1EndX},${line2EndY} L ${line2EndX},${line2EndY}`}
                                                            stroke="green"
                                                            strokeWidth="1"
                                                            fill="none"
                                                        />
                                                    </>
                                                )}

                                                {/* Solid black circle acting as a badge container */}
                                                <circle
                                                    cx={hintX}
                                                    cy={hintY}
                                                    r={10} // Slightly larger radius so the text fits cleanly inside
                                                    stroke="black"
                                                    strokeWidth="1"
                                                    fill="black"
                                                    style={{
                                                        cursor: 'pointer',
                                                        pointerEvents: 'all',
                                                    }}
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        window.appState.connectActivePinToPort(
                                                            (activeWireKey === 'M+' || activeWireKey === 'M-') ? lookupPinKey : portName
                                                        )
                                                    }}
                                                />

                                                {/* Centered text label inside the solid black circle */}
                                                <text
                                                    x={hintX}
                                                    y={hintY + 5} // Vertically balanced offset for baseline centering
                                                    fontSize="14" // Reduced font size to fit neatly inside the badge
                                                    fontWeight="bold"
                                                    fontFamily="sans-serif"
                                                    fill="white" // White text contrast for the solid black background
                                                    textAnchor="middle"
                                                    pointerEvents="none"
                                                >
                                                    {displayLabel}
                                                </text>
                                            </g>
                                        )
                                    }

                                    // Default layout used for Toki and fallback devices (Keeps original styling exactly the same)
                                    return (
                                        <g key={`hint-${portFullId}`}>
                                            <text
                                                x={
                                                    hintX +
                                                    (portData
                                                        .pinTextOffset?.[0] ||
                                                        0)
                                                }
                                                y={
                                                    hintY +
                                                    (portData
                                                        .pinTextOffset?.[1] ||
                                                        0)
                                                }
                                                fontSize="20"
                                                fontWeight="bold"
                                                fill={circleStroke}
                                                textAnchor="middle"
                                                pointerEvents="none"
                                                opacity={opacity}
                                            >
                                                {displayLabel}
                                            </text>
                                            <circle
                                                cx={hintX}
                                                cy={hintY}
                                                r={8}
                                                stroke={circleStroke}
                                                strokeWidth="3"
                                                fill={circleFill}
                                                opacity={opacity}
                                                style={{
                                                    cursor: 'pointer',
                                                    pointerEvents: 'all',
                                                }}
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    window.appState.connectActivePinToPort(
                                                        (activeWireKey === 'M+' || activeWireKey === 'M-') ? lookupPinKey : portName
                                                    )
                                                }}
                                            />
                                        </g>
                                    )
                                }

                                // Signal pins: show hints only at this component's
                                // allowedTargets (device-aware: Poki servos also
                                // expose A1/A2).
                                const signalAllowedTargets = getAllowedTargets(
                                    pinMeta,
                                    connectedDevice
                                )
                                if (
                                    pinMeta.isSignal &&
                                    signalAllowedTargets?.length
                                ) {
                                    // Grouped targets (E1/E2, F1/F2) render as one shared
                                    // blob (drawn once); the blob's circles connect the
                                    // active pin to whichever alias is a real target.
                                    // Non-grouped targets keep their individual badge.
                                    const els = []
                                    const blobsDone = new Set()
                                    signalAllowedTargets.forEach(
                                        ({ portId, pinKey, label }) => {
                                            const blob = getGroupBlob(
                                                connectedDevice,
                                                pinKey
                                            )
                                            if (blob) {
                                                if (!blobsDone.has(blob)) {
                                                    blobsDone.add(blob)
                                                    const validKeys = new Set(
                                                        signalAllowedTargets
                                                            .filter((t) =>
                                                                blob.members.includes(
                                                                    t.pinKey
                                                                )
                                                            )
                                                            .map(
                                                                (t) => t.pinKey
                                                            )
                                                    )
                                                    // Whole-socket component (e.g. OLED
                                                    // wires E1 + E2 into the one E
                                                    // socket): show the FULL group blob
                                                    // so the user routes each wire to
                                                    // its own alias circle. Otherwise
                                                    // prefer the step's target alias
                                                    // (e.g. E2) over the first member.
                                                    const wholeSocketParent =
                                                        getWholeSocketParent(
                                                            activeRgbComponent.type,
                                                            connectedDevice,
                                                            getPortGroup
                                                        )
                                                    // Once a sibling pin of this socket
                                                    // is already wired, the persistent
                                                    // block draws the full blob (with
                                                    // this active pin's circle live), so
                                                    // skip drawing it here to avoid a
                                                    // doubled overlay.
                                                    const activePc =
                                                        window.appState.getPinConnections(
                                                            activeRgbComponent.type,
                                                            activeRgbComponent.index
                                                        ) || {}
                                                    const siblingWired =
                                                        wholeSocketParent &&
                                                        Object.entries(
                                                            config.pins
                                                        ).some(
                                                            ([pk, pm]) =>
                                                                pm.isSignal &&
                                                                pk !==
                                                                    activeWireKey &&
                                                                activePc[pk] &&
                                                                blob.members.includes(
                                                                    activePc[pk]
                                                                )
                                                        )
                                                    if (!siblingWired)
                                                        els.push(
                                                            renderGroupBlob({
                                                                key: `active-blob-${pinKey}`,
                                                                bibox,
                                                                blob,
                                                                activeKey:
                                                                    wholeSocketParent &&
                                                                    blob.members.includes(
                                                                        wholeSocketParent
                                                                    )
                                                                        ? wholeSocketParent
                                                                        : blob.members.includes(
                                                                                highlightPort
                                                                            ) &&
                                                                            validKeys.has(
                                                                                highlightPort
                                                                            )
                                                                          ? highlightPort
                                                                          : pinKey,
                                                                opacity: 0.75,
                                                                onClickKey: (
                                                                    k
                                                                ) => {
                                                                    if (
                                                                        validKeys.has(
                                                                            k
                                                                        )
                                                                    )
                                                                        window.appState.connectActivePinToPort(
                                                                            k
                                                                        )
                                                                },
                                                            })
                                                        )
                                                }
                                                return
                                            }
                                            els.push(
                                                renderHint(
                                                    portId,
                                                    pinKey,
                                                    // Label from the target's pinKey via
                                                    // PORT_NAME_MAP (e.g. M3 → 'M2'), falling
                                                    // back to the config label then the key.
                                                    PORT_NAME_MAP[pinKey] ||
                                                        label ||
                                                        pinKey,
                                                    signalAllowedTargets.length ===
                                                        1
                                                )
                                            )
                                        }
                                    )
                                    return (
                                        <g key="modular-target-hints">{els}</g>
                                    )
                                }

                                // Generic and signal routing labels: search resolved board ports.
                                const TOKI_FULL_PORTS = [
                                    'servo_motor1_FULL',
                                    'A1_FULL',
                                    'A2_FULL',
                                    'servo_motor2_FULL',
                                ]
                                const POKI_FULL_PORTS = [
                                    'servo_motor1_FULL',
                                    'servo_motor2_FULL',
                                    'A1_FULL',
                                    'A2_FULL',
                                    'C1_FULL',
                                    'C2_FULL',
                                    'B1_FULL',
                                    'B2_FULL',
                                    'D1_FULL',
                                    'D2_FULL',
                                    'M1_FULL',
                                    'M3_FULL',
                                    'fallbackPins',
                                    'fallbackPins2',
                                ]

                                const activeFullPorts =
                                    connectedDevice === 'Poki'
                                        ? POKI_FULL_PORTS
                                        : TOKI_FULL_PORTS

                                return (
                                    <g key="modular-target-hints">
                                        {activeFullPorts.map((portFullId) => {
                                            // Resolve label if this is a generic 'signal' wire key
                                            let runtimeLabel =
                                                PORT_NAME_MAP[activeWireKey] ||
                                                activeWireKey
                                            if (
                                                activeWireKey === 'signal' &&
                                                pinMeta.isSignal
                                            ) {
                                                const targets =
                                                    getAllowedTargets(
                                                        pinMeta,
                                                        connectedDevice
                                                    ) || []
                                                const matchedTarget =
                                                    targets.find(
                                                        (t) =>
                                                            t.portId ===
                                                            portFullId
                                                    )
                                                if (matchedTarget) {
                                                    runtimeLabel =
                                                        PORT_NAME_MAP[
                                                            matchedTarget.pinKey
                                                        ] ||
                                                        matchedTarget.label ||
                                                        matchedTarget.pinKey
                                                }
                                            }

                                            return renderHint(
                                                portFullId,
                                                activeWireKey,
                                                runtimeLabel,
                                                false
                                            )
                                        })}
                                    </g>
                                )
                            })()}

                        {/* Poki: a persistent hint for EVERY connected pin. The
                            block above only draws the single pin held in
                            activeRgbWire, so without this re-routing one pin (e.g.
                            +) would hide the hints of the other pins that are still
                            connected (e.g. -). Each connected pin keeps its own hint
                            here, independent of which pin is being routed. */}
                        {window.appState &&
                            connectedDevice === 'Poki' &&
                            (() => {
                                const hints = []
                                Object.keys(components).forEach((compKey) => {
                                    const config = HardwareWireConfigs[compKey]
                                    if (!config) return
                                    components[compKey].forEach(
                                        (instance, instIdx) => {
                                            // Click-connected pins live in
                                            // pinConnections; drag-dropped and
                                            // tutorial-placed components only set
                                            // connectedTo, so fall back to that
                                            // (all pins → that port) so their hints
                                            // persist too. While this instance is
                                            // being dragged, removeConnection has
                                            // cleared connectedTo, so use the live
                                            // drag port (DraggingInfo.newComponentPort)
                                            // — same as the wire bundle — so the hints
                                            // stay put instead of vanishing mid-drag.
                                            const isBeingDragged =
                                                DraggingInfo.isDragging &&
                                                DraggingInfo.draggingComponentOld &&
                                                DraggingInfo
                                                    .draggingComponentOld
                                                    .type === compKey &&
                                                DraggingInfo
                                                    .draggingComponentOld
                                                    .index === instIdx
                                            let pc = instance.pinConnections
                                            const fallbackPort = isBeingDragged
                                                ? DraggingInfo.newComponentPort
                                                : instance.connectedTo
                                            if (
                                                isBeingDragged &&
                                                connectedDevice === 'Poki' &&
                                                fallbackPort
                                            ) {
                                                // Match the wire bundle's live
                                                // preview so the badge hints land
                                                // on the same + / - pins the drop
                                                // will use (see block above).
                                                const preview =
                                                    computeAutoDropPinConnections(
                                                        Ports,
                                                        compKey,
                                                        fallbackPort,
                                                        connectedDevice,
                                                        components,
                                                        {
                                                            type: compKey,
                                                            index: instIdx,
                                                        }
                                                    )
                                                // Invalid drop (a required + / -
                                                // has no free slot) → show no hints.
                                                pc =
                                                    preview &&
                                                    preview.allConnected
                                                        ? preview.pinConnections
                                                        : {}
                                            } else if (
                                                (!pc ||
                                                    Object.keys(pc).length ===
                                                        0) &&
                                                fallbackPort
                                            ) {
                                                pc = {}
                                                Object.keys(
                                                    config.pins
                                                ).forEach((pk) => {
                                                    pc[pk] = fallbackPort
                                                })
                                            }
                                            pc = pc || {}
                                            // Whole-socket component (e.g. OLED wires
                                            // E1 + E2 into the one E socket): its
                                            // connected signal pins share ONE full group
                                            // blob (drawn once) whose alias circles each
                                            // re-route their own pin. Map each board
                                            // alias → the component pin that targets it.
                                            const wholeSocketParent =
                                                getWholeSocketParent(
                                                    compKey,
                                                    connectedDevice,
                                                    getPortGroup
                                                )
                                            const aliasToPin = {}
                                            if (wholeSocketParent) {
                                                Object.entries(
                                                    config.pins
                                                ).forEach(([pk, pm]) => {
                                                    if (!pm.isSignal) return
                                                    const t = getAllowedTargets(
                                                        pm,
                                                        connectedDevice
                                                    )
                                                    if (t && t.length === 1)
                                                        aliasToPin[
                                                            t[0].pinKey
                                                        ] = pk
                                                })
                                            }
                                            const drawnGroupBlobs = new Set()
                                            Object.entries(config.pins).forEach(
                                                ([pinKey, pinMeta]) => {
                                                    const assignedPort =
                                                        pc[pinKey]
                                                    if (!assignedPort) return
                                                    // A pin being actively routed has
                                                    // no assignedPort (startPinWire
                                                    // cleared it) so it's skipped
                                                    // above; a CONNECTED pin — even the
                                                    // active one — is drawn here at its
                                                    // real port, since the active block
                                                    // now defers connected pins here.

                                                    // Grouped socket (E/E1/E2, F/F1/F2):
                                                    // draw the shared 3-circle blob once
                                                    // instead of this pin's single badge.
                                                    // Only for the signal pin — +/- still
                                                    // redirect to the shared power rail
                                                    // (fallbackPins) below.
                                                    const connectedBlob =
                                                        pinMeta.isSignal
                                                            ? getGroupBlob(
                                                                  connectedDevice,
                                                                  assignedPort
                                                              )
                                                            : undefined
                                                    if (connectedBlob) {
                                                        // Whole-socket component: draw
                                                        // the FULL group blob ONCE. Each
                                                        // alias circle re-routes its own
                                                        // pin (or, if that pin is the one
                                                        // currently following the cursor,
                                                        // connects it here).
                                                        if (
                                                            wholeSocketParent &&
                                                            connectedBlob.members.includes(
                                                                wholeSocketParent
                                                            )
                                                        ) {
                                                            if (
                                                                drawnGroupBlobs.has(
                                                                    connectedBlob
                                                                )
                                                            )
                                                                return
                                                            drawnGroupBlobs.add(
                                                                connectedBlob
                                                            )
                                                            hints.push(
                                                                renderGroupBlob({
                                                                    key: `persist-blob-${compKey}-${instIdx}-${wholeSocketParent}`,
                                                                    bibox,
                                                                    blob: connectedBlob,
                                                                    activeKey:
                                                                        wholeSocketParent,
                                                                    opacity: 0.75,
                                                                    onClickKey: (
                                                                        k
                                                                    ) => {
                                                                        const targetPin =
                                                                            aliasToPin[
                                                                                k
                                                                            ]
                                                                        if (
                                                                            !targetPin
                                                                        )
                                                                            return
                                                                        const s =
                                                                            window
                                                                                .appState
                                                                                .state
                                                                        const livePc =
                                                                            window.appState.getPinConnections(
                                                                                compKey,
                                                                                instIdx
                                                                            ) ||
                                                                            {}
                                                                        // This pin is following the
                                                                        // cursor (active + not yet
                                                                        // wired) → land it here.
                                                                        // Otherwise (already wired)
                                                                        // → pick it up to re-route.
                                                                        const isRoutingThisPin =
                                                                            s.activeRgbWire ===
                                                                                targetPin &&
                                                                            s
                                                                                .activeRgbComponent
                                                                                ?.type ===
                                                                                compKey &&
                                                                            s
                                                                                .activeRgbComponent
                                                                                ?.index ===
                                                                                instIdx &&
                                                                            !livePc[
                                                                                targetPin
                                                                            ]
                                                                        if (
                                                                            isRoutingThisPin
                                                                        )
                                                                            window.appState.connectActivePinToPort(
                                                                                k
                                                                            )
                                                                        else
                                                                            window.appState.startPinWire(
                                                                                compKey,
                                                                                instIdx,
                                                                                targetPin
                                                                            )
                                                                    },
                                                                })
                                                            )
                                                            return
                                                        }
                                                        hints.push(
                                                            renderGroupBlob({
                                                                key: `persist-blob-${compKey}-${instIdx}-${pinKey}`,
                                                                bibox,
                                                                blob: connectedBlob,
                                                                activeKey:
                                                                    assignedPort,
                                                                opacity: 0.75,
                                                                onClickKey:
                                                                    () =>
                                                                        window.appState.startPinWire(
                                                                            compKey,
                                                                            instIdx,
                                                                            pinKey
                                                                        ),
                                                            })
                                                        )
                                                        return
                                                    }

                                                    // Resolve the target port's
                                                    // _FULL record (handles both
                                                    // 'S1' and 'servo_motor1'
                                                    // spellings) and the lookup key
                                                    // inside its pins map.
                                                    let portFullId =
                                                        POKI_FULL_PORT_BY_KEY[
                                                            assignedPort
                                                        ] ||
                                                        assignedPort + '_FULL'
                                                    let lookupKey =
                                                        pinMeta.targetPinKey ||
                                                        pinKey
                                                    const allowedTargets =
                                                        getAllowedTargets(
                                                            pinMeta,
                                                            connectedDevice
                                                        )
                                                    if (allowedTargets) {
                                                        const exactMatch = allowedTargets.find((t) => t.pinKey === assignedPort)
                                                        if (exactMatch) {
                                                            portFullId = exactMatch.portId
                                                            lookupKey = exactMatch.pinKey
                                                        } else {
                                                            const m =
                                                                allowedTargets.find(
                                                                    (t) =>
                                                                        t.portId ===
                                                                        portFullId
                                                                )
                                                            if (m)
                                                                lookupKey = m.pinKey
                                                        }
                                                    }

                                                    const {
                                                        portData,
                                                        resolvedPinKey,
                                                    } = getFallbackPortData(
                                                        portFullId,
                                                        lookupKey
                                                    )
                                                    const pinCoords =
                                                        portData?.pins?.[
                                                            resolvedPinKey
                                                        ]
                                                    const lineData =
                                                        portData?.lines?.[
                                                            resolvedPinKey
                                                        ]

                                                    if (!pinCoords) return

                                                    const hintX =
                                                        bibox.left +
                                                        pinCoords[0]
                                                    const hintY =
                                                        bibox.top + pinCoords[1]
                                                    // Signal pins (e.g. C1) resolve to a
                                                    // port record with no `lines` entry, so
                                                    // guard every line-end read and skip the
                                                    // 3 routing segments when lineData is absent.
                                                    const line1EndX = lineData
                                                        ? bibox.left +
                                                          lineData.line1End[0]
                                                        : hintX
                                                    const line1EndY = lineData
                                                        ? bibox.top +
                                                          lineData.line1End[1]
                                                        : hintY
                                                    const line2EndX = lineData
                                                        ? bibox.left +
                                                          lineData.line2End[0]
                                                        : hintX
                                                    const line2EndY = lineData
                                                        ? bibox.top +
                                                          lineData.line2End[1]
                                                        : hintY
                                                    {
                                                        /* const opacity =
                                                        pinMeta.isSignal
                                                            ? 0
                                                            : 0.75 */
                                                    }
                                                    const opacity = 0.75
                                                    let displayLabel =
                                                        PORT_NAME_MAP[pinKey] ||
                                                        pinKey

                                                    // The label belongs to the TARGET port, not the
                                                    // component's own pin name. Resolve it from the
                                                    // matched target's pinKey via PORT_NAME_MAP for any
                                                    // signal pin (covers 'signal', 'servo_motor1', the
                                                    // single 'M2' motor pin, …) — e.g. M3 → 'M2'.
                                                    if (pinMeta.isSignal) {
                                                        const targets =
                                                            getAllowedTargets(
                                                                pinMeta,
                                                                connectedDevice
                                                            ) || []
                                                        const matchedTarget =
                                                            targets.find(
                                                                (t) =>
                                                                    t.portId ===
                                                                    (POKI_FULL_PORT_BY_KEY[
                                                                        assignedPort
                                                                    ] ||
                                                                        assignedPort +
                                                                            '_FULL')
                                                            )
                                                        if (matchedTarget) {
                                                            displayLabel =
                                                                PORT_NAME_MAP[
                                                                    matchedTarget
                                                                        .pinKey
                                                                ] ||
                                                                matchedTarget.label ||
                                                                matchedTarget.pinKey
                                                        }
                                                    }

                                                    hints.push(
                                                        <g
                                                            key={`persist-hint-${compKey}-${instIdx}-${pinKey}`}
                                                            opacity={opacity}
                                                        >
                                                            {lineData && (
                                                                <>
                                                                    <path
                                                                        d={`M ${hintX},${hintY} L ${line1EndX},${line1EndY}`}
                                                                        stroke="green"
                                                                        strokeWidth="1"
                                                                        fill="none"
                                                                    />
                                                                    <path
                                                                        d={`M ${line1EndX},${line1EndY} L ${line1EndX},${line2EndY}`}
                                                                        stroke="green"
                                                                        strokeWidth="1"
                                                                        fill="none"
                                                                    />
                                                                    <path
                                                                        d={`M ${line1EndX},${line2EndY} L ${line2EndX},${line2EndY}`}
                                                                        stroke="green"
                                                                        strokeWidth="1"
                                                                        fill="none"
                                                                    />
                                                                </>
                                                            )}
                                                            {/* Dynamic Extra Paths: Only injects if target is A1_FULL and pinKey is '-' */}
                                                            {/* {portFullId ===
                                                                'A1_FULL' &&
                                                                pinKey ===
                                                                    '-' && (
                                                                    <>
                                                                        <path
                                                                            d={`M ${line2EndX},${line2EndY} L ${line2EndX + 20},${line2EndY}`} // Example coordinates
                                                                            stroke="blue"
                                                                            strokeWidth="1"
                                                                            fill="none"
                                                                        />
                                                                        <path
                                                                            d={`M ${line2EndX + 20},${line2EndY} L ${line2EndX + 20},${line2EndY + 30}`}
                                                                            stroke="blue"
                                                                            strokeWidth="1"
                                                                            fill="none"
                                                                        />
                                                                    </>
                                                                )} */}
                                                            <circle
                                                                cx={hintX}
                                                                cy={hintY}
                                                                r={10}
                                                                stroke="black"
                                                                strokeWidth="1"
                                                                fill="black"
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    pointerEvents:
                                                                        'all',
                                                                }}
                                                                onClick={(
                                                                    e
                                                                ) => {
                                                                    e.stopPropagation()
                                                                    // Grab this wire
                                                                    // to re-route it.
                                                                    window.appState.startPinWire(
                                                                        compKey,
                                                                        instIdx,
                                                                        pinKey
                                                                    )
                                                                }}
                                                            />
                                                            <text
                                                                x={hintX}
                                                                y={hintY + 5}
                                                                fontSize="14"
                                                                fontWeight="bold"
                                                                fontFamily="sans-serif"
                                                                fill="white"
                                                                textAnchor="middle"
                                                                pointerEvents="none"
                                                            >
                                                                {displayLabel}
                                                            </text>
                                                        </g>
                                                    )
                                                }
                                            )
                                        }
                                    )
                                })
                                return (
                                    <g key="poki-persistent-connected-hints">
                                        {hints}
                                    </g>
                                )
                            })()}

                        {/* Poki: while a component is being DRAGGED (sidebar or an
                            existing one), preview the hints at the port(s) the
                            tutorial allows it to connect to — the same "extended
                            wires" shown after connecting, so they appear alongside
                            the animated red highlight before the drop. Gated to the
                            exact condition that shows the red highlight. Passive
                            (pointerEvents:none) so it never blocks the drop; once
                            dropped, the persistent block above takes over. */}
                        {connectedDevice === 'Poki' &&
                            extraComponent &&
                            HardwareWireConfigs[extraComponent.type] &&
                            AllowedPortTypesTutor[extraComponent.type] &&
                            !(
                                DraggingInfo.draggingComponentOld &&
                                DraggingInfo.newComponentPort
                            ) &&
                            (() => {
                                const config =
                                    HardwareWireConfigs[extraComponent.type]
                                const allowedKeys =
                                    AllowedPortTypesTutor[
                                        extraComponent.type
                                    ] || []
                                const hints = []
                                const previewedBlobs = new Set()
                                // An existing component being dragged keeps its
                                // stale pinConnections in `components`; exclude it
                                // from the occupancy scan below.
                                const previewSkip =
                                    DraggingInfo.draggingComponentOld || null
                                allowedKeys.forEach((portKey) => {
                                    // Real auto-drop result for dropping on THIS port,
                                    // so the + / - preview lands on the same free pin
                                    // the drop will pick (accounting for occupancy).
                                    const autoResult =
                                        computeAutoDropPinConnections(
                                            Ports,
                                            extraComponent.type,
                                            portKey,
                                            connectedDevice,
                                            components,
                                            previewSkip
                                        )
                                    // Invalid drop (a required + / - has no free slot)
                                    // → the drop would be rejected, so render NO hints
                                    // for this port (not even the grouped blob).
                                    if (autoResult && !autoResult.allConnected)
                                        return
                                    // Grouped socket (E/E1/E2, F/F1/F2): preview the
                                    // shared 3-circle blob once (passive). The blob only
                                    // replaces the SIGNAL pin's badge — the +/- power pins
                                    // route to the shared fallback rail, not the socket,
                                    // so they still need their own hint. So don't bail
                                    // here: render the blob, then fall through and draw
                                    // only the +/- pins below (the signal pin is skipped
                                    // inside the loop for grouped sockets).
                                    const blob = getGroupBlob(
                                        connectedDevice,
                                        portKey
                                    )
                                    const isGrouped = !!blob
                                    if (isGrouped && !previewedBlobs.has(blob)) {
                                        previewedBlobs.add(blob)
                                        hints.push(
                                            renderGroupBlob({
                                                key: `drag-blob-${portKey}`,
                                                bibox,
                                                blob,
                                                // Show the alias the current step
                                                // targets (e.g. E2), not just the
                                                // first group member.
                                                activeKey: blob.members.includes(
                                                    highlightPort
                                                )
                                                    ? highlightPort
                                                    : portKey,
                                                opacity: 0.75,
                                                // No onClickKey → passive preview.
                                            })
                                        )
                                    }
                                    const portFullId =
                                        POKI_FULL_PORT_BY_KEY[portKey] ||
                                        portKey + '_FULL'
                                    const portData = Ports(portFullId)
                                    // A non-grouped port needs its own pin coords; bail if
                                    // missing. Grouped sockets proceed even without them
                                    // because the +/- pins fall back to the shared rail.
                                    if (!isGrouped && !portData?.pins) return
                                    Object.entries(config.pins).forEach(
                                        ([pinKey, pinMeta]) => {
                                            // Grouped socket: the blob already stands in
                                            // for the signal pin; only the +/- power pins
                                            // still need a fallback hint here.
                                            if (isGrouped && pinMeta.isSignal)
                                                return
                                            let lookupKey =
                                                pinMeta.targetPinKey || pinKey
                                            let resolvedLabel =
                                                PORT_NAME_MAP[pinKey] ||
                                                pinMeta.label ||
                                                pinKey
                                            // Power pins: redirect the hint to the actual
                                            // target port the drop computed for this pin.
                                            // null → no free slot, so draw no hint.
                                            let resolvedFullId = portFullId
                                            if (
                                                (pinKey === '+' ||
                                                    pinKey === '-') &&
                                                autoResult
                                            ) {
                                                const target =
                                                    autoResult.pinConnections[
                                                        pinKey
                                                    ]
                                                if (!target) return
                                                resolvedFullId =
                                                    target === 'fallbackPins' ||
                                                    target === 'fallbackPins2'
                                                        ? target
                                                        : target + '_FULL'
                                            }

                                            const allowedTargets =
                                                getAllowedTargets(
                                                    pinMeta,
                                                    connectedDevice
                                                )
                                            if (allowedTargets) {
                                                const m = allowedTargets.find(
                                                    (t) =>
                                                        t.portId === portFullId
                                                )
                                                // signal pin that can't reach this port → no preview for it
                                                if (!m) return
                                                lookupKey = m.pinKey

                                                // Dynamically resolve the explicit target name
                                                // (e.g. S1, A1, or M3 → 'M2') from the matched
                                                // target's pinKey for any signal pin — not just a
                                                // pin literally named 'signal'.
                                                if (pinMeta.isSignal) {
                                                    resolvedLabel =
                                                        PORT_NAME_MAP[
                                                            m.pinKey
                                                        ] ||
                                                        m.label ||
                                                        m.pinKey
                                                }
                                            }

                                            // When a power pin routes to a shared
                                            // fallback rail, show its ghost on BOTH
                                            // rails (fallbackPins AND fallbackPins2)
                                            // so the second rail is visible from the
                                            // start of the drag — not only once the
                                            // first rail is occupied. The wire still
                                            // lands on just one; these are passive
                                            // availability hints.
                                            const railIds =
                                                resolvedFullId ===
                                                    'fallbackPins' ||
                                                resolvedFullId === 'fallbackPins2'
                                                    ? [
                                                          'fallbackPins',
                                                          'fallbackPins2',
                                                      ]
                                                    : [resolvedFullId]
                                            railIds.forEach((railId) => {
                                                const {
                                                    portData: dragPortData,
                                                    resolvedPinKey,
                                                } = getFallbackPortData(
                                                    railId,
                                                    lookupKey
                                                )
                                                const pinCoords =
                                                    dragPortData?.pins?.[
                                                        resolvedPinKey
                                                    ]
                                                if (!pinCoords) return

                                                hints.push(
                                                    renderPokiHintBadge({
                                                        key: `drag-hint-${extraComponent.type}-${portKey}-${pinKey}-${railId}`,
                                                        bibox,
                                                        pinCoords,
                                                        lineData:
                                                            dragPortData?.lines?.[
                                                                resolvedPinKey
                                                            ],
                                                        displayLabel:
                                                            resolvedLabel,
                                                        opacity: 0.75,
                                                        // No onClick → passive preview.
                                                    })
                                                )
                                            })
                                        }
                                    )
                                })
                                return (
                                    <g key="poki-drag-preview-hints">{hints}</g>
                                )
                            })()}

                        {Object.keys(
                            PortTypes[`${connectedDevice.toUpperCase()}`]
                        ).map((key) => {
                            var highlighted = false
                            const assemblyConnections = JSON.parse(
                                sessionStorage.getItem('assemblyTwo')
                            ).PortConnections
                            // this will let us know which port will active will draging components

                            // Poki AND Toki: a dragged component that needs + / - but
                            // has no free power pin anywhere can't connect, so it must
                            // not highlight ANY port (its wire/hint preview is already
                            // suppressed). null droppedPort → pure pool availability.
                            const dragPowerBlocked =
                                (connectedDevice === 'Poki' ||
                                    connectedDevice === 'Toki') &&
                                !!extraComponent &&
                                (() => {
                                    const r = computeAutoDropPinConnections(
                                        Ports,
                                        extraComponent.type,
                                        null,
                                        connectedDevice,
                                        components,
                                        DraggingInfo.draggingComponentOld || null
                                    )
                                    return !!(r && !r.allConnected)
                                })()

                            if (extraComponent) {
                                if (
                                    AllowedPortTypesTutor[extraComponent.type]
                                ) {
                                    if (
                                        !(
                                            DraggingInfo.draggingComponentOld &&
                                            DraggingInfo.newComponentPort
                                        ) &&
                                        extraComponent &&
                                        AllowedPortTypesTutor[
                                            extraComponent.type
                                        ].indexOf(key) > -1 &&
                                        !dragPowerBlocked
                                    )
                                        highlighted = true
                                }
                            }
                            // if (
                            //     ['A', 'B', 'A1', 'A2', 'B1', 'B2'].includes(key)
                            // )
                            //     console.log(key, 'XXXXXXXXXXXX', highlighted)
                            // S1

                            if (
                                [
                                    'Ace',
                                    'Humanoid',
                                    'Hexapod',
                                    'Klaw',
                                    'Roboki',
                                    'Atr',
                                    'Toki',
                                    'Poki',
                                    'Moki',
                                ].includes(Device)
                            ) {
                                // for poki If the E port is connected, E1 and E2 cannot be connected. Similarly, if either E1 or E2 is connected, E cannot be connected.
                                // The same rule applies for F and its sub-ports F1 and F2.
                                if (
                                    sessionStorage.getItem('connectedDevice') ==
                                    'Poki'
                                ) {
                                    const draggingItem = extraComponent?.type

                                    if (
                                        key === 'E' &&
                                        (assemblyConnections['E'] !== null ||
                                            assemblyConnections['E1'] !==
                                                null ||
                                            assemblyConnections['E2'] !== null)
                                    ) {
                                        return false
                                    }

                                    if (
                                        key === 'E2' &&
                                        assemblyConnections['E'] !== null
                                    ) {
                                        return false
                                    }

                                    if (
                                        key === 'E2' &&
                                        assemblyConnections['E1'] != null &&
                                        [
                                            'Magnetometer',
                                            'Magnetic_encoder',
                                            'IMU',
                                            'OLED',
                                            'Color_sensor',
                                        ].includes(
                                            assemblyConnections?.['E1']?.type
                                        )
                                    )
                                        return false

                                    if (
                                        key === 'E1' &&
                                        assemblyConnections['E'] !== null &&
                                        ![
                                            'Magnetometer',
                                            'Magnetic_encoder',
                                            'IMU',
                                            'OLED',
                                            'Color_sensor',
                                        ].includes(draggingItem)
                                    ) {
                                        return false
                                    }
                                    if (
                                        key === 'E1' &&
                                        assemblyConnections['E'] === null &&
                                        [
                                            'Magnetometer',
                                            'Magnetic_encoder',
                                            'IMU',
                                            'OLED',
                                            'Color_sensor',
                                        ].includes(draggingItem)
                                    ) {
                                        return false
                                    }

                                    // if (
                                    //     key === 'F2' &&
                                    //     assemblyConnections['F1'] != null &&
                                    //     ['RGB'].includes(
                                    //         assemblyConnections?.['F1']?.type
                                    //     )
                                    // )
                                    //     return false

                                    if (
                                        [
                                            'Magnetometer',
                                            'Magnetic_encoder',
                                            'IMU',
                                            'OLED',
                                            'Color_sensor',
                                        ].includes(draggingItem) &&
                                        (assemblyConnections['E2'] != null ||
                                            assemblyConnections['E1'] != null)
                                    )
                                        return false

                                    // if (
                                    //     ['RGB'].includes(draggingItem) &&
                                    //     (assemblyConnections['F2'] != null ||
                                    //         assemblyConnections['F1'] != null)
                                    // )
                                    //     return false
                                }

                                // for moki If the D port is connected, D1 and D2 cannot be connected. Similarly, if either D1 or D2 is connected, E cannot be connected.
                                // The same rule applies for A and C .
                                if (
                                    sessionStorage.getItem('connectedDevice') ==
                                    'Moki'
                                ) {
                                    const draggingItem = extraComponent?.type
                                    if (
                                        key === 'A2' &&
                                        assemblyConnections['A1'] != null &&
                                        ['ultrasonic_sensor'].includes(
                                            assemblyConnections?.['A1']?.type
                                        )
                                    )
                                        return false

                                    if (
                                        key === 'C2' &&
                                        assemblyConnections['C1'] != null &&
                                        ['ultrasonic_sensor'].includes(
                                            assemblyConnections?.['C1']?.type
                                        )
                                    )
                                        return false

                                    // if (port === 'A')

                                    if (
                                        (['ultrasonic_sensor'].includes(
                                            draggingItem
                                        ) &&
                                            key === 'A' &&
                                            (assemblyConnections['A2'] !=
                                                null ||
                                                assemblyConnections['A1'] !=
                                                    null)) ||
                                        (key === 'C' &&
                                            (assemblyConnections['C2'] !=
                                                null ||
                                                assemblyConnections['C1'] !=
                                                    null))
                                    )
                                        return false

                                    if (
                                        key === 'D2' &&
                                        assemblyConnections['D1'] != null &&
                                        [
                                            'Magnetometer',
                                            'Magnetic_encoder',
                                            'IMU',
                                            'OLED',
                                            'Color_sensor',
                                        ].includes(
                                            assemblyConnections?.['D1']?.type
                                        )
                                    )
                                        return false

                                    if (
                                        [
                                            'Magnetometer',
                                            'Magnetic_encoder',
                                            'IMU',
                                            'OLED',
                                            'Color_sensor',
                                        ].includes(draggingItem) &&
                                        (assemblyConnections['D2'] != null ||
                                            assemblyConnections['D1'] != null)
                                    )
                                        return false

                                    if (
                                        key === 'B2' &&
                                        assemblyConnections['B1'] != null &&
                                        ['Audio_codec', 'RGB'].includes(
                                            assemblyConnections?.['B1']?.type
                                        )
                                    )
                                        return false

                                    if (
                                        ['Audio_codec', 'RGB'].includes(
                                            draggingItem
                                        ) &&
                                        (assemblyConnections['B2'] != null ||
                                            assemblyConnections['B1'] != null)
                                    )
                                        return false
                                }

                                //for ATR B1 and C1 ports and B2 and C2 port are share, show we restitct here the connection
                                if (
                                    sessionStorage.getItem('connectedDevice') ==
                                    'Atr'
                                ) {
                                    const iSDragComponentPWMOutput =
                                        checkIsPwmOutput(extraComponent?.type)
                                    if (
                                        key === 'B1' &&
                                        checkIsPwmOutput(
                                            assemblyConnections?.['C1']?.type
                                        ) &&
                                        iSDragComponentPWMOutput
                                    )
                                        return
                                    if (
                                        key === 'B2' &&
                                        checkIsPwmOutput(
                                            assemblyConnections?.['C2']?.type
                                        ) &&
                                        iSDragComponentPWMOutput
                                    )
                                        return
                                    if (
                                        key === 'C1' &&
                                        checkIsPwmOutput(
                                            assemblyConnections?.['B1']?.type
                                        ) &&
                                        iSDragComponentPWMOutput
                                    )
                                        return
                                    if (
                                        key === 'C2' &&
                                        checkIsPwmOutput(
                                            assemblyConnections?.['B2']?.type
                                        ) &&
                                        iSDragComponentPWMOutput
                                    )
                                        return
                                    if (
                                        key === 'S1' &&
                                        (assemblyConnections['C1'] != null ||
                                            assemblyConnections['B1'] != null)
                                    ) {
                                        return
                                    }
                                    if (
                                        key === 'S2' &&
                                        (assemblyConnections['C2'] != null ||
                                            assemblyConnections['B2'] != null)
                                    ) {
                                        return
                                    }
                                }

                                if (
                                    (key == 'D1' || key == 'D2') &&
                                    highlighted &&
                                    !['Atr', 'Poki', 'Moki'].includes(
                                        connectedDevice
                                    )
                                ) {
                                    if (components) {
                                        highlighted = false
                                        Object.keys(components).map(
                                            (dual_splitter) => {
                                                if (
                                                    dual_splitter ==
                                                    'dual_splitter'
                                                ) {
                                                    components[
                                                        dual_splitter
                                                    ].map(
                                                        (component, index) => {
                                                            if (
                                                                ![
                                                                    'dc_motor',
                                                                    'geared_motor',
                                                                    'mini_geared_motor',
                                                                    'dynamex_motor',
                                                                ].includes(
                                                                    extraComponent.type
                                                                )
                                                            ) {
                                                                if (
                                                                    component.connectedTo ==
                                                                    'D'
                                                                ) {
                                                                    Left =
                                                                        component.left
                                                                    Top =
                                                                        component.top
                                                                    highlighted = true
                                                                }
                                                                if (
                                                                    component.connectedTo ==
                                                                        'D' &&
                                                                    (this.props
                                                                        .shield ||
                                                                        this
                                                                            .props
                                                                            .armShield)
                                                                ) {
                                                                    if (
                                                                        key ==
                                                                        'D1'
                                                                    ) {
                                                                        Left =
                                                                            component.left -
                                                                            230
                                                                        Top =
                                                                            component.top -
                                                                            319
                                                                        highlighted = true
                                                                    }
                                                                    if (
                                                                        key ==
                                                                        'D2'
                                                                    ) {
                                                                        Left =
                                                                            component.left -
                                                                            139
                                                                        Top =
                                                                            component.top -
                                                                            315
                                                                        highlighted = true
                                                                    }
                                                                }
                                                            } else {
                                                                if (
                                                                    component.connectedTo ==
                                                                    'D'
                                                                ) {
                                                                    Left =
                                                                        component.left +
                                                                        28
                                                                    Top =
                                                                        component.top +
                                                                        5
                                                                    highlighted = true
                                                                }
                                                                if (
                                                                    component.connectedTo ==
                                                                        'D' &&
                                                                    (this.props
                                                                        .shield ||
                                                                        this
                                                                            .props
                                                                            .armShield)
                                                                ) {
                                                                    Left =
                                                                        component.left -
                                                                        200
                                                                    Top =
                                                                        component.top -
                                                                        314
                                                                    highlighted = true
                                                                }
                                                            }
                                                        }
                                                    )
                                                }
                                                if (
                                                    dual_splitter ==
                                                    'play_shield'
                                                ) {
                                                    components[
                                                        dual_splitter
                                                    ].map(
                                                        (component, index) => {
                                                            if (
                                                                [
                                                                    'servo_motor',
                                                                    'servo_motor_270',
                                                                    'servo_motor_360',
                                                                ].includes(
                                                                    extraComponent.type
                                                                )
                                                            ) {
                                                                if (
                                                                    (key ==
                                                                        'D1' ||
                                                                        key ==
                                                                            'D2') &&
                                                                    PortConnections.D ==
                                                                        null
                                                                ) {
                                                                    Left =
                                                                        bibox.left
                                                                    Top =
                                                                        bibox.top
                                                                    highlighted = true
                                                                }
                                                            }
                                                        }
                                                    )
                                                }
                                                // MOTOR DRIVER
                                                if (
                                                    dual_splitter ==
                                                        'pc_motor_driver' &&
                                                    JSON.parse(
                                                        sessionStorage.getItem(
                                                            'assemblyTwo'
                                                        )
                                                    ).PortConnections.D !== null
                                                ) {
                                                    if (
                                                        JSON.parse(
                                                            sessionStorage.getItem(
                                                                'assemblyTwo'
                                                            )
                                                        ).PortConnections.D
                                                            .type ==
                                                        'pc_motor_driver'
                                                    ) {
                                                        //checking extraCoponent type = geared_motor
                                                        if (
                                                            [
                                                                'dc_motor',
                                                                'geared_motor',
                                                                'mini_geared_motor',
                                                                'dynamex_motor',
                                                            ].includes(
                                                                extraComponent.type
                                                            )
                                                        ) {
                                                            // 1 all ports == null  i.e B1,B2,D1,D2,SMTP == null

                                                            if (
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .STPM ===
                                                                    null &&
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .B1 ===
                                                                    null &&
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .B2 ===
                                                                    null &&
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .D1 ===
                                                                    null &&
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .D2 === null
                                                            ) {
                                                                components[
                                                                    dual_splitter
                                                                ].map(
                                                                    (
                                                                        component,
                                                                        index
                                                                    ) => {
                                                                        if (
                                                                            component.connectedTo ==
                                                                                'B' ||
                                                                            component.connectedTo ==
                                                                                'D'
                                                                        ) {
                                                                            Left =
                                                                                component.left +
                                                                                125
                                                                            Top =
                                                                                component.top +
                                                                                30
                                                                            highlighted = true
                                                                        }
                                                                    }
                                                                )
                                                            }

                                                            // checking connect divice is not == to servo_motot n stepper_motor
                                                            let connectName =
                                                                isMotorConnected_BD()
                                                            if (
                                                                ![
                                                                    'servo_motor',
                                                                    'servo_motor_270',
                                                                    'stepper_motor',
                                                                ].includes(
                                                                    connectName
                                                                )
                                                            ) {
                                                                components[
                                                                    dual_splitter
                                                                ].map(
                                                                    (
                                                                        component,
                                                                        index
                                                                    ) => {
                                                                        if (
                                                                            component.connectedTo ==
                                                                                'B' ||
                                                                            component.connectedTo ==
                                                                                'D'
                                                                        ) {
                                                                            Left =
                                                                                component.left +
                                                                                125
                                                                            Top =
                                                                                component.top +
                                                                                30
                                                                            highlighted = true
                                                                        }
                                                                    }
                                                                )
                                                            }
                                                        }

                                                        //checking extraCoponent type = servo_motor
                                                        if (
                                                            extraComponent.type ==
                                                            'servo_motor'
                                                        ) {
                                                            if (
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .B1 ===
                                                                    null &&
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .D1 ===
                                                                    null &&
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .STPM ===
                                                                    null
                                                            ) {
                                                                components[
                                                                    dual_splitter
                                                                ].map(
                                                                    (
                                                                        component,
                                                                        index
                                                                    ) => {
                                                                        if (
                                                                            component.connectedTo ==
                                                                                'B' ||
                                                                            component.connectedTo ==
                                                                                'D'
                                                                        ) {
                                                                            if (
                                                                                key ==
                                                                                'D2'
                                                                            ) {
                                                                                Left =
                                                                                    component.left +
                                                                                    20
                                                                            } else {
                                                                                Left =
                                                                                    component.left +
                                                                                    60
                                                                            }
                                                                            Top =
                                                                                component.top
                                                                            highlighted = true
                                                                        }
                                                                    }
                                                                )
                                                            }

                                                            // checking connect divice is not == to geared_motor n stepper_motor
                                                            let connectName =
                                                                isMotorConnected_BD()
                                                            if (
                                                                ![
                                                                    'dc_motor',
                                                                    'geared_motor',
                                                                    'mini_geared_motor',
                                                                    'dynamex_motor',
                                                                    'stepper_motor',
                                                                ].includes(
                                                                    connectName
                                                                )
                                                            ) {
                                                                components[
                                                                    dual_splitter
                                                                ].map(
                                                                    (
                                                                        component,
                                                                        index
                                                                    ) => {
                                                                        if (
                                                                            component.connectedTo ==
                                                                                'B' ||
                                                                            component.connectedTo ==
                                                                                'D'
                                                                        ) {
                                                                            if (
                                                                                key ==
                                                                                'D2'
                                                                            ) {
                                                                                Left =
                                                                                    component.left +
                                                                                    20
                                                                            } else {
                                                                                Left =
                                                                                    component.left +
                                                                                    60
                                                                            }
                                                                            Top =
                                                                                component.top
                                                                            highlighted = true
                                                                        }
                                                                    }
                                                                )
                                                            }
                                                        }

                                                        //checking extraCoponent type = stepper_motor
                                                    }
                                                }
                                            }
                                        )
                                    }
                                } else if (
                                    (key == 'C1' || key == 'C2') &&
                                    highlighted &&
                                    !['Toki', 'Poki', 'Moki'].includes(
                                        connectedDevice
                                    )
                                ) {
                                    if (components) {
                                        highlighted = false
                                        Object.keys(components).map(
                                            (dual_splitter) => {
                                                if (
                                                    dual_splitter ==
                                                    'dual_splitter'
                                                ) {
                                                    components[
                                                        dual_splitter
                                                    ].map(
                                                        (component, index) => {
                                                            if (
                                                                extraComponent.type !=
                                                                    'geared_motor' &&
                                                                extraComponent.type !=
                                                                    'mini_geared_motor' &&
                                                                extraComponent.type !=
                                                                    'dc_motor' &&
                                                                extraComponent.type !=
                                                                    'dynamex_motor'
                                                            ) {
                                                                if (
                                                                    component.connectedTo ==
                                                                    'C'
                                                                ) {
                                                                    if (
                                                                        key ==
                                                                        'C1'
                                                                    ) {
                                                                        Left =
                                                                            component.left
                                                                        Top =
                                                                            component.top
                                                                        highlighted = true
                                                                    }
                                                                    if (
                                                                        key ==
                                                                        'C2'
                                                                    ) {
                                                                        Left =
                                                                            component.left
                                                                        Top =
                                                                            component.top
                                                                        highlighted = true
                                                                    }
                                                                }
                                                                if (
                                                                    component.connectedTo ==
                                                                        'C' &&
                                                                    (this.props
                                                                        .shield ||
                                                                        this
                                                                            .props
                                                                            .armShield)
                                                                ) {
                                                                    if (
                                                                        key ==
                                                                        'C1'
                                                                    ) {
                                                                        Left =
                                                                            component.left -
                                                                            125
                                                                        Top =
                                                                            component.top -
                                                                            320
                                                                        highlighted = true
                                                                    }
                                                                    if (
                                                                        key ==
                                                                        'C2'
                                                                    ) {
                                                                        Left =
                                                                            component.left -
                                                                            105
                                                                        Top =
                                                                            component.top -
                                                                            315
                                                                        highlighted = true
                                                                    }
                                                                }
                                                            } else {
                                                                if (
                                                                    component.connectedTo ==
                                                                    'C'
                                                                ) {
                                                                    Left =
                                                                        component.left +
                                                                        28
                                                                    Top =
                                                                        component.top +
                                                                        5
                                                                    highlighted = true
                                                                }
                                                                if (
                                                                    component.connectedTo ==
                                                                        'C' &&
                                                                    (this.props
                                                                        .shield ||
                                                                        this
                                                                            .props
                                                                            .armShield)
                                                                ) {
                                                                    Left =
                                                                        component.left -
                                                                        100
                                                                    Top =
                                                                        component.top -
                                                                        315
                                                                    highlighted = true
                                                                }
                                                            }
                                                        }
                                                    )
                                                }
                                                if (
                                                    dual_splitter ==
                                                    'play_shield'
                                                ) {
                                                    components[
                                                        dual_splitter
                                                    ].map(
                                                        (component, index) => {
                                                            if (
                                                                [
                                                                    'servo_motor',
                                                                    'servo_motor_360',
                                                                    'servo_motor_270',
                                                                ].includes(
                                                                    extraComponent.type
                                                                )
                                                            ) {
                                                                if (
                                                                    (key ==
                                                                        'C1' ||
                                                                        key ==
                                                                            'C2') &&
                                                                    PortConnections.C ==
                                                                        null
                                                                ) {
                                                                    Left =
                                                                        bibox.left
                                                                    Top =
                                                                        bibox.top
                                                                    highlighted = true
                                                                }
                                                            }
                                                        }
                                                    )
                                                }
                                                /** */

                                                // MOTOR DRIVER
                                                if (
                                                    dual_splitter ==
                                                        'pc_motor_driver' &&
                                                    JSON.parse(
                                                        sessionStorage.getItem(
                                                            'assemblyTwo'
                                                        )
                                                    ).PortConnections.C !== null
                                                ) {
                                                    if (
                                                        JSON.parse(
                                                            sessionStorage.getItem(
                                                                'assemblyTwo'
                                                            )
                                                        ).PortConnections.C
                                                            .type ==
                                                        'pc_motor_driver'
                                                    ) {
                                                        //checking extraCoponent type = geared_motor
                                                        if (
                                                            [
                                                                'dc_motor',
                                                                'geared_motor',
                                                                'mini_geared_motor',
                                                                'dynamex_motor',
                                                            ].includes(
                                                                extraComponent.type
                                                            )
                                                        ) {
                                                            // 1 all ports == null  i.e B1,B2,D1,D2,SMTP == null

                                                            if (
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .STPM ===
                                                                    null &&
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .A1 ===
                                                                    null &&
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .A2 ===
                                                                    null &&
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .C1 ===
                                                                    null &&
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .C2 === null
                                                            ) {
                                                                components[
                                                                    dual_splitter
                                                                ].map(
                                                                    (
                                                                        component,
                                                                        index
                                                                    ) => {
                                                                        if (
                                                                            component.connectedTo ==
                                                                                'A' ||
                                                                            component.connectedTo ==
                                                                                'C'
                                                                        ) {
                                                                            Left =
                                                                                component.left +
                                                                                125
                                                                            Top =
                                                                                component.top +
                                                                                30
                                                                            highlighted = true
                                                                        }
                                                                    }
                                                                )
                                                            }

                                                            // checking connect divice is not == to servo_motot n stepper_motor
                                                            let connectName =
                                                                isMotorConnected_AC()
                                                            if (
                                                                connectName !==
                                                                    'servo_motor' &&
                                                                connectName !==
                                                                    'stepper_motor'
                                                            ) {
                                                                components[
                                                                    dual_splitter
                                                                ].map(
                                                                    (
                                                                        component,
                                                                        index
                                                                    ) => {
                                                                        if (
                                                                            component.connectedTo ==
                                                                                'A' ||
                                                                            component.connectedTo ==
                                                                                'C'
                                                                        ) {
                                                                            Left =
                                                                                component.left +
                                                                                125
                                                                            Top =
                                                                                component.top +
                                                                                30
                                                                            highlighted = true
                                                                        }
                                                                    }
                                                                )
                                                            }
                                                        }

                                                        //checking extraCoponent type = servo_motor
                                                        if (
                                                            extraComponent.type ==
                                                            'servo_motor'
                                                        ) {
                                                            if (
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .A1 ===
                                                                    null &&
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .C1 ===
                                                                    null &&
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .STPM ===
                                                                    null
                                                            ) {
                                                                components[
                                                                    dual_splitter
                                                                ].map(
                                                                    (
                                                                        component,
                                                                        index
                                                                    ) => {
                                                                        if (
                                                                            component.connectedTo ==
                                                                                'A' ||
                                                                            component.connectedTo ==
                                                                                'C'
                                                                        ) {
                                                                            if (
                                                                                key ==
                                                                                'C2'
                                                                            ) {
                                                                                Left =
                                                                                    component.left +
                                                                                    20
                                                                            } else {
                                                                                Left =
                                                                                    component.left +
                                                                                    60
                                                                            }
                                                                            Top =
                                                                                component.top
                                                                            highlighted = true
                                                                        }
                                                                    }
                                                                )
                                                            }

                                                            // checking connect divice is not == to geared_motor n stepper_motor
                                                            let connectName =
                                                                isMotorConnected_AC()
                                                            if (
                                                                ![
                                                                    'dc_motor',
                                                                    'geared_motor',
                                                                    'mini_geared_motor',
                                                                    'dynamex_motor',
                                                                    'stepper_motor',
                                                                ].includes(
                                                                    connectName
                                                                )
                                                            ) {
                                                                components[
                                                                    dual_splitter
                                                                ].map(
                                                                    (
                                                                        component,
                                                                        index
                                                                    ) => {
                                                                        if (
                                                                            component.connectedTo ==
                                                                                'A' ||
                                                                            component.connectedTo ==
                                                                                'C'
                                                                        ) {
                                                                            if (
                                                                                key ==
                                                                                'C2'
                                                                            ) {
                                                                                Left =
                                                                                    component.left +
                                                                                    20
                                                                            } else {
                                                                                Left =
                                                                                    component.left +
                                                                                    60
                                                                            }
                                                                            Top =
                                                                                component.top
                                                                            highlighted = true
                                                                        }
                                                                    }
                                                                )
                                                            }
                                                        }

                                                        //checking extraCoponent type = stepper_motor
                                                    }
                                                }

                                                /** */
                                            }
                                        )
                                    }
                                } else if (
                                    (key == 'B1' || key == 'B2') &&
                                    highlighted &&
                                    !['Toki', 'Poki', 'Moki'].includes(
                                        connectedDevice
                                    )
                                ) {
                                    if (components) {
                                        highlighted = false
                                        Object.keys(components).map((value) => {
                                            // console.log("assemblComponents", value);
                                            if (value == 'dual_splitter') {
                                                components[value].map(
                                                    (component, index) => {
                                                        if (
                                                            extraComponent.type !=
                                                                'geared_motor' &&
                                                            extraComponent.type !=
                                                                'mini_geared_motor' &&
                                                            extraComponent.type !=
                                                                'dc_motor' &&
                                                            extraComponent.type !=
                                                                'dynamex_motor'
                                                        ) {
                                                            if (
                                                                component.connectedTo ==
                                                                'B'
                                                            ) {
                                                                Left =
                                                                    component.left
                                                                Top =
                                                                    component.top
                                                                highlighted = true
                                                            }
                                                            if (
                                                                component.connectedTo ==
                                                                    'B' &&
                                                                (this.props
                                                                    .shield ||
                                                                    this.props
                                                                        .armShield)
                                                            ) {
                                                                if (
                                                                    key == 'B1'
                                                                ) {
                                                                    Left =
                                                                        component.left -
                                                                        268
                                                                    Top =
                                                                        component.top -
                                                                        256
                                                                    highlighted = true
                                                                }
                                                                if (
                                                                    key == 'B2'
                                                                ) {
                                                                    Left =
                                                                        component.left -
                                                                        212
                                                                    Top =
                                                                        component.top -
                                                                        287
                                                                    highlighted = true
                                                                }
                                                            }
                                                        } else {
                                                            if (
                                                                component.connectedTo ==
                                                                'B'
                                                            ) {
                                                                Left =
                                                                    component.left +
                                                                    28
                                                                Top =
                                                                    component.top +
                                                                    5
                                                                highlighted = true
                                                            }
                                                            if (
                                                                component.connectedTo ==
                                                                    'B' &&
                                                                (this.props
                                                                    .shield ||
                                                                    this.props
                                                                        .armShield)
                                                            ) {
                                                                Left =
                                                                    component.left -
                                                                    240
                                                                Top =
                                                                    component.top -
                                                                    250
                                                                highlighted = true
                                                            }
                                                        }
                                                    }
                                                )
                                            }
                                            if (value == 'play_shield') {
                                                components[value].map(
                                                    (component, index) => {
                                                        if (
                                                            extraComponent.type !=
                                                                'geared_motor' &&
                                                            extraComponent.type !=
                                                                'mini_geared_motor' &&
                                                            extraComponent.type !=
                                                                'dc_motor' &&
                                                            extraComponent.type !=
                                                                'dynamex_motor' &&
                                                            extraComponent.type !=
                                                                'servo_motor' &&
                                                            extraComponent.type !=
                                                                'servo_motor_270' &&
                                                            extraComponent.type !=
                                                                'servo_motor_360'
                                                        ) {
                                                            if (
                                                                PortConnections.B ==
                                                                null
                                                            ) {
                                                                if (
                                                                    key == 'B1'
                                                                ) {
                                                                    Left =
                                                                        bibox.left
                                                                    Top =
                                                                        bibox.top
                                                                    highlighted = true
                                                                }

                                                                if (
                                                                    key == 'B2'
                                                                ) {
                                                                    Left =
                                                                        bibox.left
                                                                    Top =
                                                                        bibox.top
                                                                    highlighted = true
                                                                }
                                                            }
                                                        }
                                                    }
                                                )
                                            }
                                            if (value == 'servo_extender') {
                                                components[value].map(
                                                    (component, index) => {
                                                        if (
                                                            component.connectedTo ==
                                                            'B'
                                                        ) {
                                                            Left =
                                                                component.left +
                                                                30
                                                            Top =
                                                                component.top +
                                                                5
                                                            highlighted = true
                                                        }
                                                    }
                                                )
                                            }

                                            // MOTOR DRIVER
                                            if (
                                                value == 'pc_motor_driver' &&
                                                JSON.parse(
                                                    sessionStorage.getItem(
                                                        'assemblyTwo'
                                                    )
                                                ).PortConnections.B !== null
                                            ) {
                                                if (
                                                    JSON.parse(
                                                        sessionStorage.getItem(
                                                            'assemblyTwo'
                                                        )
                                                    ).PortConnections.B.type ==
                                                    'pc_motor_driver'
                                                ) {
                                                    //***checking extraCoponent type = geared_motor
                                                    if (
                                                        [
                                                            'geared_motor',
                                                            'mini_geared_motor',
                                                            'dc_motor',
                                                            'dynamex_motor',
                                                        ].includes(
                                                            extraComponent.type
                                                        )
                                                    ) {
                                                        // 1 all ports == null  i.e B1,B2,D1,D2,SMTP == null

                                                        if (
                                                            JSON.parse(
                                                                sessionStorage.getItem(
                                                                    'assemblyTwo'
                                                                )
                                                            ).PortConnections
                                                                .STPM ===
                                                                null &&
                                                            JSON.parse(
                                                                sessionStorage.getItem(
                                                                    'assemblyTwo'
                                                                )
                                                            ).PortConnections
                                                                .B1 === null &&
                                                            JSON.parse(
                                                                sessionStorage.getItem(
                                                                    'assemblyTwo'
                                                                )
                                                            ).PortConnections
                                                                .B2 === null &&
                                                            JSON.parse(
                                                                sessionStorage.getItem(
                                                                    'assemblyTwo'
                                                                )
                                                            ).PortConnections
                                                                .D1 === null &&
                                                            JSON.parse(
                                                                sessionStorage.getItem(
                                                                    'assemblyTwo'
                                                                )
                                                            ).PortConnections
                                                                .D2 === null
                                                        ) {
                                                            components[
                                                                value
                                                            ].map(
                                                                (
                                                                    component,
                                                                    index
                                                                ) => {
                                                                    if (
                                                                        component.connectedTo ==
                                                                            'B' ||
                                                                        component.connectedTo ==
                                                                            'D'
                                                                    ) {
                                                                        Left =
                                                                            component.left -
                                                                            70
                                                                        Top =
                                                                            component.top +
                                                                            30
                                                                        highlighted = true
                                                                    }
                                                                }
                                                            )
                                                        }

                                                        // checking connect divice is not == to servo_motot n stepper_motor
                                                        let connectName =
                                                            isMotorConnected_BD()
                                                        if (
                                                            connectName !==
                                                                'servo_motor' &&
                                                            connectName !==
                                                                'stepper_motor'
                                                        ) {
                                                            components[
                                                                value
                                                            ].map(
                                                                (
                                                                    component,
                                                                    index
                                                                ) => {
                                                                    if (
                                                                        component.connectedTo ==
                                                                            'B' ||
                                                                        component.connectedTo ==
                                                                            'D'
                                                                    ) {
                                                                        Left =
                                                                            component.left -
                                                                            70
                                                                        Top =
                                                                            component.top +
                                                                            30
                                                                        highlighted = true
                                                                    }
                                                                }
                                                            )
                                                        }
                                                    }

                                                    //****checking extraCoponent type = servo_motor

                                                    if (
                                                        extraComponent.type ==
                                                        'servo_motor'
                                                    ) {
                                                        if (
                                                            JSON.parse(
                                                                sessionStorage.getItem(
                                                                    'assemblyTwo'
                                                                )
                                                            ).PortConnections
                                                                .B1 === null &&
                                                            JSON.parse(
                                                                sessionStorage.getItem(
                                                                    'assemblyTwo'
                                                                )
                                                            ).PortConnections
                                                                .D1 === null &&
                                                            JSON.parse(
                                                                sessionStorage.getItem(
                                                                    'assemblyTwo'
                                                                )
                                                            ).PortConnections
                                                                .STPM === null
                                                        ) {
                                                            components[
                                                                value
                                                            ].map(
                                                                (
                                                                    component,
                                                                    index
                                                                ) => {
                                                                    if (
                                                                        component.connectedTo ==
                                                                            'B' ||
                                                                        component.connectedTo ==
                                                                            'D'
                                                                    ) {
                                                                        if (
                                                                            key ==
                                                                            'B2'
                                                                        ) {
                                                                            Left =
                                                                                component.left -
                                                                                70
                                                                        } else {
                                                                            Left =
                                                                                component.left -
                                                                                25
                                                                        }
                                                                        Top =
                                                                            component.top
                                                                        highlighted = true
                                                                    }
                                                                }
                                                            )
                                                        }

                                                        // checking connect divice is not == to servo_motot n stepper_motor
                                                        let connectName =
                                                            isMotorConnected_BD()
                                                        if (
                                                            ![
                                                                'dc_motor',
                                                                'geared_motor',
                                                                'mini_geared_motor',
                                                                'dynamex_motor',
                                                                'stepper_motor',
                                                            ].includes(
                                                                connectName
                                                            )
                                                        ) {
                                                            components[
                                                                value
                                                            ].map(
                                                                (
                                                                    component,
                                                                    index
                                                                ) => {
                                                                    if (
                                                                        component.connectedTo ==
                                                                            'B' ||
                                                                        component.connectedTo ==
                                                                            'D'
                                                                    ) {
                                                                        if (
                                                                            key ==
                                                                            'B2'
                                                                        ) {
                                                                            Left =
                                                                                component.left -
                                                                                70
                                                                        } else {
                                                                            Left =
                                                                                component.left -
                                                                                25
                                                                        }
                                                                        Top =
                                                                            component.top
                                                                        highlighted = true
                                                                    }
                                                                }
                                                            )
                                                        }
                                                    }

                                                    //checking extraCoponent type = stepper_motor
                                                }
                                            }
                                        })
                                    }
                                } else if (
                                    (key == 'A1' || key == 'A2') &&
                                    highlighted &&
                                    !['Toki', 'Poki', 'Moki'].includes(
                                        connectedDevice
                                    )
                                ) {
                                    if (components) {
                                        highlighted = false
                                        Object.keys(components).map(
                                            (dual_splitter) => {
                                                if (
                                                    dual_splitter ==
                                                    'dual_splitter'
                                                ) {
                                                    components[
                                                        dual_splitter
                                                    ].map(
                                                        (component, index) => {
                                                            if (
                                                                ![
                                                                    'geared_motor',
                                                                    'mini_geared_motor',
                                                                    'dc_motor',
                                                                    'dynamex_motor',
                                                                ].includes(
                                                                    extraComponent.type
                                                                )
                                                            ) {
                                                                if (
                                                                    component.connectedTo ==
                                                                    'A'
                                                                ) {
                                                                    Left =
                                                                        component.left
                                                                    Top =
                                                                        component.top
                                                                    highlighted = true
                                                                }
                                                                if (
                                                                    component.connectedTo ==
                                                                        'A' &&
                                                                    (this.props
                                                                        .shield ||
                                                                        this
                                                                            .props
                                                                            .armShield)
                                                                ) {
                                                                    if (
                                                                        key ==
                                                                        'A1'
                                                                    ) {
                                                                        Left =
                                                                            component.left -
                                                                            87
                                                                        Top =
                                                                            component.top -
                                                                            252
                                                                        highlighted = true
                                                                    }
                                                                    if (
                                                                        key ==
                                                                        'A2'
                                                                    ) {
                                                                        Left =
                                                                            component.left -
                                                                            32
                                                                        Top =
                                                                            component.top -
                                                                            285
                                                                        highlighted = true
                                                                    }
                                                                }
                                                            } else {
                                                                if (
                                                                    component.connectedTo ==
                                                                    'A'
                                                                ) {
                                                                    Left =
                                                                        component.left +
                                                                        28
                                                                    Top =
                                                                        component.top +
                                                                        5
                                                                    highlighted = true
                                                                }
                                                                if (
                                                                    component.connectedTo ==
                                                                        'A' &&
                                                                    (this.props
                                                                        .shield ||
                                                                        this
                                                                            .props
                                                                            .armShield)
                                                                ) {
                                                                    Left =
                                                                        component.left -
                                                                        60
                                                                    Top =
                                                                        component.top -
                                                                        248
                                                                    highlighted = true
                                                                }
                                                            }
                                                        }
                                                    )
                                                }
                                                if (
                                                    dual_splitter ==
                                                    'play_shield'
                                                ) {
                                                    components[
                                                        dual_splitter
                                                    ].map(
                                                        (component, index) => {
                                                            if (
                                                                extraComponent.type !=
                                                                    'geared_motor' &&
                                                                extraComponent.type !=
                                                                    'mini_geared_motor' &&
                                                                extraComponent.type !=
                                                                    'dc_motor' &&
                                                                extraComponent.type !=
                                                                    'dynamex_motor' &&
                                                                extraComponent.type !=
                                                                    'servo_motor' &&
                                                                extraComponent.type !=
                                                                    'servo_motor_270' &&
                                                                extraComponent.type !=
                                                                    'servo_motor_360'
                                                            ) {
                                                                if (
                                                                    PortConnections.A ==
                                                                    null
                                                                ) {
                                                                    if (
                                                                        key ==
                                                                        'A1'
                                                                    ) {
                                                                        Left =
                                                                            bibox.left
                                                                        Top =
                                                                            bibox.top
                                                                        highlighted = true
                                                                    }
                                                                    if (
                                                                        key ==
                                                                        'A2'
                                                                    ) {
                                                                        Left =
                                                                            bibox.left
                                                                        Top =
                                                                            bibox.top
                                                                        highlighted = true
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    )
                                                }

                                                /** */
                                                // MOTOR DRIVER
                                                if (
                                                    dual_splitter ==
                                                        'pc_motor_driver' &&
                                                    JSON.parse(
                                                        sessionStorage.getItem(
                                                            'assemblyTwo'
                                                        )
                                                    ).PortConnections.A !== null
                                                ) {
                                                    if (
                                                        JSON.parse(
                                                            sessionStorage.getItem(
                                                                'assemblyTwo'
                                                            )
                                                        ).PortConnections.A
                                                            .type ==
                                                        'pc_motor_driver'
                                                    ) {
                                                        //***checking extraCoponent type = geared_motor
                                                        if (
                                                            [
                                                                'geared_motor',
                                                                'mini_geared_motor',
                                                                'dc_motor',
                                                                'dynamex_motor',
                                                            ].includes(
                                                                extraComponent.type
                                                            )
                                                        ) {
                                                            // 1 all ports == null  i.e B1,B2,D1,D2,SMTP == null

                                                            if (
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .STPM ===
                                                                    null &&
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .A1 ===
                                                                    null &&
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .A2 ===
                                                                    null &&
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .C1 ===
                                                                    null &&
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .C2 === null
                                                            ) {
                                                                components[
                                                                    dual_splitter
                                                                ].map(
                                                                    (
                                                                        component,
                                                                        index
                                                                    ) => {
                                                                        if (
                                                                            component.connectedTo ==
                                                                                'A' ||
                                                                            component.connectedTo ==
                                                                                'C'
                                                                        ) {
                                                                            Left =
                                                                                component.left -
                                                                                70
                                                                            Top =
                                                                                component.top +
                                                                                30
                                                                            highlighted = true
                                                                        }
                                                                    }
                                                                )
                                                            }

                                                            // checking connect divice is not == to servo_motot n stepper_motor
                                                            let connectName =
                                                                isMotorConnected_AC()
                                                            if (
                                                                connectName !==
                                                                    'servo_motor' &&
                                                                connectName !==
                                                                    'stepper_motor'
                                                            ) {
                                                                components[
                                                                    dual_splitter
                                                                ].map(
                                                                    (
                                                                        component,
                                                                        index
                                                                    ) => {
                                                                        if (
                                                                            component.connectedTo ==
                                                                                'A' ||
                                                                            component.connectedTo ==
                                                                                'C'
                                                                        ) {
                                                                            Left =
                                                                                component.left -
                                                                                70
                                                                            Top =
                                                                                component.top +
                                                                                30
                                                                            highlighted = true
                                                                        }
                                                                    }
                                                                )
                                                            }
                                                        }

                                                        //****checking extraCoponent type = servo_motor

                                                        if (
                                                            extraComponent.type ==
                                                            'servo_motor'
                                                        ) {
                                                            if (
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .A1 ===
                                                                    null &&
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .C1 ===
                                                                    null &&
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'assemblyTwo'
                                                                    )
                                                                )
                                                                    .PortConnections
                                                                    .STPM ===
                                                                    null
                                                            ) {
                                                                components[
                                                                    dual_splitter
                                                                ].map(
                                                                    (
                                                                        component,
                                                                        index
                                                                    ) => {
                                                                        if (
                                                                            component.connectedTo ==
                                                                                'A' ||
                                                                            component.connectedTo ==
                                                                                'C'
                                                                        ) {
                                                                            if (
                                                                                key ==
                                                                                'A2'
                                                                            ) {
                                                                                Left =
                                                                                    component.left -
                                                                                    70
                                                                            } else {
                                                                                Left =
                                                                                    component.left -
                                                                                    25
                                                                            }
                                                                            Top =
                                                                                component.top
                                                                            highlighted = true
                                                                        }
                                                                    }
                                                                )
                                                            }

                                                            // checking connect divice is not == to servo_motot n stepper_motor
                                                            let connectName =
                                                                isMotorConnected_AC()
                                                            if (
                                                                ![
                                                                    'geared_motor',
                                                                    'mini_geared_motor',
                                                                    'dc_motor',
                                                                    'dynamex_motor',
                                                                    'stepper_motor',
                                                                ].includes(
                                                                    connectName
                                                                )
                                                            ) {
                                                                components[
                                                                    dual_splitter
                                                                ].map(
                                                                    (
                                                                        component,
                                                                        index
                                                                    ) => {
                                                                        if (
                                                                            component.connectedTo ==
                                                                                'A' ||
                                                                            component.connectedTo ==
                                                                                'C'
                                                                        ) {
                                                                            if (
                                                                                key ==
                                                                                'A2'
                                                                            ) {
                                                                                Left =
                                                                                    component.left -
                                                                                    70
                                                                            } else {
                                                                                Left =
                                                                                    component.left -
                                                                                    25
                                                                            }
                                                                            Top =
                                                                                component.top
                                                                            highlighted = true
                                                                        }
                                                                    }
                                                                )
                                                            }
                                                        }

                                                        //checking extraCoponent type = stepper_motor
                                                    }
                                                }

                                                /** */
                                            }
                                        )
                                    }
                                } else if (
                                    (key == 'E1' || key == 'E2') &&
                                    highlighted &&
                                    !['Moki'].includes(connectedDevice)
                                ) {
                                    let isGetPosition = false
                                    let oldHighlighted = highlighted
                                    if (components) {
                                        highlighted = false
                                        Object.keys(components).map(
                                            (dual_splitter) => {
                                                if (
                                                    dual_splitter ==
                                                    'dual_splitter'
                                                ) {
                                                    components[
                                                        dual_splitter
                                                    ].map(
                                                        (component, index) => {
                                                            if (
                                                                extraComponent.type !=
                                                                    'geared_motor' &&
                                                                extraComponent.type !=
                                                                    'mini_geared_motor' &&
                                                                extraComponent.type !=
                                                                    'dc_motor' &&
                                                                extraComponent.type !=
                                                                    'dynamex_motor'
                                                            ) {
                                                                if (
                                                                    component.connectedTo ==
                                                                    'E'
                                                                ) {
                                                                    if (
                                                                        key ==
                                                                        'E1'
                                                                    ) {
                                                                        Left =
                                                                            component.left +
                                                                            5
                                                                        Top =
                                                                            component.top -
                                                                            74
                                                                        highlighted = true
                                                                    }
                                                                    if (
                                                                        key ==
                                                                        'E2'
                                                                    ) {
                                                                        Left =
                                                                            component.left -
                                                                            5
                                                                        Top =
                                                                            component.top -
                                                                            68
                                                                        highlighted = true
                                                                    }
                                                                }
                                                            } else {
                                                                if (
                                                                    component.connectedTo ==
                                                                    'E'
                                                                ) {
                                                                    console.log(
                                                                        'highlited true'
                                                                    )
                                                                    Left =
                                                                        component.left +
                                                                        30
                                                                    Top =
                                                                        component.top -
                                                                        70
                                                                    highlighted = true
                                                                }
                                                            }
                                                        }
                                                    )
                                                } else if (
                                                    connectedDevice ===
                                                        'Poki' &&
                                                    dual_splitter === 'OLED'
                                                ) {
                                                    components[
                                                        dual_splitter
                                                    ].map(
                                                        (component, index) => {
                                                            if (
                                                                component.connectedTo ==
                                                                'E'
                                                            ) {
                                                                isGetPosition = true
                                                                Top =
                                                                    component.top -
                                                                    127
                                                                Left =
                                                                    component.left -
                                                                    13
                                                                highlighted = true
                                                            }
                                                        }
                                                    )
                                                }
                                            }
                                        )
                                    }

                                    if (
                                        connectedDevice === 'Poki' &&
                                        !isGetPosition
                                    ) {
                                        Top = bibox.top
                                        Left = bibox.left
                                        highlighted = oldHighlighted
                                    }
                                } else if (
                                    (key == 'F1' || key == 'F2') &&
                                    highlighted &&
                                    !['Klaw', 'Poki', 'Moki'].includes(
                                        connectedDevice
                                    )
                                ) {
                                    if (components) {
                                        highlighted = false
                                        Object.keys(components).map(
                                            (dual_splitter) => {
                                                if (
                                                    dual_splitter ==
                                                    'dual_splitter'
                                                ) {
                                                    components[
                                                        dual_splitter
                                                    ].map(
                                                        (component, index) => {
                                                            if (
                                                                ![
                                                                    'geared_motor',
                                                                    'mini_geared_motor',
                                                                    'dc_motor',
                                                                    'dynamex_motor',
                                                                ].includes(
                                                                    extraComponent.type
                                                                )
                                                            ) {
                                                                if (
                                                                    component.connectedTo ==
                                                                    'F'
                                                                ) {
                                                                    if (
                                                                        key ==
                                                                        'F1'
                                                                    ) {
                                                                        Left =
                                                                            component.left +
                                                                            5
                                                                        Top =
                                                                            component.top -
                                                                            74
                                                                        highlighted = true
                                                                    }
                                                                    if (
                                                                        key ==
                                                                        'F2'
                                                                    ) {
                                                                        Left =
                                                                            component.left -
                                                                            5
                                                                        Top =
                                                                            component.top -
                                                                            68
                                                                        highlighted = true
                                                                    }
                                                                }
                                                            } else {
                                                                if (
                                                                    component.connectedTo ==
                                                                    'F'
                                                                ) {
                                                                    console.log(
                                                                        'highlited true'
                                                                    )
                                                                    Left =
                                                                        component.left +
                                                                        30
                                                                    Top =
                                                                        component.top -
                                                                        70
                                                                    highlighted = true
                                                                }
                                                            }
                                                        }
                                                    )
                                                }
                                            }
                                        )
                                    }
                                } else if (
                                    ![
                                        'Roboki',
                                        'Klaw',
                                        'Atr',
                                        'Toki',
                                        'Poki',
                                        'Moki',
                                    ].includes(
                                        sessionStorage.getItem(
                                            'connectedDevice'
                                        )
                                    ) &&
                                    key == 'M1' &&
                                    highlighted
                                ) {
                                    if (components) {
                                        console.log('v1', components)
                                        highlighted = false
                                        Object.keys(components).map(
                                            (dual_splitter) => {
                                                if (
                                                    dual_splitter ==
                                                        'play_shield' ||
                                                    dual_splitter ==
                                                        'play_shield_v1'
                                                ) {
                                                    components[
                                                        dual_splitter
                                                    ].map(
                                                        (component, index) => {
                                                            if (
                                                                [
                                                                    'dc_motor',
                                                                    'geared_motor',
                                                                    'mini_geared_motor',
                                                                    'dynamex_motor',
                                                                ].includes(
                                                                    extraComponent.type
                                                                )
                                                            ) {
                                                                Left =
                                                                    bibox.left
                                                                Top = bibox.top
                                                                highlighted = true
                                                            }
                                                        }
                                                    )
                                                } else if (
                                                    dual_splitter ==
                                                    'peeCee_ATR'
                                                ) {
                                                    components[
                                                        dual_splitter
                                                    ].map(
                                                        (component, index) => {
                                                            Left = bibox.left
                                                            Top = bibox.top
                                                            highlighted = true
                                                        }
                                                    )
                                                }
                                            }
                                        )
                                    }
                                } else if (
                                    ![
                                        'Roboki',
                                        'Klaw',
                                        'Atr',
                                        'Toki',
                                        'Poki',
                                        'Moki',
                                    ].includes(
                                        sessionStorage.getItem(
                                            'connectedDevice'
                                        )
                                    ) &&
                                    key == 'M3' &&
                                    highlighted
                                ) {
                                    if (components) {
                                        highlighted = false
                                        Object.keys(components).map(
                                            (dual_splitter) => {
                                                if (
                                                    dual_splitter ==
                                                        'play_shield' ||
                                                    dual_splitter ==
                                                        'play_shield_v1' ||
                                                    dual_splitter ==
                                                        'peeCee_ATR'
                                                ) {
                                                    components[
                                                        dual_splitter
                                                    ].map(
                                                        (component, index) => {
                                                            if (
                                                                [
                                                                    'dc_motor',
                                                                    'geared_motor',
                                                                    'mini_geared_motor',
                                                                    'dynamex_motor',
                                                                ].includes(
                                                                    extraComponent.type
                                                                )
                                                            ) {
                                                                Left =
                                                                    bibox.left
                                                                Top = bibox.top
                                                                highlighted = true
                                                            }
                                                        }
                                                    )
                                                }
                                            }
                                        )
                                    }
                                } else if (
                                    (key == 'M2' || key == 'M4') &&
                                    highlighted
                                ) {
                                    if (components) {
                                        highlighted = false
                                        Object.keys(components).map(
                                            (sensor) => {
                                                if (sensor == 'peeCee_ATR') {
                                                    components[sensor].map(
                                                        (component, index) => {
                                                            Left = bibox.left
                                                            Top = bibox.top
                                                            highlighted = true
                                                        }
                                                    )
                                                }
                                            }
                                        )
                                    }
                                } else if (key == 'MOTOR1' && highlighted) {
                                    if (components) {
                                        highlighted = false
                                        Object.keys(components).map(
                                            (sensor) => {
                                                if (sensor == 'arm_shield') {
                                                    components[sensor].map(
                                                        (component, index) => {
                                                            if (
                                                                [
                                                                    'geared_motor',
                                                                    'mini_geared_motor',
                                                                    'dc_motor',
                                                                    'dynamex_motor',
                                                                ].includes(
                                                                    extraComponent.type
                                                                )
                                                            ) {
                                                                Left =
                                                                    bibox.left
                                                                Top = bibox.top
                                                                highlighted = true
                                                            }
                                                        }
                                                    )
                                                }
                                            }
                                        )
                                    }
                                } else if (
                                    (key == 'P1' ||
                                        key == 'P2' ||
                                        key == 'P3' ||
                                        key == 'SS' ||
                                        key == 'SPK') &&
                                    highlighted
                                ) {
                                    if (components) {
                                        highlighted = false
                                        Object.keys(components).map(
                                            (sensor) => {
                                                if (sensor == 'arm_shield') {
                                                    components[sensor].map(
                                                        (component, index) => {
                                                            Left = bibox.left
                                                            Top = bibox.top
                                                            highlighted = true
                                                        }
                                                    )
                                                }
                                            }
                                        )
                                    }
                                } else if (key == 'STPM' && highlighted) {
                                    if (components) {
                                        highlighted = false

                                        Object.keys(components).map(
                                            (dataVal) => {
                                                if (
                                                    dataVal == 'pc_motor_driver'
                                                ) {
                                                    // isPcMotorDriver = true;

                                                    let pc_motor_driverConnectedTo =
                                                        isPc_motor_driverConnected_BD_AC()

                                                    if (
                                                        pc_motor_driverConnectedTo ==
                                                            'B' ||
                                                        pc_motor_driverConnectedTo ==
                                                            'D'
                                                    ) {
                                                        if (
                                                            JSON.parse(
                                                                sessionStorage.getItem(
                                                                    'assemblyTwo'
                                                                )
                                                            ).PortConnections
                                                                .B1 === null &&
                                                            JSON.parse(
                                                                sessionStorage.getItem(
                                                                    'assemblyTwo'
                                                                )
                                                            ).PortConnections
                                                                .B2 === null &&
                                                            JSON.parse(
                                                                sessionStorage.getItem(
                                                                    'assemblyTwo'
                                                                )
                                                            ).PortConnections
                                                                .D1 === null &&
                                                            JSON.parse(
                                                                sessionStorage.getItem(
                                                                    'assemblyTwo'
                                                                )
                                                            ).PortConnections
                                                                .D2 === null
                                                        ) {
                                                            components[
                                                                dataVal
                                                            ].map(
                                                                (
                                                                    component,
                                                                    index
                                                                ) => {
                                                                    if (
                                                                        component.connectedTo ==
                                                                            'B' ||
                                                                        component.connectedTo ==
                                                                            'D'
                                                                    ) {
                                                                        Left =
                                                                            component.left
                                                                        Top =
                                                                            component.top
                                                                        highlighted = true
                                                                    }
                                                                }
                                                            )
                                                        }
                                                    }

                                                    // if (
                                                    //   JSON.parse(sessionStorage.getItem("assembly"))
                                                    //     .PortConnections.B1 === null &&
                                                    //   JSON.parse(sessionStorage.getItem("assembly"))
                                                    //     .PortConnections.B2 === null &&
                                                    //   JSON.parse(sessionStorage.getItem("assembly"))
                                                    //     .PortConnections.D1 === null &&
                                                    //   JSON.parse(sessionStorage.getItem("assembly"))
                                                    //     .PortConnections.D2 === null
                                                    // ) {
                                                    //   components[dataVal].map((component, index) => {
                                                    //     if (
                                                    //       component.connectedTo == "B" ||
                                                    //       component.connectedTo == "D" ||
                                                    //       component.connectedTo == "A" ||
                                                    //       component.connectedTo == "C"
                                                    //     ) {
                                                    //       Left = component.left;
                                                    //       Top = component.top;
                                                    //       highlighted = true;
                                                    //     }
                                                    //   });
                                                    // }

                                                    if (
                                                        pc_motor_driverConnectedTo ==
                                                            'C' ||
                                                        pc_motor_driverConnectedTo ==
                                                            'A'
                                                    ) {
                                                        if (
                                                            JSON.parse(
                                                                sessionStorage.getItem(
                                                                    'assemblyTwo'
                                                                )
                                                            ).PortConnections
                                                                .A1 === null &&
                                                            JSON.parse(
                                                                sessionStorage.getItem(
                                                                    'assemblyTwo'
                                                                )
                                                            ).PortConnections
                                                                .A2 === null &&
                                                            JSON.parse(
                                                                sessionStorage.getItem(
                                                                    'assemblyTwo'
                                                                )
                                                            ).PortConnections
                                                                .C1 === null &&
                                                            JSON.parse(
                                                                sessionStorage.getItem(
                                                                    'assemblyTwo'
                                                                )
                                                            ).PortConnections
                                                                .C2 === null
                                                        ) {
                                                            components[
                                                                dataVal
                                                            ].map(
                                                                (
                                                                    component,
                                                                    index
                                                                ) => {
                                                                    if (
                                                                        component.connectedTo ==
                                                                            'A' ||
                                                                        component.connectedTo ==
                                                                            'C'
                                                                    ) {
                                                                        Left =
                                                                            component.left
                                                                        Top =
                                                                            component.top
                                                                        highlighted = true
                                                                    }
                                                                }
                                                            )
                                                        }
                                                    }
                                                }
                                            }
                                        )
                                    }
                                } else {
                                    // ABCD
                                    Top = bibox.top
                                    Left = bibox.left
                                }
                            } else {
                                if (
                                    (key == 'F1' || key == 'F2') &&
                                    highlighted
                                ) {
                                    if (components) {
                                        highlighted = false
                                        Object.keys(components).map((key) => {
                                            if (key == 'dual_splitter') {
                                                components[key].map(
                                                    (component, index) => {
                                                        if (
                                                            component.connectedTo ==
                                                            'F'
                                                        ) {
                                                            Left =
                                                                component.left
                                                            Top = component.top
                                                            highlighted = true
                                                        }
                                                    }
                                                )
                                            } else if (
                                                key == 'servo_extender'
                                            ) {
                                                components[key].map(
                                                    (component, index) => {
                                                        if (
                                                            component.connectedTo ==
                                                            'F'
                                                        ) {
                                                            Left =
                                                                component.left +
                                                                30
                                                            Top =
                                                                component.top +
                                                                5
                                                            highlighted = true
                                                        }
                                                    }
                                                )
                                            }
                                        })
                                    }
                                } else if (
                                    (key == 'G1' || key == 'G2') &&
                                    highlighted
                                ) {
                                    if (components) {
                                        highlighted = false
                                        Object.keys(components).map(
                                            (dual_splitter) => {
                                                if (
                                                    dual_splitter ==
                                                    'dual_splitter'
                                                ) {
                                                    components[
                                                        dual_splitter
                                                    ].map(
                                                        (component, index) => {
                                                            if (
                                                                component.connectedTo ==
                                                                'G'
                                                            ) {
                                                                Left =
                                                                    component.left
                                                                Top =
                                                                    component.top
                                                                highlighted = true
                                                            }
                                                        }
                                                    )
                                                }
                                            }
                                        )
                                    }
                                } else if (
                                    (key == 'I1' || key == 'I2') &&
                                    highlighted
                                ) {
                                    if (components) {
                                        highlighted = false
                                        Object.keys(components).map(
                                            (dual_splitter) => {
                                                if (
                                                    dual_splitter ==
                                                    'dual_splitter'
                                                ) {
                                                    components[
                                                        dual_splitter
                                                    ].map(
                                                        (component, index) => {
                                                            if (
                                                                component.connectedTo ==
                                                                'I'
                                                            ) {
                                                                Left =
                                                                    component.left
                                                                Top =
                                                                    component.top
                                                                highlighted = true
                                                            }
                                                        }
                                                    )
                                                }
                                            }
                                        )
                                    }
                                } else if (
                                    (key == 'H1' || key == 'H2') &&
                                    highlighted
                                ) {
                                    if (components) {
                                        highlighted = false
                                        Object.keys(components).map(
                                            (dual_splitter) => {
                                                if (
                                                    dual_splitter ==
                                                    'dual_splitter'
                                                ) {
                                                    components[
                                                        dual_splitter
                                                    ].map(
                                                        (component, index) => {
                                                            if (
                                                                component.connectedTo ==
                                                                'H'
                                                            ) {
                                                                Left =
                                                                    component.left
                                                                Top =
                                                                    component.top
                                                                highlighted = true
                                                            }
                                                        }
                                                    )
                                                }
                                            }
                                        )
                                    }
                                } else if (
                                    (key == 'E1' || key == 'E2') &&
                                    highlighted
                                ) {
                                    if (components) {
                                        highlighted = false
                                        Object.keys(components).map(
                                            (dual_splitter) => {
                                                if (
                                                    dual_splitter ==
                                                    'dual_splitter'
                                                ) {
                                                    components[
                                                        dual_splitter
                                                    ].map(
                                                        (component, index) => {
                                                            if (
                                                                component.connectedTo ==
                                                                'E'
                                                            ) {
                                                                Left =
                                                                    component.left
                                                                Top =
                                                                    component.top
                                                                highlighted = true
                                                            }
                                                        }
                                                    )
                                                }
                                            }
                                        )
                                    }
                                } else if (
                                    (key == 'D1' || key == 'D2') &&
                                    highlighted
                                ) {
                                    if (components) {
                                        highlighted = false
                                        Object.keys(components).map(
                                            (dual_splitter) => {
                                                if (
                                                    dual_splitter ==
                                                    'dual_splitter'
                                                ) {
                                                    components[
                                                        dual_splitter
                                                    ].map(
                                                        (component, index) => {
                                                            if (
                                                                component.connectedTo ==
                                                                'D'
                                                            ) {
                                                                Left =
                                                                    component.left
                                                                Top =
                                                                    component.top
                                                                highlighted = true
                                                            }
                                                        }
                                                    )
                                                }
                                            }
                                        )
                                    }
                                } else if (
                                    (key == 'C1' || key == 'C2') &&
                                    highlighted
                                ) {
                                    if (components) {
                                        highlighted = false
                                        Object.keys(components).map(
                                            (dual_splitter) => {
                                                if (
                                                    dual_splitter ==
                                                    'dual_splitter'
                                                ) {
                                                    components[
                                                        dual_splitter
                                                    ].map(
                                                        (component, index) => {
                                                            if (
                                                                component.connectedTo ==
                                                                'C'
                                                            ) {
                                                                Left =
                                                                    component.left
                                                                Top =
                                                                    component.top
                                                                highlighted = true
                                                            }
                                                        }
                                                    )
                                                }
                                            }
                                        )
                                    }
                                } else if (
                                    (key == 'B1' || key == 'B2') &&
                                    highlighted
                                ) {
                                    if (components) {
                                        highlighted = false
                                        Object.keys(components).map((value) => {
                                            if (value == 'dual_splitter') {
                                                components[value].map(
                                                    (component, index) => {
                                                        if (
                                                            component.connectedTo ==
                                                            'B'
                                                        ) {
                                                            Left =
                                                                component.left
                                                            Top = component.top
                                                            highlighted = true
                                                        }
                                                    }
                                                )
                                            }
                                            if (value == 'servo_extender') {
                                                components[value].map(
                                                    (component, index) => {
                                                        if (
                                                            component.connectedTo ==
                                                            'B'
                                                        ) {
                                                            Left =
                                                                component.left +
                                                                30
                                                            Top =
                                                                component.top +
                                                                5
                                                            highlighted = true
                                                        }
                                                    }
                                                )
                                            }
                                        })
                                    }
                                } else if (
                                    (key == 'A1' || key == 'A2') &&
                                    highlighted
                                ) {
                                    if (components) {
                                        highlighted = false
                                        Object.keys(components).map(
                                            (dual_splitter) => {
                                                if (
                                                    dual_splitter ==
                                                    'dual_splitter'
                                                ) {
                                                    components[
                                                        dual_splitter
                                                    ].map(
                                                        (component, index) => {
                                                            if (
                                                                component.connectedTo ==
                                                                'A'
                                                            ) {
                                                                Left =
                                                                    component.left
                                                                Top =
                                                                    component.top
                                                                highlighted = true
                                                            }
                                                        }
                                                    )
                                                }
                                            }
                                        )
                                    }
                                } else {
                                    Top = bibox.top
                                    Left = bibox.left
                                }
                            }

                            /* here we are checking that if led,dual splitter is connected to "A" then DRIVER_MOTOR will not connect to A, C ports*/
                            if (
                                sessionStorage.getItem('dragingItem') ==
                                'dual_spliier'
                            ) {
                                let PortConnections = JSON.parse(
                                    sessionStorage.getItem('assemblyTwo')
                                ).PortConnections

                                if (key == 'A') {
                                    if (
                                        JSON.parse(
                                            sessionStorage.getItem(
                                                'assemblyTwo'
                                            )
                                        ).PortConnections.A === null &&
                                        JSON.parse(
                                            sessionStorage.getItem(
                                                'assemblyTwo'
                                            )
                                        ).PortConnections.C === null
                                    ) {
                                        return (
                                            <g
                                                key={key}
                                                stroke="white"
                                                strokeWidth="2"
                                                fill={
                                                    PortTypes[
                                                        `${connectedDevice.toUpperCase()}`
                                                    ][key].color
                                                }
                                            >
                                                {PortTypes[
                                                    `${connectedDevice.toUpperCase()}`
                                                ][key].ports.map(
                                                    (port) => (
                                                        <PortCircle
                                                            style={{
                                                                visibility:
                                                                    'hidden',
                                                            }}
                                                            left={
                                                                Left +
                                                                Ports(port)[0]
                                                            }
                                                            top={
                                                                Top +
                                                                Ports(port)[1]
                                                            }
                                                            key={port}
                                                            highlighted={
                                                                !PortConnections[
                                                                    port
                                                                ] &&
                                                                highlighted &&
                                                                (!highlightPort ||
                                                                    highlightPort ===
                                                                        port)
                                                            }
                                                            PortConnections={
                                                                PortConnections
                                                            }
                                                            forceHighlight={
                                                                highlightPort ===
                                                                port
                                                            }
                                                            isFinalSlide={
                                                                this.props
                                                                    .isFinalSlide
                                                            }
                                                        />
                                                    )

                                                    //It highlight only those whih are
                                                )}
                                            </g>
                                        )
                                    }
                                }
                                if (key == 'B') {
                                    if (
                                        JSON.parse(
                                            sessionStorage.getItem(
                                                'assemblyTwo'
                                            )
                                        ).PortConnections.B === null &&
                                        JSON.parse(
                                            sessionStorage.getItem(
                                                'assemblyTwo'
                                            )
                                        ).PortConnections.D === null
                                    ) {
                                        return (
                                            <g
                                                key={key}
                                                stroke="white"
                                                strokeWidth="2"
                                                fill={
                                                    PortTypes[
                                                        `${connectedDevice.toUpperCase()}`
                                                    ][key].color
                                                }
                                            >
                                                {PortTypes[
                                                    `${connectedDevice.toUpperCase()}`
                                                ][key].ports.map(
                                                    (port) => (
                                                        // Ports.js helping the dual_spliter to assign dots on dual_spliter ex - D1,D2
                                                        // PPP

                                                        <PortCircle
                                                            style={{
                                                                visibility:
                                                                    'hidden',
                                                            }}
                                                            left={
                                                                Left +
                                                                Ports(port)[0]
                                                            }
                                                            top={
                                                                Top +
                                                                Ports(port)[1]
                                                            }
                                                            key={port}
                                                            highlighted={
                                                                !PortConnections[
                                                                    port
                                                                ] &&
                                                                highlighted &&
                                                                (!highlightPort ||
                                                                    highlightPort ===
                                                                        port)
                                                            }
                                                            PortConnections={
                                                                PortConnections
                                                            }
                                                            forceHighlight={
                                                                highlightPort ===
                                                                port
                                                            }
                                                            isFinalSlide={
                                                                this.props
                                                                    .isFinalSlide
                                                            }
                                                        />
                                                    )

                                                    //It highlight only those whih are
                                                )}
                                            </g>
                                        )
                                    }
                                }
                                if (key == 'C') {
                                    if (
                                        JSON.parse(
                                            sessionStorage.getItem(
                                                'assemblyTwo'
                                            )
                                        ).PortConnections.A === null &&
                                        JSON.parse(
                                            sessionStorage.getItem(
                                                'assemblyTwo'
                                            )
                                        ).PortConnections.C === null
                                    ) {
                                        return (
                                            <g
                                                key={key}
                                                stroke="white"
                                                strokeWidth="2"
                                                fill={
                                                    PortTypes[
                                                        `${connectedDevice.toUpperCase()}`
                                                    ][key].color
                                                }
                                            >
                                                {PortTypes[
                                                    `${connectedDevice.toUpperCase()}`
                                                ][key].ports.map(
                                                    (port) => (
                                                        // Ports.js helping the dual_spliter to assign dots on dual_spliter ex - D1,D2
                                                        // PPP

                                                        <PortCircle
                                                            style={{
                                                                visibility:
                                                                    'hidden',
                                                            }}
                                                            left={
                                                                Left +
                                                                Ports(port)[0]
                                                            }
                                                            top={
                                                                Top +
                                                                Ports(port)[1]
                                                            }
                                                            key={port}
                                                            highlighted={
                                                                !PortConnections[
                                                                    port
                                                                ] &&
                                                                highlighted &&
                                                                (!highlightPort ||
                                                                    highlightPort ===
                                                                        port)
                                                            }
                                                            PortConnections={
                                                                PortConnections
                                                            }
                                                            forceHighlight={
                                                                highlightPort ===
                                                                port
                                                            }
                                                            isFinalSlide={
                                                                this.props
                                                                    .isFinalSlide
                                                            }
                                                        />
                                                    )

                                                    //It highlight only those whih are
                                                )}
                                            </g>
                                        )
                                    }
                                }
                                if (key == 'D') {
                                    if (
                                        JSON.parse(
                                            sessionStorage.getItem(
                                                'assemblyTwo'
                                            )
                                        ).PortConnections.B === null &&
                                        JSON.parse(
                                            sessionStorage.getItem(
                                                'assemblyTwo'
                                            )
                                        ).PortConnections.D === null
                                    ) {
                                        return (
                                            <g
                                                key={key}
                                                stroke="white"
                                                strokeWidth="2"
                                                fill={
                                                    PortTypes[
                                                        `${connectedDevice.toUpperCase()}`
                                                    ][key].color
                                                }
                                            >
                                                {PortTypes[
                                                    `${connectedDevice.toUpperCase()}`
                                                ][key].ports.map(
                                                    (port) => (
                                                        // Ports.js helping the dual_spliter to assign dots on dual_spliter ex - D1,D2
                                                        // PPP

                                                        <PortCircle
                                                            style={{
                                                                visibility:
                                                                    'hidden',
                                                            }}
                                                            left={
                                                                Left +
                                                                Ports(port)[0]
                                                            }
                                                            top={
                                                                Top +
                                                                Ports(port)[1]
                                                            }
                                                            key={port}
                                                            highlighted={
                                                                !PortConnections[
                                                                    port
                                                                ] &&
                                                                highlighted &&
                                                                (!highlightPort ||
                                                                    highlightPort ===
                                                                        port)
                                                            }
                                                            PortConnections={
                                                                PortConnections
                                                            }
                                                            forceHighlight={
                                                                highlightPort ===
                                                                port
                                                            }
                                                            isFinalSlide={
                                                                this.props
                                                                    .isFinalSlide
                                                            }
                                                        />
                                                    )

                                                    //It highlight only those whih are
                                                )}
                                            </g>
                                        )
                                    }
                                }
                            } else {
                                // console.log("key", key);
                                //////// HOTFIX for hiding PortCircle motor getting connected when port is already occupied ////
                                const draggingItem =
                                    sessionStorage.getItem('dragingItem')
                                // const assemblyConnections = JSON.parse(
                                //     sessionStorage.getItem('assemblyTwo')
                                // ).PortConnections

                                if (
                                    [
                                        'mini_geared_motor',
                                        'geared_motor',
                                        'dc_motor',
                                        'dynamex_motor',
                                    ].includes(draggingItem)
                                ) {
                                    if (
                                        key == 'A1' &&
                                        assemblyConnections.A2 != null
                                    )
                                        return
                                    if (
                                        key == 'B1' &&
                                        assemblyConnections.B2 != null
                                    )
                                        return
                                    if (
                                        key == 'C1' &&
                                        assemblyConnections.C2 != null &&
                                        !['Toki', 'Poki', 'Moki'].includes(
                                            connectedDevice
                                        )
                                    )
                                        return
                                    if (
                                        key == 'D1' &&
                                        assemblyConnections.D2 != null
                                    )
                                        return
                                    if (
                                        key == 'E1' &&
                                        assemblyConnections.E2 != null
                                    )
                                        return

                                    if (
                                        connectedDevice !== 'Klaw' &&
                                        key == 'F1' &&
                                        assemblyConnections.F2 != null
                                    )
                                        return
                                }
                                if (
                                    connectedDevice === 'Klaw' &&
                                    draggingItem === 'serial_servo_motor'
                                ) {
                                    const assemblyConnections = JSON.parse(
                                        sessionStorage.getItem('assemblyTwo')
                                    ).PortConnections
                                    if (
                                        assemblyConnections.serial_servo2 !==
                                            null ||
                                        assemblyConnections.serial_servo2 !==
                                            null
                                    )
                                        return false
                                }

                                ///////////////////////////////////////////////////////////////////////////////////////////////

                                /////////////////////// PLAYC-39 ////////////////////////
                                ///// Disabling certain ports when certain
                                ///// internal accessories are selected
                                if (
                                    !sessionStorage
                                        .getItem('deviceVersion')
                                        ?.startsWith('1')
                                ) {
                                    const internalAccessories = JSON.parse(
                                        sessionStorage.getItem('concept')
                                    ).internalaccessories

                                    const portConnections = JSON.parse(
                                        sessionStorage.getItem('assemblyTwo')
                                    ).PortConnections

                                    const is4in1SensorConnected =
                                        internalAccessories.isFour_in_one_sensor ||
                                        false

                                    if (
                                        is4in1SensorConnected &&
                                        (key == 'D1' || key == 'D2')
                                    )
                                        return

                                    const isSmile1 =
                                        internalAccessories.isSmileOne || false
                                    const isSmile2 =
                                        internalAccessories.isSmileTwo || false
                                    const isSmile3 =
                                        internalAccessories.isSmileThree ||
                                        false
                                    const isSmile4 =
                                        internalAccessories.isSmileFour || false
                                    if (
                                        (this.props.shield ||
                                            this.props.peeCeeATR) &&
                                        key === 'M1' &&
                                        (isSmile1 || isSmile2)
                                    )
                                        return false
                                    if (
                                        (this.props.shield ||
                                            this.props.peeCeeATR) &&
                                        key === 'M3' &&
                                        (isSmile3 || isSmile4)
                                    )
                                        return false

                                    if (
                                        this.props.armShield &&
                                        key === 'MOTOR1' &&
                                        (isSmile2 || isSmile3)
                                    )
                                        return false
                                    if (this.props.armShield && key === 'F')
                                        return false

                                    if (key === 'SS' && (isSmile1 || isSmile4))
                                        return false

                                    const isTouch0 =
                                        internalAccessories.isTouchZero ||
                                        internalAccessories.isTouchZeroOutput ||
                                        false
                                    const isTouch1 =
                                        internalAccessories.isTouchOne ||
                                        internalAccessories.isTouchOneOutput ||
                                        false
                                    const isTouch2 =
                                        internalAccessories.isTouchTwo ||
                                        internalAccessories.isTouchTwoOutput ||
                                        false

                                    const isA1 = portConnections['A1']
                                        ? true
                                        : false
                                    const isA2 = portConnections['A2']
                                        ? true
                                        : false
                                    const isB1 = portConnections['B1']
                                        ? true
                                        : false
                                    const isC1 = portConnections['C1']
                                        ? true
                                        : false
                                    const isC2 = portConnections['C2']
                                        ? true
                                        : false

                                    const isP0 = portConnections['P0']
                                        ? true
                                        : false
                                    const isP1 = portConnections['P1']
                                        ? true
                                        : false
                                    const isP2 = portConnections['P2']
                                        ? true
                                        : false
                                    const isF1 = portConnections['F1']
                                        ? true
                                        : false
                                    const isF2 = portConnections['F2']
                                        ? true
                                        : false

                                    const isS1 = portConnections['S1']
                                        ? true
                                        : false
                                    const isS2 = portConnections['S2']
                                        ? true
                                        : false

                                    if (this.props.peeCeeATR) {
                                        if (
                                            key === 'M1' &&
                                            (isSmile1 || isSmile2)
                                        )
                                            return false
                                        else if (
                                            key === 'M2' &&
                                            (isSmile3 || isSmile4)
                                        )
                                            return false
                                        // else if (
                                        //     (key == 'S1' || key == 'A1') &&
                                        //     (isA1 || isS1)
                                        // )
                                        //     return false
                                        // else if (
                                        //     (key == 'S2' || key == 'C1') &&
                                        //     (isC1 || isS2)
                                        // )
                                        //     return false
                                    }

                                    if (
                                        (key === 'A1' || key === 'P0') &&
                                        (isTouch0 || isA1 || isP0)
                                    )
                                        return false
                                    if (
                                        (key === 'B1' || key === 'P1') &&
                                        (isTouch1 || isB1 || isP1)
                                    )
                                        return false
                                    if (
                                        (key === 'C1' || key === 'P2') &&
                                        (isTouch2 || isC1 || isP2)
                                    )
                                        return false

                                    if (draggingItem !== 'dual_splitter') {
                                        if (key === 'A' && isTouch0)
                                            return false
                                        if (key === 'B' && isTouch1)
                                            return false
                                        if (key === 'C' && isTouch2)
                                            return false
                                    }
                                }

                                return (
                                    <g
                                        key={key}
                                        stroke="white"
                                        strokeWidth="2"
                                        fill={
                                            PortTypes[
                                                `${connectedDevice.toUpperCase()}`
                                            ][key].color
                                        }
                                    >
                                        {PortTypes[
                                            `${connectedDevice.toUpperCase()}`
                                        ][key].ports.map(
                                            (port) => (
                                                <>
                                                    <PortCircle
                                                        style={{
                                                            visibility:
                                                                'hidden',
                                                        }}
                                                        left={
                                                            Left +
                                                            Ports(port)[0]
                                                        }
                                                        top={
                                                            getTopValueRedCircle(
                                                                port,
                                                                Top,
                                                                Ports,
                                                                draggingItem
                                                            )
                                                            // Top +
                                                            // Ports(port)[1]
                                                        }
                                                        key={port}
                                                        highlighted={
                                                            (!highlightPort ||
                                                                highlightPort ===
                                                                    port) &&
                                                            this.getPortHighlightStatus(
                                                                {
                                                                    port,
                                                                    PortConnections,
                                                                    highlighted,
                                                                    connectedDevice,
                                                                }
                                                            )
                                                        }
                                                        isFinalSlide={
                                                            this.props
                                                                .isFinalSlide
                                                        }
                                                        // highlighted={
                                                        //     (!highlightPort || highlightPort === port) && (
                                                        //     PortConnections[
                                                        //         port
                                                        //     ] == null
                                                        //         ? !PortConnections[
                                                        //               port
                                                        //           ] &&
                                                        //           highlighted
                                                        //         : sessionStorage.getItem(
                                                        //               'dragingItem'
                                                        //           ) !=
                                                        //           'pc_motor_driver'
                                                        //         ? PortConnections[
                                                        //               port
                                                        //           ]
                                                        //               .notDriverMotot ==
                                                        //           'notConnectedDriverMotor'
                                                        //             ? true &&
                                                        //               highlighted
                                                        //             : !PortConnections[
                                                        //                   port
                                                        //               ] &&
                                                        //               highlighted
                                                        //         : !PortConnections[
                                                        //               port
                                                        //           ] &&
                                                        //           highlighted
                                                        //     )
                                                        // }
                                                        PortConnections={
                                                            PortConnections
                                                        }
                                                        portName={key}
                                                        forceHighlight={
                                                            highlightPort ===
                                                            port
                                                        }
                                                    />
                                                </>
                                            )

                                            //It highlight only those whih are
                                        )}
                                    </g>
                                )
                            }
                        })}
                    </g>
                </svg>
            </div>
        )
    }
}

export default Connections
